"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3172],{

/***/ 16087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77058);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9465);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);









var HeaderSearch = function HeaderSearch(_ref) {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2, _process$env$NEXT_PUB3, _process$env$NEXT_PUB4, _process$env$NEXT_PUB5, _process$env$NEXT_PUB6, _process$env$NEXT_PUB7, _process$env$NEXT_PUB8, _process$env$NEXT_PUB9, _process$env$NEXT_PUB10, _process$env$NEXT_PUB11, _process$env$NEXT_PUB12, _process$env$NEXT_PUB13, _process$env$NEXT_PUB14, _process$env$NEXT_PUB15, _process$env$NEXT_PUB16, _process$env$NEXT_PUB17, _process$env$NEXT_PUB18, _process$env$NEXT_PUB19, _process$env$NEXT_PUB20, _process$env$NEXT_PUB21, _process$env$NEXT_PUB22, _process$env$NEXT_PUB23, _process$env$NEXT_PUB24, _process$env$NEXT_PUB25, _process$env$NEXT_PUB26, _process$env$NEXT_PUB27, _process$env$NEXT_PUB28, _process$env$NEXT_PUB29, _process$env$NEXT_PUB30, _process$env$NEXT_PUB31, _process$env$NEXT_PUB32, _process$env$NEXT_PUB33, _process$env$NEXT_PUB34, _process$env$NEXT_PUB35;

  var defaultValue = _ref.defaultValue,
      onPress = _ref.onPress;

  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  var category = router.query.category;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultValue || ""),
      keywordSearch = _useState[0],
      setKeywordSearch = _useState[1];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
    className: "sm:block hidden ".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("header", true)),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: "wrapper mx-auto py-3",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("form", {
        action: onPress ? "" : "/explore/".concat(category || ((_process$env$NEXT_PUB = "Rooftops".split(",")[0]) === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.toLowerCase()) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : (_process$env$NEXT_PUB3 = _process$env$NEXT_PUB2.replace("venue cocktail", "bars")) === null || _process$env$NEXT_PUB3 === void 0 ? void 0 : (_process$env$NEXT_PUB4 = _process$env$NEXT_PUB3.replace("venue beachful", "beach-clubs")) === null || _process$env$NEXT_PUB4 === void 0 ? void 0 : (_process$env$NEXT_PUB5 = _process$env$NEXT_PUB4.replace("prefab company", "companies")) === null || _process$env$NEXT_PUB5 === void 0 ? void 0 : _process$env$NEXT_PUB5.replace("prefab home", "homes"))),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
          className: "flex flex-row items-center justify-between",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
            className: "flex flex-row items-center",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
              className: "mr-6",
              style: {
                height: 40
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                    src: "/images/".concat( true ? ((_process$env$NEXT_PUB6 = "RooftopClub") === null || _process$env$NEXT_PUB6 === void 0 ? void 0 : (_process$env$NEXT_PUB7 = _process$env$NEXT_PUB6.replace(" ", "")) === null || _process$env$NEXT_PUB7 === void 0 ? void 0 : _process$env$NEXT_PUB7.toLowerCase()) + "/" : 0, "home.svg"),
                    width: 40,
                    height: 40,
                    alt: "".concat("RooftopClub", " home")
                  })
                })
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
              className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("bg-input", true), " rounded-full flex flex-row items-center justify-between pl-8 h-10 w-480px"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("input", {
                name: "search",
                type: "search",
                className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("bg-input", true), " font-regular text-base ").concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("text-white", true), " ").concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("placeholder-input"), " outline-0 w-335px"),
                "aria-label": "Search ".concat((_process$env$NEXT_PUB8 = "Rooftops".split(",").join(" | ")) === null || _process$env$NEXT_PUB8 === void 0 ? void 0 : (_process$env$NEXT_PUB9 = _process$env$NEXT_PUB8.replace("Festivals", "Festival")) === null || _process$env$NEXT_PUB9 === void 0 ? void 0 : (_process$env$NEXT_PUB10 = _process$env$NEXT_PUB9.replace("Artists", "Artist")) === null || _process$env$NEXT_PUB10 === void 0 ? void 0 : (_process$env$NEXT_PUB11 = _process$env$NEXT_PUB10.replace("Venues", "Venue")) === null || _process$env$NEXT_PUB11 === void 0 ? void 0 : (_process$env$NEXT_PUB12 = _process$env$NEXT_PUB11.replace("Rooftops", "Rooftop")) === null || _process$env$NEXT_PUB12 === void 0 ? void 0 : (_process$env$NEXT_PUB13 = _process$env$NEXT_PUB12.replace("Spas", "Spa")) === null || _process$env$NEXT_PUB13 === void 0 ? void 0 : (_process$env$NEXT_PUB14 = _process$env$NEXT_PUB13.replace("Venue Cocktail", "Bar")) === null || _process$env$NEXT_PUB14 === void 0 ? void 0 : (_process$env$NEXT_PUB15 = _process$env$NEXT_PUB14.replace("Venue Beachful", "Beach Club")) === null || _process$env$NEXT_PUB15 === void 0 ? void 0 : (_process$env$NEXT_PUB16 = _process$env$NEXT_PUB15.replace("Prefab Company", "Company")) === null || _process$env$NEXT_PUB16 === void 0 ? void 0 : (_process$env$NEXT_PUB17 = _process$env$NEXT_PUB16.replace("Prefab Home", "Home")) === null || _process$env$NEXT_PUB17 === void 0 ? void 0 : (_process$env$NEXT_PUB18 = _process$env$NEXT_PUB17.replace("Parks", "Park")) === null || _process$env$NEXT_PUB18 === void 0 ? void 0 : (_process$env$NEXT_PUB19 = _process$env$NEXT_PUB18.replace("Casinos", "Casino")) === null || _process$env$NEXT_PUB19 === void 0 ? void 0 : (_process$env$NEXT_PUB20 = _process$env$NEXT_PUB19.replace("Castles", "Castle")) === null || _process$env$NEXT_PUB20 === void 0 ? void 0 : (_process$env$NEXT_PUB21 = _process$env$NEXT_PUB20.replace("Resorts", "Resort")) === null || _process$env$NEXT_PUB21 === void 0 ? void 0 : _process$env$NEXT_PUB21.replace("Aparthotels", "Aparthotel")),
                placeholder: (_process$env$NEXT_PUB22 = "Rooftops".split(",").join(" | ")) === null || _process$env$NEXT_PUB22 === void 0 ? void 0 : (_process$env$NEXT_PUB23 = _process$env$NEXT_PUB22.replace("Festivals", "Festival")) === null || _process$env$NEXT_PUB23 === void 0 ? void 0 : (_process$env$NEXT_PUB24 = _process$env$NEXT_PUB23.replace("Artists", "Artist")) === null || _process$env$NEXT_PUB24 === void 0 ? void 0 : (_process$env$NEXT_PUB25 = _process$env$NEXT_PUB24.replace("Venues", "Venue")) === null || _process$env$NEXT_PUB25 === void 0 ? void 0 : (_process$env$NEXT_PUB26 = _process$env$NEXT_PUB25.replace("Rooftops", "Rooftop")) === null || _process$env$NEXT_PUB26 === void 0 ? void 0 : (_process$env$NEXT_PUB27 = _process$env$NEXT_PUB26.replace("Spas", "Spa")) === null || _process$env$NEXT_PUB27 === void 0 ? void 0 : (_process$env$NEXT_PUB28 = _process$env$NEXT_PUB27.replace("Venue Cocktail", "Bar")) === null || _process$env$NEXT_PUB28 === void 0 ? void 0 : (_process$env$NEXT_PUB29 = _process$env$NEXT_PUB28.replace("Venue Beachful", "Beach Club")) === null || _process$env$NEXT_PUB29 === void 0 ? void 0 : (_process$env$NEXT_PUB30 = _process$env$NEXT_PUB29.replace("Prefab Company", "Company")) === null || _process$env$NEXT_PUB30 === void 0 ? void 0 : (_process$env$NEXT_PUB31 = _process$env$NEXT_PUB30.replace("Prefab Home", "Home")) === null || _process$env$NEXT_PUB31 === void 0 ? void 0 : (_process$env$NEXT_PUB32 = _process$env$NEXT_PUB31.replace("Parks", "Park")) === null || _process$env$NEXT_PUB32 === void 0 ? void 0 : (_process$env$NEXT_PUB33 = _process$env$NEXT_PUB32.replace("Casinos", "Casino")) === null || _process$env$NEXT_PUB33 === void 0 ? void 0 : (_process$env$NEXT_PUB34 = _process$env$NEXT_PUB33.replace("Castles", "Castle")) === null || _process$env$NEXT_PUB34 === void 0 ? void 0 : (_process$env$NEXT_PUB35 = _process$env$NEXT_PUB34.replace("Resorts", "Resort")) === null || _process$env$NEXT_PUB35 === void 0 ? void 0 : _process$env$NEXT_PUB35.replace("Aparthotels", "Aparthotel"),
                value: keywordSearch,
                onChange: function onChange(e) {
                  return setKeywordSearch(e.target.value);
                },
                onKeyDown: function onKeyDown(e) {
                  var _process$env$NEXT_PUB36, _process$env$NEXT_PUB37, _process$env$NEXT_PUB38, _process$env$NEXT_PUB39, _process$env$NEXT_PUB40;

                  return e.key === "Enter" ? onPress ? onPress(keywordSearch) : router.push("/explore/".concat((_process$env$NEXT_PUB36 = "Rooftops".split(",")[0]) === null || _process$env$NEXT_PUB36 === void 0 ? void 0 : (_process$env$NEXT_PUB37 = _process$env$NEXT_PUB36.toLowerCase()) === null || _process$env$NEXT_PUB37 === void 0 ? void 0 : (_process$env$NEXT_PUB38 = _process$env$NEXT_PUB37.replace("venue cocktail", "bars")) === null || _process$env$NEXT_PUB38 === void 0 ? void 0 : (_process$env$NEXT_PUB39 = _process$env$NEXT_PUB38.replace("venue beachful", "beach-clubs")) === null || _process$env$NEXT_PUB39 === void 0 ? void 0 : (_process$env$NEXT_PUB40 = _process$env$NEXT_PUB39.replace("prefab company", "companies")) === null || _process$env$NEXT_PUB40 === void 0 ? void 0 : _process$env$NEXT_PUB40.replace("prefab home", "homes"), "?search=").concat(keywordSearch)) : null;
                }
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("button", {
                type: "submit",
                className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("btn-gradient"), " flex justify-center items-center h-10 w-80px -mr-1 rounded-full cursor-pointer"),
                onClick: function onClick() {
                  var _process$env$NEXT_PUB41;

                  return onPress ? onPress(keywordSearch) : router.push("/explore/".concat(category || ((_process$env$NEXT_PUB41 = "Rooftops".split(",")[0]) === null || _process$env$NEXT_PUB41 === void 0 ? void 0 : _process$env$NEXT_PUB41.toLowerCase()), "?search=").concat(keywordSearch));
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                  src: "/icons/ic_search.svg",
                  width: 20,
                  height: 20,
                  alt: "search"
                })
              })]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: "flex flex-row items-center",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
              href: "/guides",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
                className: "".concat((0,_src_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_4__/* .getClass */ .ll)("btn-gradient"), " flex justify-center items-center w-150px h-40px rounded-full uppercase cursor-pointer"),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
                  className: "text-white text-base font-bold",
                  children: "Guides"
                })
              })
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (HeaderSearch);

/***/ }),

/***/ 580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54176);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28908);
/* harmony import */ var react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48409);
/* harmony import */ var react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77058);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9465);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);












var FilterView = function FilterView(props) {
  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion,
      isChartsMode = props.isChartsMode;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_6___default()), {
    style: styles.container,
    children: [!isChartsMode && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_7___default()), {
      style: styles.item,
      activeOpacity: 1,
      onPress: function onPress() {
        return (// props.dataCategory === Constants.categoryType.CATEGORY_ARTIST
          //   ? null
          //   :
          props.onPressLocation()
        );
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        width: 16,
        height: 16 // style={
        //   props.dataCategory === Constants.categoryType.CATEGORY_ARTIST
        //     ? { opacity: 0.7 }
        //     : {}
        // }
        ,
        src: _config__WEBPACK_IMPORTED_MODULE_1__/* .Images.iconLocationPin */ .rU.iconLocationPin,
        alt: "icon location"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_8___default()), {
        style: [[styles.label, isMobileVersion ? {
          fontSize: 12,
          lineHeight: 18
        } : {}] // props.dataCategory === Constants.categoryType.CATEGORY_ARTIST
        //   ? { opacity: 0.7 }
        //   : {},
        ],
        children: t("key_location")
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_7___default()), {
      style: styles.item,
      activeOpacity: 1,
      onPress: props.onPressFilter,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        width: 16,
        height: 16,
        src: _config__WEBPACK_IMPORTED_MODULE_1__/* .Images.iconFilterColored */ .rU.iconFilterColored,
        alt: "icon filter"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_8___default()), {
        style: [styles.label, isMobileVersion ? {
          fontSize: 12,
          lineHeight: 18
        } : {}],
        children: t("key_filter")
      }), props.isFiltered && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_7___default()), {
        style: styles.dot
      })]
    }), !isChartsMode && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)((react_native_web_dist_cjs_exports_TouchableOpacity__WEBPACK_IMPORTED_MODULE_7___default()), {
      style: [styles.item, {
        borderRightWidth: 0
      }],
      activeOpacity: 1,
      onPress: props.onPressSort,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        width: 16,
        height: 16,
        src: _config__WEBPACK_IMPORTED_MODULE_1__/* .Images.iconSortColored */ .rU.iconSortColored,
        alt: "icon sort"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_native_web_dist_cjs_exports_Text__WEBPACK_IMPORTED_MODULE_8___default()), {
        style: [styles.label, isMobileVersion ? {
          fontSize: 12,
          lineHeight: 18
        } : {}],
        children: t("key_sort")
      })]
    })]
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_9___default().create({
  container: {
    borderTopWidth: 1,
    borderTopColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getClass */ .ll)("bg-black2"),
    borderBottomWidth: 1,
    borderBottomColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getClass */ .ll)("bg-black2"),
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
  },
  item: {
    borderRightWidth: 1,
    borderRightColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getClass */ .ll)("bg-black2"),
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 10
  },
  icon: {
    width: 12,
    height: 12
  },
  label: {
    color: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getClass */ .ll)("text-black3"),
    fontSize: 14,
    lineHeight: 18,
    marginLeft: 6,
    fontFamily: _config__WEBPACK_IMPORTED_MODULE_1__/* .Fonts.primaryMedium */ .F3.primaryMedium
  },
  dot: {
    backgroundColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_3__/* .getClass */ .ll)("text-white"),
    borderRadius: 100,
    width: 4,
    height: 4,
    marginLeft: 6
  }
});
/* harmony default export */ __webpack_exports__["Z"] = (FilterView);

/***/ }),

/***/ 48306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ explore_search; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/config/index.js + 8 modules
var config = __webpack_require__(54176);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__(79057);
var View_default = /*#__PURE__*/__webpack_require__.n(View);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(77058);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 38 modules
var atoms = __webpack_require__(52738);
// EXTERNAL MODULE: ./src/DAO/index.js + 12 modules
var DAO = __webpack_require__(90793);
// EXTERNAL MODULE: ./src/components/molecules/index.js + 37 modules
var molecules = __webpack_require__(53732);
// EXTERNAL MODULE: ./node_modules/lodash/range.js
var range = __webpack_require__(96026);
var range_default = /*#__PURE__*/__webpack_require__.n(range);
// EXTERNAL MODULE: ./node_modules/lodash/reverse.js
var reverse = __webpack_require__(31351);
var reverse_default = /*#__PURE__*/__webpack_require__.n(reverse);
// EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(45578);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ActivityIndicator/index.js
var ActivityIndicator = __webpack_require__(89009);
var ActivityIndicator_default = /*#__PURE__*/__webpack_require__.n(ActivityIndicator);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Dimensions/index.js
var Dimensions = __webpack_require__(13256);
var Dimensions_default = /*#__PURE__*/__webpack_require__.n(Dimensions);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/TouchableOpacity/index.js
var TouchableOpacity = __webpack_require__(28908);
var TouchableOpacity_default = /*#__PURE__*/__webpack_require__.n(TouchableOpacity);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Text/index.js
var Text = __webpack_require__(48409);
var Text_default = /*#__PURE__*/__webpack_require__.n(Text);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/modules/home/components/SectionTitleView.js











var SectionTitleView = function SectionTitleView(props) {
  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var onViewAll = function onViewAll() {
    if (props.onViewAll) {
      props.onViewAll();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [styles.titleSection, props.style],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
      style: styles.title,
      children: props.title
    }), props.hasViewAll && /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
      onPress: onViewAll,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: styles.viewAllBtn,
        children: t("key_view_all")
      })
    })]
  });
};

var styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch"
  },
  titleSection: {
    flexDirection: "row",
    alignSelf: "stretch",
    alignItems: "center",
    paddingHorizontal: 16,
    justifyContent: "space-between",
    marginBottom: 10
  },
  title: {
    fontSize: 20,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: config/* Colors.white */.wL.white,
    textTransform: "uppercase"
  },
  viewAllBtn: {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: config/* Colors.white */.wL.white
  }
});
/* harmony default export */ var components_SectionTitleView = (SectionTitleView);
;// CONCATENATED MODULE: ./src/modules/home/containers/PopularListSectionContainer.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var _Dimensions$get = Dimensions_default().get("window"),
    widthScreen = _Dimensions$get.width;

var PopularListSectionContainer = function PopularListSectionContainer(props) {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2, _process$env$NEXT_PUB3, _process$env$NEXT_PUB4;

  var flatListRef = (0,react.useRef)(null);
  var page = 0;

  var _useState = (0,react.useState)([]),
      items = _useState[0],
      setItems = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isChartsMode = props.isChartsMode;

  var loadItems = function loadItems(category) {
    setIsLoading(true);

    if (category === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE) {
      DAO/* VenueDao.find */.eL.find(_objectSpread(_objectSpread({}, props.paramsVenue), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP) {
      DAO/* VenueDao.find */.eL.find(_objectSpread(_objectSpread({}, props.paramsRooftop), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA) {
      DAO/* VenueDao.find */.eL.find(_objectSpread(_objectSpread({}, props.paramsSpa), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL) {
      DAO/* VenueDao.find */.eL.find(_objectSpread(_objectSpread({}, props.paramsVenueBeachful), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY) {
      DAO/* VenueDao.find */.eL.find(_objectSpread(_objectSpread({}, props.paramsPrefabCompany), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES) {
      DAO/* VenueDao.find */.eL.find(_objectSpread(_objectSpread({}, props.paramsPrefabHome), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO) {
      DAO/* VenueDao.find */.eL.find(_objectSpread(_objectSpread({}, props.paramsZoo), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL) {
      DAO/* VenueDao.find */.eL.find(_objectSpread(_objectSpread({}, props.paramsAnimal), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL) {
      DAO/* VenueDao.find */.eL.find(_objectSpread(_objectSpread({}, props.paramsParkful), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO) {
      DAO/* VenueDao.find */.eL.find(_objectSpread(_objectSpread({}, props.paramsCasino), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE) {
      DAO/* VenueDao.find */.eL.find(_objectSpread(_objectSpread({}, props.paramsCastle), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT) {
      DAO/* VenueDao.find */.eL.find(_objectSpread(_objectSpread({}, props.paramsResort), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL) {
      DAO/* VenueDao.find */.eL.find(_objectSpread(_objectSpread({}, props.paramsAparthotel), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL) {
      DAO/* VenueDao.find */.eL.find(_objectSpread(_objectSpread({}, props.paramsVenueCocktail), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT) {
      DAO/* EventDao.findWeb */.SA.findWeb(_objectSpread(_objectSpread({}, props.paramsEvent), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY,
        dateSortType: config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL) {
      DAO/* FestivalDao.findWeb */.vB.findWeb(_objectSpread(_objectSpread({}, props.paramsFestival), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY,
        dateSortType: config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST) {
      DAO/* ArtistDao.findWeb */.uf.findWeb(_objectSpread(_objectSpread({}, props.paramsArtist), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else {
      setIsLoading(false);
      setItems([]);
    }
  };

  (0,react.useEffect)(function () {
    loadItems(props.category);
  }, [props.category, JSON.stringify(props.locationSelected), props.filterCriteriaListOriginalFestival, props.filterCriteriaListOriginalEvent, props.filterCriteriaListOriginalArtist, props.filterCriteriaListOriginalVenue, props.filterCriteriaListOriginalRooftop, props.filterCriteriaListOriginalSpa, props.filterCriteriaListOriginalVenueBeachful, props.filterCriteriaListOriginalVenueCocktail]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [PopularListSectionContainer_styles.container, props.style],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_SectionTitleView, {
      title: t("key_popular")
    }), isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)((ActivityIndicator_default()), {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
      ref: flatListRef,
      horizontal: true,
      items: items,
      category: props.category,
      style: {
        marginLeft: 16,
        marginTop: 16,
        overflow: "hidden"
      },
      isChartsMode: isChartsMode // onItemAction={onItemAction}

    }), items.length > (widthScreen < 1536 ? 3 : 4) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "w-full flex flex-row justify-between max-w-198px mx-auto -mt-2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "cursor-pointer",
        onClick: function onClick() {
          var _flatListRef$current;

          if (page - 1 >= 0) {
            page--;
          }

          var newIndex = page * (widthScreen < 1536 ? 3 : 4);
          flatListRef === null || flatListRef === void 0 ? void 0 : (_flatListRef$current = flatListRef.current) === null || _flatListRef$current === void 0 ? void 0 : _flatListRef$current.scrollToIndex({
            animated: true,
            index: newIndex
          });
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "/icons/".concat( true ? ((_process$env$NEXT_PUB = "RooftopClub") === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.replace(" ", "")) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : _process$env$NEXT_PUB2.toLowerCase()) + "/" : 0, "ic_arrow_left.png"),
          width: "40",
          height: "40",
          alt: "arrow"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "cursor-pointer",
        onClick: function onClick() {
          var _flatListRef$current2;

          if (page + 1 < Math.round(items.length / (widthScreen < 1536 ? 3 : 4))) {
            page++;
          }

          var newIndex = page * (widthScreen < 1536 ? 3 : 4);
          flatListRef === null || flatListRef === void 0 ? void 0 : (_flatListRef$current2 = flatListRef.current) === null || _flatListRef$current2 === void 0 ? void 0 : _flatListRef$current2.scrollToIndex({
            animated: true,
            index: newIndex
          });
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "/icons/".concat( true ? ((_process$env$NEXT_PUB3 = "RooftopClub") === null || _process$env$NEXT_PUB3 === void 0 ? void 0 : (_process$env$NEXT_PUB4 = _process$env$NEXT_PUB3.replace(" ", "")) === null || _process$env$NEXT_PUB4 === void 0 ? void 0 : _process$env$NEXT_PUB4.toLowerCase()) + "/" : 0, "ic_arrow_right.png"),
          width: "40",
          height: "40",
          alt: "arrow"
        })
      })]
    })]
  });
};

var PopularListSectionContainer_styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    overflow: "hidden",
    width: "100%"
  },
  titleSection: {
    flexDirection: "row",
    alignSelf: "stretch",
    alignItems: "center"
  },
  title: {
    fontSize: 16,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold
  },
  viewAllBtn: {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular
  }
});
/* harmony default export */ var containers_PopularListSectionContainer = (PopularListSectionContainer);
;// CONCATENATED MODULE: ./src/modules/home/containers/TrendingListSectionContainer.js


function TrendingListSectionContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TrendingListSectionContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TrendingListSectionContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TrendingListSectionContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var TrendingListSectionContainer_Dimensions$get = Dimensions_default().get("window"),
    TrendingListSectionContainer_widthScreen = TrendingListSectionContainer_Dimensions$get.width;

var TrendingListSectionContainer = function TrendingListSectionContainer(props) {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2, _process$env$NEXT_PUB3, _process$env$NEXT_PUB4;

  var flatListRef = (0,react.useRef)(null);
  var page = 0;

  var _useState = (0,react.useState)([]),
      items = _useState[0],
      setItems = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isChartsMode = props.isChartsMode;

  var onViewAll = function onViewAll() {};

  var loadItems = function loadItems(category) {
    setIsLoading(true);

    if (category === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE) {
      DAO/* VenueDao.find */.eL.find(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsVenue), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP) {
      DAO/* VenueDao.find */.eL.find(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsRooftop), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA) {
      DAO/* VenueDao.find */.eL.find(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsSpa), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL) {
      DAO/* VenueDao.find */.eL.find(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsVenueBeachful), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY) {
      DAO/* VenueDao.find */.eL.find(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsPrefabCompany), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES) {
      DAO/* VenueDao.find */.eL.find(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsPrefabHome), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO) {
      DAO/* VenueDao.find */.eL.find(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsZoo), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL) {
      DAO/* VenueDao.find */.eL.find(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsAnimal), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL) {
      DAO/* VenueDao.find */.eL.find(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsParkful), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO) {
      DAO/* VenueDao.find */.eL.find(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsCasino), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE) {
      DAO/* VenueDao.find */.eL.find(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsCastle), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT) {
      DAO/* VenueDao.find */.eL.find(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsResort), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL) {
      DAO/* VenueDao.find */.eL.find(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsAparthotel), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL) {
      DAO/* VenueDao.find */.eL.find(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsVenueCocktail), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category == config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT) {
      DAO/* EventDao.findWeb */.SA.findWeb(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsEvent), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING,
        dateSortType: config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING,
        startDateFrom: moment_default()().format("YYYY-MM-DD"),
        startDateTo: moment_default()().add(1, "month").format("YYYY-MM-DD")
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL) {
      DAO/* FestivalDao.findWeb */.vB.findWeb(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsFestival), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING,
        dateSortType: config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING,
        startDateFrom: moment_default()().format("YYYY-MM-DD"),
        startDateTo: moment_default()().add(1, "month").format("YYYY-MM-DD")
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST) {
      DAO/* ArtistDao.findWeb */.uf.findWeb(TrendingListSectionContainer_objectSpread(TrendingListSectionContainer_objectSpread({}, props.paramsArtist), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING,
        startDateFrom: moment_default()().format("YYYY-MM-DD"),
        startDateTo: moment_default()().add(1, "month").format("YYYY-MM-DD")
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else {
      setIsLoading(false);
      setItems([]);
    }
  };

  (0,react.useEffect)(function () {
    loadItems(props.category);
  }, [props.category, JSON.stringify(props.locationSelected), props.filterCriteriaListOriginalFestival, props.filterCriteriaListOriginalEvent, props.filterCriteriaListOriginalArtist, props.filterCriteriaListOriginalVenue, props.filterCriteriaListOriginalRooftop, props.filterCriteriaListOriginalSpa, props.filterCriteriaListOriginalVenueBeachful, props.filterCriteriaListOriginalVenueCocktail]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [TrendingListSectionContainer_styles.container, props.style],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_SectionTitleView, {
      title: t("key_trending"),
      onViewAll: onViewAll
    }), isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)((ActivityIndicator_default()), {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
      ref: flatListRef,
      category: props.category,
      horizontal: true,
      items: items,
      style: {
        marginLeft: 16,
        marginTop: 16
      },
      isChartsMode: isChartsMode // onItemAction={onItemAction}

    }), items.length > (TrendingListSectionContainer_widthScreen < 1536 ? 3 : 4) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "w-full flex flex-row justify-between max-w-198px mx-auto -mt-2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "cursor-pointer",
        onClick: function onClick() {
          var _flatListRef$current;

          if (page - 1 >= 0) {
            page--;
          }

          var newIndex = page * (TrendingListSectionContainer_widthScreen < 1536 ? 3 : 4);
          flatListRef === null || flatListRef === void 0 ? void 0 : (_flatListRef$current = flatListRef.current) === null || _flatListRef$current === void 0 ? void 0 : _flatListRef$current.scrollToIndex({
            animated: true,
            index: newIndex
          });
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "/icons/".concat( true ? ((_process$env$NEXT_PUB = "RooftopClub") === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.replace(" ", "")) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : _process$env$NEXT_PUB2.toLowerCase()) + "/" : 0, "ic_arrow_left.png"),
          width: "40",
          height: "40",
          alt: "arrow"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "cursor-pointer",
        onClick: function onClick() {
          var _flatListRef$current2;

          if (page + 1 < Math.round(items.length / (TrendingListSectionContainer_widthScreen < 1536 ? 3 : 4))) {
            page++;
          }

          var newIndex = page * (TrendingListSectionContainer_widthScreen < 1536 ? 3 : 4);
          flatListRef === null || flatListRef === void 0 ? void 0 : (_flatListRef$current2 = flatListRef.current) === null || _flatListRef$current2 === void 0 ? void 0 : _flatListRef$current2.scrollToIndex({
            animated: true,
            index: newIndex
          });
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "/icons/".concat( true ? ((_process$env$NEXT_PUB3 = "RooftopClub") === null || _process$env$NEXT_PUB3 === void 0 ? void 0 : (_process$env$NEXT_PUB4 = _process$env$NEXT_PUB3.replace(" ", "")) === null || _process$env$NEXT_PUB4 === void 0 ? void 0 : _process$env$NEXT_PUB4.toLowerCase()) + "/" : 0, "ic_arrow_right.png"),
          width: "40",
          height: "40",
          alt: "arrow"
        })
      })]
    })]
  });
};

var TrendingListSectionContainer_styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    overflow: "hidden",
    width: "100%"
  },
  titleSection: {
    flexDirection: "row",
    alignSelf: "stretch",
    alignItems: "center"
  },
  title: {
    fontSize: 16,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold
  },
  viewAllBtn: {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular
  }
});
/* harmony default export */ var containers_TrendingListSectionContainer = (TrendingListSectionContainer);
;// CONCATENATED MODULE: ./src/modules/home/containers/RecommendedListSectionContainer.js


function RecommendedListSectionContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function RecommendedListSectionContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? RecommendedListSectionContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : RecommendedListSectionContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var RecommendedListSectionContainer_Dimensions$get = Dimensions_default().get("window"),
    RecommendedListSectionContainer_widthScreen = RecommendedListSectionContainer_Dimensions$get.width;

var RecommendedListSectionContainer = function RecommendedListSectionContainer(props) {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2, _process$env$NEXT_PUB3, _process$env$NEXT_PUB4;

  var flatListRef = (0,react.useRef)(null);
  var page = 0;

  var _useState = (0,react.useState)([]),
      items = _useState[0],
      setItems = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isChartsMode = props.isChartsMode;

  var loadItems = function loadItems(category) {
    setIsLoading(true);

    if (category === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE) {
      DAO/* VenueDao.find */.eL.find(RecommendedListSectionContainer_objectSpread(RecommendedListSectionContainer_objectSpread({}, props.paramsVenue), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP) {
      DAO/* VenueDao.find */.eL.find(RecommendedListSectionContainer_objectSpread(RecommendedListSectionContainer_objectSpread({}, props.paramsRooftop), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA) {
      DAO/* VenueDao.find */.eL.find(RecommendedListSectionContainer_objectSpread(RecommendedListSectionContainer_objectSpread({}, props.paramsSpa), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL) {
      DAO/* VenueDao.find */.eL.find(RecommendedListSectionContainer_objectSpread(RecommendedListSectionContainer_objectSpread({}, props.paramsVenueBeachful), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY) {
      DAO/* VenueDao.find */.eL.find(RecommendedListSectionContainer_objectSpread(RecommendedListSectionContainer_objectSpread({}, props.paramsPrefabCompany), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES) {
      DAO/* VenueDao.find */.eL.find(RecommendedListSectionContainer_objectSpread(RecommendedListSectionContainer_objectSpread({}, props.paramsPrefabHome), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO) {
      DAO/* VenueDao.find */.eL.find(RecommendedListSectionContainer_objectSpread(RecommendedListSectionContainer_objectSpread({}, props.paramsZoo), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL) {
      DAO/* VenueDao.find */.eL.find(RecommendedListSectionContainer_objectSpread(RecommendedListSectionContainer_objectSpread({}, props.paramsAnimal), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL) {
      DAO/* VenueDao.find */.eL.find(RecommendedListSectionContainer_objectSpread(RecommendedListSectionContainer_objectSpread({}, props.paramsParkful), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO) {
      DAO/* VenueDao.find */.eL.find(RecommendedListSectionContainer_objectSpread(RecommendedListSectionContainer_objectSpread({}, props.paramsCasino), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE) {
      DAO/* VenueDao.find */.eL.find(RecommendedListSectionContainer_objectSpread(RecommendedListSectionContainer_objectSpread({}, props.paramsCastle), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT) {
      DAO/* VenueDao.find */.eL.find(RecommendedListSectionContainer_objectSpread(RecommendedListSectionContainer_objectSpread({}, props.paramsResort), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL) {
      DAO/* VenueDao.find */.eL.find(RecommendedListSectionContainer_objectSpread(RecommendedListSectionContainer_objectSpread({}, props.paramsAparthotel), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL) {
      DAO/* VenueDao.find */.eL.find(RecommendedListSectionContainer_objectSpread(RecommendedListSectionContainer_objectSpread({}, props.paramsVenueCocktail), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT) {
      var _props$locationSelect, _props$locationSelect2, _props$locationSelect3;

      DAO/* EventDao.findWeb */.SA.findWeb({
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED,
        countryId: (_props$locationSelect = props.locationSelected) !== null && _props$locationSelect !== void 0 && _props$locationSelect.country_id ? [(_props$locationSelect2 = props.locationSelected) === null || _props$locationSelect2 === void 0 ? void 0 : _props$locationSelect2.country_id] : null,
        cityId: (_props$locationSelect3 = props.locationSelected) === null || _props$locationSelect3 === void 0 ? void 0 : _props$locationSelect3.city_id,
        pageSize: 7
      }).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL) {
      DAO/* FestivalDao.findWeb */.vB.findWeb(RecommendedListSectionContainer_objectSpread(RecommendedListSectionContainer_objectSpread({}, props.paramsFestival), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED,
        dateSortType: config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST) {
      DAO/* ArtistDao.findWeb */.uf.findWeb(RecommendedListSectionContainer_objectSpread(RecommendedListSectionContainer_objectSpread({}, props.paramsArtist), {}, {
        sortType: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED
      })).then(function (result) {
        setIsLoading(false);
        setItems(result.data);
      });
    } else {
      setIsLoading(false);
      setItems([]);
    }
  };

  (0,react.useEffect)(function () {
    loadItems(props.category);
  }, [props.category, JSON.stringify(props.locationSelected), props.filterCriteriaListOriginalFestival, props.filterCriteriaListOriginalEvent, props.filterCriteriaListOriginalArtist, props.filterCriteriaListOriginalVenue, props.filterCriteriaListOriginalRooftop, props.filterCriteriaListOriginalSpa, props.filterCriteriaListOriginalVenueBeachful, props.filterCriteriaListOriginalVenueCocktail]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [RecommendedListSectionContainer_styles.container, props.style],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_SectionTitleView, {
      title: t("key_recommended")
    }), isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)((ActivityIndicator_default()), {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
      ref: flatListRef,
      horizontal: true,
      items: items,
      category: props.category,
      style: {
        marginLeft: 16,
        marginTop: 16,
        overflow: "hidden"
      },
      isChartsMode: isChartsMode // onItemAction={onItemAction}

    }), items.length > (RecommendedListSectionContainer_widthScreen < 1536 ? 3 : 4) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "w-full flex flex-row justify-between max-w-198px mx-auto -mt-2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "cursor-pointer",
        onClick: function onClick() {
          var _flatListRef$current;

          if (page - 1 >= 0) {
            page--;
          }

          var newIndex = page * (RecommendedListSectionContainer_widthScreen < 1536 ? 3 : 4);
          flatListRef === null || flatListRef === void 0 ? void 0 : (_flatListRef$current = flatListRef.current) === null || _flatListRef$current === void 0 ? void 0 : _flatListRef$current.scrollToIndex({
            animated: true,
            index: newIndex
          });
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "/icons/".concat( true ? ((_process$env$NEXT_PUB = "RooftopClub") === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.replace(" ", "")) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : _process$env$NEXT_PUB2.toLowerCase()) + "/" : 0, "ic_arrow_left.png"),
          width: "40",
          height: "40",
          alt: "arrow"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "cursor-pointer",
        onClick: function onClick() {
          var _flatListRef$current2;

          if (page + 1 < Math.round(items.length / (RecommendedListSectionContainer_widthScreen < 1536 ? 3 : 4))) {
            page++;
          }

          var newIndex = page * (RecommendedListSectionContainer_widthScreen < 1536 ? 3 : 4);
          flatListRef === null || flatListRef === void 0 ? void 0 : (_flatListRef$current2 = flatListRef.current) === null || _flatListRef$current2 === void 0 ? void 0 : _flatListRef$current2.scrollToIndex({
            animated: true,
            index: newIndex
          });
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "/icons/".concat( true ? ((_process$env$NEXT_PUB3 = "RooftopClub") === null || _process$env$NEXT_PUB3 === void 0 ? void 0 : (_process$env$NEXT_PUB4 = _process$env$NEXT_PUB3.replace(" ", "")) === null || _process$env$NEXT_PUB4 === void 0 ? void 0 : _process$env$NEXT_PUB4.toLowerCase()) + "/" : 0, "ic_arrow_right.png"),
          width: "40",
          height: "40",
          alt: "arrow"
        })
      })]
    })]
  });
};

var RecommendedListSectionContainer_styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    overflow: "hidden",
    width: "100%"
  },
  titleSection: {
    flexDirection: "row",
    alignSelf: "stretch",
    alignItems: "center"
  },
  title: {
    fontSize: 16,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold
  },
  viewAllBtn: {
    fontSize: 16,
    lineHeight: 18,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular
  }
});
/* harmony default export */ var containers_RecommendedListSectionContainer = (RecommendedListSectionContainer);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-accessible-dropdown-menu-hook/dist/use-dropdown-menu.js
var use_dropdown_menu = __webpack_require__(19768);
// EXTERNAL MODULE: ./src/helpers/formatHelpers.js
var formatHelpers = __webpack_require__(9465);
;// CONCATENATED MODULE: ./src/modules/explore_search/index.js




function explore_search_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function explore_search_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? explore_search_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : explore_search_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















 // 320px is filter, 32px-35px-32px are paddings




var contentWidth = "w-[calc(100vw-320px-32px-35px-32px)]";

var ExploreSearchScreen = function ExploreSearchScreen(props) {
  var _process$env$NEXT_PUB, _process$env$NEXT_PUB2, _process$env$NEXT_PUB3, _process$env$NEXT_PUB4;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)();

  var _ref = (router === null || router === void 0 ? void 0 : router.query) || {},
      combinationLinkID = _ref.id;

  var isEnabledInfiniteScroll = false;

  var _useDropdownMenu = (0,use_dropdown_menu/* default */.Z)(1),
      buttonPropsPage = _useDropdownMenu.buttonProps,
      itemPropsPage = _useDropdownMenu.itemProps,
      isOpenPage = _useDropdownMenu.isOpen,
      setIsOpenPage = _useDropdownMenu.setIsOpen;

  var pageSizeFestival = 24;
  var pageSizeEvent = 24;
  var pageSizeArtist = 36;
  var pageSizeVenue = 36;
  var pageSizeRooftop = 36;
  var pageSizeSpa = 36;
  var pageSizeVenueBeachful = 36;
  var pageSizePrefabCompany = 36;
  var pageSizePrefabHome = 36;
  var pageSizeZoo = 36;
  var pageSizeAnimal = 36;
  var pageSizeParkful = 36;
  var pageSizeCasino = 36;
  var pageSizeCastle = 36;
  var pageSizeResort = 36;
  var pageSizeAparthotel = 36;
  var pageSizeVenueCocktail = 36;
  var pageScrollRef = (0,react.useRef)(null);
  var countFestival = props.countFestival,
      setCountFestival = props.setCountFestival,
      countEvent = props.countEvent,
      setCountEvent = props.setCountEvent,
      countArtist = props.countArtist,
      setCountArtist = props.setCountArtist,
      countVenue = props.countVenue,
      setCountVenue = props.setCountVenue,
      countRooftop = props.countRooftop,
      setCountRooftop = props.setCountRooftop,
      countSpa = props.countSpa,
      setCountSpa = props.setCountSpa,
      countVenueBeachful = props.countVenueBeachful,
      setCountVenueBeachful = props.setCountVenueBeachful,
      countPrefabCompany = props.countPrefabCompany,
      setCountPrefabCompany = props.setCountPrefabCompany,
      countPrefabHome = props.countPrefabHome,
      setCountPrefabHome = props.setCountPrefabHome,
      countZoo = props.countZoo,
      setCountZoo = props.setCountZoo,
      countAnimal = props.countAnimal,
      setCountAnimal = props.setCountAnimal,
      countParkful = props.countParkful,
      setCountParkful = props.setCountParkful,
      countCasino = props.countCasino,
      setCountCasino = props.setCountCasino,
      countCastle = props.countCastle,
      setCountCastle = props.setCountCastle,
      countResort = props.countResort,
      setCountResort = props.setCountResort,
      countAparthotel = props.countAparthotel,
      setCountAparthotel = props.setCountAparthotel,
      countVenueCocktail = props.countVenueCocktail,
      setCountVenueCocktail = props.setCountVenueCocktail,
      general = props.general,
      passViewMode = props.passViewMode,
      keyword = props.keyword,
      setKeyword = props.setKeyword,
      dataCategory = props.dataCategory,
      setDataCategory = props.setDataCategory,
      locationSelected = props.locationSelected,
      setLocationSelected = props.setLocationSelected,
      setLocationSelectedTemp = props.setLocationSelectedTemp,
      sortBy = props.sortBy,
      setSortBy = props.setSortBy,
      filterCriteriaListOriginalFestival = props.filterCriteriaListOriginalFestival,
      setFilterCriteriaListOriginalFestival = props.setFilterCriteriaListOriginalFestival,
      setFilterCriteriaListOriginalFestivalTemp = props.setFilterCriteriaListOriginalFestivalTemp,
      filterCriteriaListSelectedFestival = props.filterCriteriaListSelectedFestival,
      setFilterCriteriaListSelectedFestival = props.setFilterCriteriaListSelectedFestival,
      setFilterCriteriaListSelectedFestivalTemp = props.setFilterCriteriaListSelectedFestivalTemp,
      filterTabSelectedFestival = props.filterTabSelectedFestival,
      setFilterTabSelectedFestival = props.setFilterTabSelectedFestival,
      filterCriteriaListOriginalEvent = props.filterCriteriaListOriginalEvent,
      setFilterCriteriaListOriginalEvent = props.setFilterCriteriaListOriginalEvent,
      setFilterCriteriaListOriginalEventTemp = props.setFilterCriteriaListOriginalEventTemp,
      filterCriteriaListSelectedEvent = props.filterCriteriaListSelectedEvent,
      setFilterCriteriaListSelectedEvent = props.setFilterCriteriaListSelectedEvent,
      setFilterCriteriaListSelectedEventTemp = props.setFilterCriteriaListSelectedEventTemp,
      filterTabSelectedEvent = props.filterTabSelectedEvent,
      setFilterTabSelectedEvent = props.setFilterTabSelectedEvent,
      filterCriteriaListOriginalArtist = props.filterCriteriaListOriginalArtist,
      setFilterCriteriaListOriginalArtist = props.setFilterCriteriaListOriginalArtist,
      setFilterCriteriaListOriginalArtistTemp = props.setFilterCriteriaListOriginalArtistTemp,
      filterCriteriaListSelectedArtist = props.filterCriteriaListSelectedArtist,
      setFilterCriteriaListSelectedArtist = props.setFilterCriteriaListSelectedArtist,
      setFilterCriteriaListSelectedArtistTemp = props.setFilterCriteriaListSelectedArtistTemp,
      filterTabSelectedArtist = props.filterTabSelectedArtist,
      setFilterTabSelectedArtist = props.setFilterTabSelectedArtist,
      filterCriteriaListOriginalVenue = props.filterCriteriaListOriginalVenue,
      setFilterCriteriaListOriginalVenue = props.setFilterCriteriaListOriginalVenue,
      setFilterCriteriaListOriginalVenueTemp = props.setFilterCriteriaListOriginalVenueTemp,
      filterCriteriaListSelectedVenue = props.filterCriteriaListSelectedVenue,
      setFilterCriteriaListSelectedVenue = props.setFilterCriteriaListSelectedVenue,
      setFilterCriteriaListSelectedVenueTemp = props.setFilterCriteriaListSelectedVenueTemp,
      filterTabSelectedVenue = props.filterTabSelectedVenue,
      setFilterTabSelectedVenue = props.setFilterTabSelectedVenue,
      filterCriteriaListOriginalRooftop = props.filterCriteriaListOriginalRooftop,
      setFilterCriteriaListOriginalRooftop = props.setFilterCriteriaListOriginalRooftop,
      setFilterCriteriaListOriginalRooftopTemp = props.setFilterCriteriaListOriginalRooftopTemp,
      filterCriteriaListSelectedRooftop = props.filterCriteriaListSelectedRooftop,
      setFilterCriteriaListSelectedRooftop = props.setFilterCriteriaListSelectedRooftop,
      setFilterCriteriaListSelectedRooftopTemp = props.setFilterCriteriaListSelectedRooftopTemp,
      filterTabSelectedRooftop = props.filterTabSelectedRooftop,
      setFilterTabSelectedRooftop = props.setFilterTabSelectedRooftop,
      filterCriteriaListOriginalSpa = props.filterCriteriaListOriginalSpa,
      setFilterCriteriaListOriginalSpa = props.setFilterCriteriaListOriginalSpa,
      setFilterCriteriaListOriginalSpaTemp = props.setFilterCriteriaListOriginalSpaTemp,
      filterCriteriaListSelectedSpa = props.filterCriteriaListSelectedSpa,
      setFilterCriteriaListSelectedSpa = props.setFilterCriteriaListSelectedSpa,
      setFilterCriteriaListSelectedSpaTemp = props.setFilterCriteriaListSelectedSpaTemp,
      filterTabSelectedSpa = props.filterTabSelectedSpa,
      setFilterTabSelectedSpa = props.setFilterTabSelectedSpa,
      filterCriteriaListOriginalVenueBeachful = props.filterCriteriaListOriginalVenueBeachful,
      setFilterCriteriaListOriginalVenueBeachful = props.setFilterCriteriaListOriginalVenueBeachful,
      setFilterCriteriaListOriginalVenueBeachfulTemp = props.setFilterCriteriaListOriginalVenueBeachfulTemp,
      filterCriteriaListSelectedVenueBeachful = props.filterCriteriaListSelectedVenueBeachful,
      setFilterCriteriaListSelectedVenueBeachful = props.setFilterCriteriaListSelectedVenueBeachful,
      setFilterCriteriaListSelectedVenueBeachfulTemp = props.setFilterCriteriaListSelectedVenueBeachfulTemp,
      filterTabSelectedVenueBeachful = props.filterTabSelectedVenueBeachful,
      setFilterTabSelectedVenueBeachful = props.setFilterTabSelectedVenueBeachful,
      filterCriteriaListOriginalPrefabCompany = props.filterCriteriaListOriginalPrefabCompany,
      setFilterCriteriaListOriginalPrefabCompany = props.setFilterCriteriaListOriginalPrefabCompany,
      setFilterCriteriaListOriginalPrefabCompanyTemp = props.setFilterCriteriaListOriginalPrefabCompanyTemp,
      filterCriteriaListSelectedPrefabCompany = props.filterCriteriaListSelectedPrefabCompany,
      setFilterCriteriaListSelectedPrefabCompany = props.setFilterCriteriaListSelectedPrefabCompany,
      setFilterCriteriaListSelectedPrefabCompanyTemp = props.setFilterCriteriaListSelectedPrefabCompanyTemp,
      filterTabSelectedPrefabCompany = props.filterTabSelectedPrefabCompany,
      setFilterTabSelectedPrefabCompany = props.setFilterTabSelectedPrefabCompany,
      filterCriteriaListOriginalPrefabHome = props.filterCriteriaListOriginalPrefabHome,
      setFilterCriteriaListOriginalPrefabHome = props.setFilterCriteriaListOriginalPrefabHome,
      setFilterCriteriaListOriginalPrefabHomeTemp = props.setFilterCriteriaListOriginalPrefabHomeTemp,
      filterCriteriaListSelectedPrefabHome = props.filterCriteriaListSelectedPrefabHome,
      setFilterCriteriaListSelectedPrefabHome = props.setFilterCriteriaListSelectedPrefabHome,
      setFilterCriteriaListSelectedPrefabHomeTemp = props.setFilterCriteriaListSelectedPrefabHomeTemp,
      filterTabSelectedPrefabHome = props.filterTabSelectedPrefabHome,
      setFilterTabSelectedPrefabHome = props.setFilterTabSelectedPrefabHome,
      filterCriteriaListOriginalZoo = props.filterCriteriaListOriginalZoo,
      setFilterCriteriaListOriginalZoo = props.setFilterCriteriaListOriginalZoo,
      setFilterCriteriaListOriginalZooTemp = props.setFilterCriteriaListOriginalZooTemp,
      filterCriteriaListSelectedZoo = props.filterCriteriaListSelectedZoo,
      setFilterCriteriaListSelectedZoo = props.setFilterCriteriaListSelectedZoo,
      setFilterCriteriaListSelectedZooTemp = props.setFilterCriteriaListSelectedZooTemp,
      filterTabSelectedZoo = props.filterTabSelectedZoo,
      setFilterTabSelectedZoo = props.setFilterTabSelectedZoo,
      filterCriteriaListOriginalAnimal = props.filterCriteriaListOriginalAnimal,
      setFilterCriteriaListOriginalAnimal = props.setFilterCriteriaListOriginalAnimal,
      setFilterCriteriaListOriginalAnimalTemp = props.setFilterCriteriaListOriginalAnimalTemp,
      filterCriteriaListSelectedAnimal = props.filterCriteriaListSelectedAnimal,
      setFilterCriteriaListSelectedAnimal = props.setFilterCriteriaListSelectedAnimal,
      setFilterCriteriaListSelectedAnimalTemp = props.setFilterCriteriaListSelectedAnimalTemp,
      filterTabSelectedAnimal = props.filterTabSelectedAnimal,
      setFilterTabSelectedAnimal = props.setFilterTabSelectedAnimal,
      filterCriteriaListOriginalParkful = props.filterCriteriaListOriginalParkful,
      setFilterCriteriaListOriginalParkful = props.setFilterCriteriaListOriginalParkful,
      setFilterCriteriaListOriginalParkfulTemp = props.setFilterCriteriaListOriginalParkfulTemp,
      filterCriteriaListSelectedParkful = props.filterCriteriaListSelectedParkful,
      setFilterCriteriaListSelectedParkful = props.setFilterCriteriaListSelectedParkful,
      setFilterCriteriaListSelectedParkfulTemp = props.setFilterCriteriaListSelectedParkfulTemp,
      filterTabSelectedParkful = props.filterTabSelectedParkful,
      setFilterTabSelectedParkful = props.setFilterTabSelectedParkful,
      filterCriteriaListOriginalCasino = props.filterCriteriaListOriginalCasino,
      setFilterCriteriaListOriginalCasino = props.setFilterCriteriaListOriginalCasino,
      setFilterCriteriaListOriginalCasinoTemp = props.setFilterCriteriaListOriginalCasinoTemp,
      filterCriteriaListSelectedCasino = props.filterCriteriaListSelectedCasino,
      setFilterCriteriaListSelectedCasino = props.setFilterCriteriaListSelectedCasino,
      setFilterCriteriaListSelectedCasinoTemp = props.setFilterCriteriaListSelectedCasinoTemp,
      filterTabSelectedCasino = props.filterTabSelectedCasino,
      setFilterTabSelectedCasino = props.setFilterTabSelectedCasino,
      filterCriteriaListOriginalCastle = props.filterCriteriaListOriginalCastle,
      setFilterCriteriaListOriginalCastle = props.setFilterCriteriaListOriginalCastle,
      setFilterCriteriaListOriginalCastleTemp = props.setFilterCriteriaListOriginalCastleTemp,
      filterCriteriaListSelectedCastle = props.filterCriteriaListSelectedCastle,
      setFilterCriteriaListSelectedCastle = props.setFilterCriteriaListSelectedCastle,
      setFilterCriteriaListSelectedCastleTemp = props.setFilterCriteriaListSelectedCastleTemp,
      filterTabSelectedCastle = props.filterTabSelectedCastle,
      setFilterTabSelectedCastle = props.setFilterTabSelectedCastle,
      filterCriteriaListOriginalResort = props.filterCriteriaListOriginalResort,
      setFilterCriteriaListOriginalResort = props.setFilterCriteriaListOriginalResort,
      setFilterCriteriaListOriginalResortTemp = props.setFilterCriteriaListOriginalResortTemp,
      filterCriteriaListSelectedResort = props.filterCriteriaListSelectedResort,
      setFilterCriteriaListSelectedResort = props.setFilterCriteriaListSelectedResort,
      setFilterCriteriaListSelectedResortTemp = props.setFilterCriteriaListSelectedResortTemp,
      filterTabSelectedResort = props.filterTabSelectedResort,
      setFilterTabSelectedResort = props.setFilterTabSelectedResort,
      filterCriteriaListOriginalAparthotel = props.filterCriteriaListOriginalAparthotel,
      setFilterCriteriaListOriginalAparthotel = props.setFilterCriteriaListOriginalAparthotel,
      setFilterCriteriaListOriginalAparthotelTemp = props.setFilterCriteriaListOriginalAparthotelTemp,
      filterCriteriaListSelectedAparthotel = props.filterCriteriaListSelectedAparthotel,
      setFilterCriteriaListSelectedAparthotel = props.setFilterCriteriaListSelectedAparthotel,
      setFilterCriteriaListSelectedAparthotelTemp = props.setFilterCriteriaListSelectedAparthotelTemp,
      filterTabSelectedAparthotel = props.filterTabSelectedAparthotel,
      setFilterTabSelectedAparthotel = props.setFilterTabSelectedAparthotel,
      filterCriteriaListOriginalVenueCocktail = props.filterCriteriaListOriginalVenueCocktail,
      setFilterCriteriaListOriginalVenueCocktail = props.setFilterCriteriaListOriginalVenueCocktail,
      setFilterCriteriaListOriginalVenueCocktailTemp = props.setFilterCriteriaListOriginalVenueCocktailTemp,
      filterCriteriaListSelectedVenueCocktail = props.filterCriteriaListSelectedVenueCocktail,
      setFilterCriteriaListSelectedVenueCocktail = props.setFilterCriteriaListSelectedVenueCocktail,
      setFilterCriteriaListSelectedVenueCocktailTemp = props.setFilterCriteriaListSelectedVenueCocktailTemp,
      filterTabSelectedVenueCocktail = props.filterTabSelectedVenueCocktail,
      setFilterTabSelectedVenueCocktail = props.setFilterTabSelectedVenueCocktail,
      currentPageIndex = props.currentPageIndex,
      setListFestival = props.setListFestival,
      setListEvent = props.setListEvent,
      setListArtist = props.setListArtist,
      setListVenue = props.setListVenue,
      setListRooftop = props.setListRooftop,
      setListSpa = props.setListSpa,
      setListVenueBeachful = props.setListVenueBeachful,
      setListPrefabCompany = props.setListPrefabCompany,
      setListPrefabHome = props.setListPrefabHome,
      setListZoo = props.setListZoo,
      setListAnimal = props.setListAnimal,
      setListParkful = props.setListParkful,
      setListCasino = props.setListCasino,
      setListCastle = props.setListCastle,
      setListResort = props.setListResort,
      setListAparthotel = props.setListAparthotel,
      setListVenueCocktail = props.setListVenueCocktail,
      isMobileVersion = props.isMobileVersion,
      isChartsMode = props.isChartsMode,
      listFestival = props.listFestival,
      listEvent = props.listEvent,
      listArtist = props.listArtist,
      listVenue = props.listVenue,
      listRooftop = props.listRooftop,
      listSpa = props.listSpa,
      listVenueBeachful = props.listVenueBeachful,
      listPrefabCompany = props.listPrefabCompany,
      listPrefabHome = props.listPrefabHome,
      listZoo = props.listZoo,
      listAnimal = props.listAnimal,
      listParkful = props.listParkful,
      listCasino = props.listCasino,
      listCastle = props.listCastle,
      listResort = props.listResort,
      listAparthotel = props.listAparthotel,
      listVenueCocktail = props.listVenueCocktail;
  var isInitialized = false;
  var locationModal = (0,react.useRef)(null); // Festival

  var _useState = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexFestival = _useState[0],
      setPageIndexFestival = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoadingFestival = _useState2[0],
      setIsLoadingFestival = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isLoadingNextPageFestival = _useState3[0],
      setIsLoadingNextPageFestival = _useState3[1];

  var _useState4 = (0,react.useState)(listFestival || []),
      itemsFestival = _useState4[0],
      setItemsFestival = _useState4[1];

  var _useState5 = (0,react.useState)(false),
      isNoMoreDataFestival = _useState5[0],
      setIsNoMoreDataFestival = _useState5[1]; // Event


  var _useState6 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexEvent = _useState6[0],
      setPageIndexEvent = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      isLoadingEvent = _useState7[0],
      setIsLoadingEvent = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      isLoadingNextPageEvent = _useState8[0],
      setIsLoadingNextPageEvent = _useState8[1];

  var _useState9 = (0,react.useState)(listEvent || []),
      itemsEvent = _useState9[0],
      setItemsEvent = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      isNoMoreDataEvent = _useState10[0],
      setIsNoMoreDataEvent = _useState10[1]; // Artist


  var _useState11 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexArtist = _useState11[0],
      setPageIndexArtist = _useState11[1];

  var _useState12 = (0,react.useState)(false),
      isLoadingArtist = _useState12[0],
      setIsLoadingArtist = _useState12[1];

  var _useState13 = (0,react.useState)(false),
      isLoadingNextPageArtist = _useState13[0],
      setIsLoadingNextPageArtist = _useState13[1];

  var _useState14 = (0,react.useState)(listArtist || []),
      itemsArtist = _useState14[0],
      setItemsArtist = _useState14[1];

  var _useState15 = (0,react.useState)(false),
      isNoMoreDataArtist = _useState15[0],
      setIsNoMoreDataArtist = _useState15[1]; // Venue


  var _useState16 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexVenue = _useState16[0],
      setPageIndexVenue = _useState16[1];

  var _useState17 = (0,react.useState)(false),
      isLoadingVenue = _useState17[0],
      setIsLoadingVenue = _useState17[1];

  var _useState18 = (0,react.useState)(false),
      isLoadingNextPageVenue = _useState18[0],
      setIsLoadingNextPageVenue = _useState18[1];

  var _useState19 = (0,react.useState)(listVenue || []),
      itemsVenue = _useState19[0],
      setItemsVenue = _useState19[1];

  var _useState20 = (0,react.useState)(false),
      isNoMoreDataVenue = _useState20[0],
      setIsNoMoreDataVenue = _useState20[1]; // Rooftop


  var _useState21 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexRooftop = _useState21[0],
      setPageIndexRooftop = _useState21[1];

  var _useState22 = (0,react.useState)(false),
      isLoadingRooftop = _useState22[0],
      setIsLoadingRooftop = _useState22[1];

  var _useState23 = (0,react.useState)(false),
      isLoadingNextPageRooftop = _useState23[0],
      setIsLoadingNextPageRooftop = _useState23[1];

  var _useState24 = (0,react.useState)(listRooftop || []),
      itemsRooftop = _useState24[0],
      setItemsRooftop = _useState24[1];

  var _useState25 = (0,react.useState)(false),
      isNoMoreDataRooftop = _useState25[0],
      setIsNoMoreDataRooftop = _useState25[1]; // Spa


  var _useState26 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexSpa = _useState26[0],
      setPageIndexSpa = _useState26[1];

  var _useState27 = (0,react.useState)(false),
      isLoadingSpa = _useState27[0],
      setIsLoadingSpa = _useState27[1];

  var _useState28 = (0,react.useState)(false),
      isLoadingNextPageSpa = _useState28[0],
      setIsLoadingNextPageSpa = _useState28[1];

  var _useState29 = (0,react.useState)(listSpa || []),
      itemsSpa = _useState29[0],
      setItemsSpa = _useState29[1];

  var _useState30 = (0,react.useState)(false),
      isNoMoreDataSpa = _useState30[0],
      setIsNoMoreDataSpa = _useState30[1]; // VenueBeachful


  var _useState31 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexVenueBeachful = _useState31[0],
      setPageIndexVenueBeachful = _useState31[1];

  var _useState32 = (0,react.useState)(false),
      isLoadingVenueBeachful = _useState32[0],
      setIsLoadingVenueBeachful = _useState32[1];

  var _useState33 = (0,react.useState)(false),
      isLoadingNextPageVenueBeachful = _useState33[0],
      setIsLoadingNextPageVenueBeachful = _useState33[1];

  var _useState34 = (0,react.useState)(listVenueBeachful || []),
      itemsVenueBeachful = _useState34[0],
      setItemsVenueBeachful = _useState34[1];

  var _useState35 = (0,react.useState)(false),
      isNoMoreDataVenueBeachful = _useState35[0],
      setIsNoMoreDataVenueBeachful = _useState35[1]; // PrefabCompany


  var _useState36 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexPrefabCompany = _useState36[0],
      setPageIndexPrefabCompany = _useState36[1];

  var _useState37 = (0,react.useState)(false),
      isLoadingPrefabCompany = _useState37[0],
      setIsLoadingPrefabCompany = _useState37[1];

  var _useState38 = (0,react.useState)(false),
      isLoadingNextPagePrefabCompany = _useState38[0],
      setIsLoadingNextPagePrefabCompany = _useState38[1];

  var _useState39 = (0,react.useState)(listPrefabCompany || []),
      itemsPrefabCompany = _useState39[0],
      setItemsPrefabCompany = _useState39[1];

  var _useState40 = (0,react.useState)(false),
      isNoMoreDataPrefabCompany = _useState40[0],
      setIsNoMoreDataPrefabCompany = _useState40[1]; // PrefabHome


  var _useState41 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexPrefabHome = _useState41[0],
      setPageIndexPrefabHome = _useState41[1];

  var _useState42 = (0,react.useState)(false),
      isLoadingPrefabHome = _useState42[0],
      setIsLoadingPrefabHome = _useState42[1];

  var _useState43 = (0,react.useState)(false),
      isLoadingNextPagePrefabHome = _useState43[0],
      setIsLoadingNextPagePrefabHome = _useState43[1];

  var _useState44 = (0,react.useState)(listPrefabHome || []),
      itemsPrefabHome = _useState44[0],
      setItemsPrefabHome = _useState44[1];

  var _useState45 = (0,react.useState)(false),
      isNoMoreDataPrefabHome = _useState45[0],
      setIsNoMoreDataPrefabHome = _useState45[1]; // Zoo


  var _useState46 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexZoo = _useState46[0],
      setPageIndexZoo = _useState46[1];

  var _useState47 = (0,react.useState)(false),
      isLoadingZoo = _useState47[0],
      setIsLoadingZoo = _useState47[1];

  var _useState48 = (0,react.useState)(false),
      isLoadingNextPageZoo = _useState48[0],
      setIsLoadingNextPageZoo = _useState48[1];

  var _useState49 = (0,react.useState)(listZoo || []),
      itemsZoo = _useState49[0],
      setItemsZoo = _useState49[1];

  var _useState50 = (0,react.useState)(false),
      isNoMoreDataZoo = _useState50[0],
      setIsNoMoreDataZoo = _useState50[1]; // Animal


  var _useState51 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexAnimal = _useState51[0],
      setPageIndexAnimal = _useState51[1];

  var _useState52 = (0,react.useState)(false),
      isLoadingAnimal = _useState52[0],
      setIsLoadingAnimal = _useState52[1];

  var _useState53 = (0,react.useState)(false),
      isLoadingNextPageAnimal = _useState53[0],
      setIsLoadingNextPageAnimal = _useState53[1];

  var _useState54 = (0,react.useState)(listAnimal || []),
      itemsAnimal = _useState54[0],
      setItemsAnimal = _useState54[1];

  var _useState55 = (0,react.useState)(false),
      isNoMoreDataAnimal = _useState55[0],
      setIsNoMoreDataAnimal = _useState55[1]; // Parkful


  var _useState56 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexParkful = _useState56[0],
      setPageIndexParkful = _useState56[1];

  var _useState57 = (0,react.useState)(false),
      isLoadingParkful = _useState57[0],
      setIsLoadingParkful = _useState57[1];

  var _useState58 = (0,react.useState)(false),
      isLoadingNextPageParkful = _useState58[0],
      setIsLoadingNextPageParkful = _useState58[1];

  var _useState59 = (0,react.useState)(listParkful || []),
      itemsParkful = _useState59[0],
      setItemsParkful = _useState59[1];

  var _useState60 = (0,react.useState)(false),
      isNoMoreDataParkful = _useState60[0],
      setIsNoMoreDataParkful = _useState60[1]; // Casino


  var _useState61 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexCasino = _useState61[0],
      setPageIndexCasino = _useState61[1];

  var _useState62 = (0,react.useState)(false),
      isLoadingCasino = _useState62[0],
      setIsLoadingCasino = _useState62[1];

  var _useState63 = (0,react.useState)(false),
      isLoadingNextPageCasino = _useState63[0],
      setIsLoadingNextPageCasino = _useState63[1];

  var _useState64 = (0,react.useState)(listCasino || []),
      itemsCasino = _useState64[0],
      setItemsCasino = _useState64[1];

  var _useState65 = (0,react.useState)(false),
      isNoMoreDataCasino = _useState65[0],
      setIsNoMoreDataCasino = _useState65[1]; // Castle


  var _useState66 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexCastle = _useState66[0],
      setPageIndexCastle = _useState66[1];

  var _useState67 = (0,react.useState)(false),
      isLoadingCastle = _useState67[0],
      setIsLoadingCastle = _useState67[1];

  var _useState68 = (0,react.useState)(false),
      isLoadingNextPageCastle = _useState68[0],
      setIsLoadingNextPageCastle = _useState68[1];

  var _useState69 = (0,react.useState)(listCastle || []),
      itemsCastle = _useState69[0],
      setItemsCastle = _useState69[1];

  var _useState70 = (0,react.useState)(false),
      isNoMoreDataCastle = _useState70[0],
      setIsNoMoreDataCastle = _useState70[1]; // Resort


  var _useState71 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexResort = _useState71[0],
      setPageIndexResort = _useState71[1];

  var _useState72 = (0,react.useState)(false),
      isLoadingResort = _useState72[0],
      setIsLoadingResort = _useState72[1];

  var _useState73 = (0,react.useState)(false),
      isLoadingNextPageResort = _useState73[0],
      setIsLoadingNextPageResort = _useState73[1];

  var _useState74 = (0,react.useState)(listResort || []),
      itemsResort = _useState74[0],
      setItemsResort = _useState74[1];

  var _useState75 = (0,react.useState)(false),
      isNoMoreDataResort = _useState75[0],
      setIsNoMoreDataResort = _useState75[1]; // Aparthotel


  var _useState76 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexAparthotel = _useState76[0],
      setPageIndexAparthotel = _useState76[1];

  var _useState77 = (0,react.useState)(false),
      isLoadingAparthotel = _useState77[0],
      setIsLoadingAparthotel = _useState77[1];

  var _useState78 = (0,react.useState)(false),
      isLoadingNextPageAparthotel = _useState78[0],
      setIsLoadingNextPageAparthotel = _useState78[1];

  var _useState79 = (0,react.useState)(listAparthotel || []),
      itemsAparthotel = _useState79[0],
      setItemsAparthotel = _useState79[1];

  var _useState80 = (0,react.useState)(false),
      isNoMoreDataAparthotel = _useState80[0],
      setIsNoMoreDataAparthotel = _useState80[1]; // Venue Cocktail


  var _useState81 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexVenueCocktail = _useState81[0],
      setPageIndexVenueCocktail = _useState81[1];

  var _useState82 = (0,react.useState)(false),
      isLoadingVenueCocktail = _useState82[0],
      setIsLoadingVenueCocktail = _useState82[1];

  var _useState83 = (0,react.useState)(false),
      isLoadingNextPageVenueCocktail = _useState83[0],
      setIsLoadingNextPageVenueCocktail = _useState83[1];

  var _useState84 = (0,react.useState)(listVenueCocktail || []),
      itemsVenueCocktail = _useState84[0],
      setItemsVenueCocktail = _useState84[1];

  var _useState85 = (0,react.useState)(false),
      isNoMoreDataVenueCocktail = _useState85[0],
      setIsNoMoreDataVenueCocktail = _useState85[1]; // Other


  var _useState86 = (0,react.useState)(parseInt(currentPageIndex) || 1),
      pageIndexOther = _useState86[0],
      setPageIndexOther = _useState86[1];

  var _useState87 = (0,react.useState)(false),
      isLoadingOther = _useState87[0],
      setIsLoadingOther = _useState87[1];

  var _useState88 = (0,react.useState)(false),
      isLoadingNextPageOther = _useState88[0],
      setIsLoadingNextPageOther = _useState88[1];

  var _useState89 = (0,react.useState)([]),
      itemsOther = _useState89[0],
      setItemsOther = _useState89[1];

  var _useState90 = (0,react.useState)(false),
      isNoMoreDataOther = _useState90[0],
      setIsNoMoreDataOther = _useState90[1];

  var _useState91 = (0,react.useState)([]),
      categoryList = _useState91[0],
      setCategoryList = _useState91[1];

  var _useState92 = (0,react.useState)(null),
      itemSelected = _useState92[0],
      setItemSelected = _useState92[1];

  var followModal = (0,react.useRef)(null);
  var sortMenuModal = (0,react.useRef)(null);
  var sortMenu = [{
    id: config/* Constants.sortByAction.SORT_BY_POPULARITY */.gT.sortByAction.SORT_BY_POPULARITY,
    label: t("key_sort_option_popularity"),
    isHide: dataCategory === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE || dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP || dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA || dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL || dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY || dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES || dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || dataCategory === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL || dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL || dataCategory === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO || dataCategory === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE || dataCategory === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT || dataCategory === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL || dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL
  }, {
    id: config/* Constants.sortByAction.SORT_BY_RECOMMENDED */.gT.sortByAction.SORT_BY_RECOMMENDED,
    label: t("key_sort_option_recommended"),
    isHide: dataCategory !== config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE && dataCategory !== config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP && dataCategory !== config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA && dataCategory !== config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL && dataCategory !== config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY && dataCategory !== config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES && dataCategory !== config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO && dataCategory !== config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL && dataCategory !== config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL && dataCategory !== config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO && dataCategory !== config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE && dataCategory !== config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT && dataCategory !== config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL && dataCategory !== config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL
  }, {
    id: config/* Constants.sortByAction.SORT_BY_TRENDING */.gT.sortByAction.SORT_BY_TRENDING,
    label: t("key_sort_option_trending"),
    isHide: false
  }, {
    id: config/* Constants.sortByAction.SORT_BY_PRICE_LOW */.gT.sortByAction.SORT_BY_PRICE_LOW,
    label: t("key_sort_option_price"),
    suffix: t("key_sort_option_low_high"),
    isHide: dataCategory === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST || dataCategory === config/* Constants.categoryType.CATEGORY_PROMOTERS */.gT.categoryType.CATEGORY_PROMOTERS || dataCategory === config/* Constants.categoryType.CATEGORY_OTHER */.gT.categoryType.CATEGORY_OTHER
  }, {
    id: config/* Constants.sortByAction.SORT_BY_PRICE_HIGH */.gT.sortByAction.SORT_BY_PRICE_HIGH,
    label: t("key_sort_option_price"),
    suffix: t("key_sort_option_high_low"),
    isHide: dataCategory === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST || dataCategory === config/* Constants.categoryType.CATEGORY_PROMOTERS */.gT.categoryType.CATEGORY_PROMOTERS || dataCategory === config/* Constants.categoryType.CATEGORY_OTHER */.gT.categoryType.CATEGORY_OTHER
  }, // {
  //   id: Constants.sortByAction.SORT_BY_RATING_LOW,
  //   label: t("key_sort_option_rating"),
  //   suffix: t("key_sort_option_low_high"),
  //   isHide: dataCategory === Constants.categoryType.CATEGORY_OTHER,
  // },
  // {
  //   id: Constants.sortByAction.SORT_BY_RATING_HIGH,
  //   label: t("key_sort_option_rating"),
  //   suffix: t("key_sort_option_high_low"),
  //   isHide: dataCategory === Constants.categoryType.CATEGORY_OTHER,
  // },
  {
    id: config/* Constants.sortByAction.SORT_BY_NAMEATOZ */.gT.sortByAction.SORT_BY_NAMEATOZ,
    label: t("key_sort_option_name"),
    suffix: t("key_sort_option_a_z"),
    isHide: false
  }, {
    id: config/* Constants.sortByAction.SORT_BY_NAMEZTOA */.gT.sortByAction.SORT_BY_NAMEZTOA,
    label: t("key_sort_option_name"),
    suffix: t("key_sort_option_z_a"),
    isHide: false
  }];

  var combinationLink = function combinationLink() {
    return new Promise(function (resolve, reject) {
      DAO/* LocationDao.find */.c0.find({
        pageSize: 999,
        isCountryOnly: 1
      }).then(function (locations) {
        if (dataCategory == config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL) {
          var _filterCriteriaListOr, _filterCriteriaListOr2, _filterCriteriaListOr3, _filterCriteriaListOr4, _filterCriteriaListOr5, _filterCriteriaListOr6;

          var charSet = [locations.map(function (i) {
            return i.name || i.country_name;
          }), filterCriteriaListOriginalFestival === null || filterCriteriaListOriginalFestival === void 0 ? void 0 : (_filterCriteriaListOr = filterCriteriaListOriginalFestival.find(function (i) {
            return i.title === "Date";
          })) === null || _filterCriteriaListOr === void 0 ? void 0 : (_filterCriteriaListOr2 = _filterCriteriaListOr.detailList) === null || _filterCriteriaListOr2 === void 0 ? void 0 : _filterCriteriaListOr2.map(function (i) {
            return i.label;
          }), filterCriteriaListOriginalFestival === null || filterCriteriaListOriginalFestival === void 0 ? void 0 : (_filterCriteriaListOr3 = filterCriteriaListOriginalFestival.find(function (i) {
            return i.title === "Music";
          })) === null || _filterCriteriaListOr3 === void 0 ? void 0 : (_filterCriteriaListOr4 = _filterCriteriaListOr3.detailList) === null || _filterCriteriaListOr4 === void 0 ? void 0 : _filterCriteriaListOr4.map(function (i) {
            return i.label;
          }), filterCriteriaListOriginalFestival === null || filterCriteriaListOriginalFestival === void 0 ? void 0 : (_filterCriteriaListOr5 = filterCriteriaListOriginalFestival.find(function (i) {
            return i.title === "Category";
          })) === null || _filterCriteriaListOr5 === void 0 ? void 0 : (_filterCriteriaListOr6 = _filterCriteriaListOr5.detailList) === null || _filterCriteriaListOr6 === void 0 ? void 0 : _filterCriteriaListOr6.map(function (i) {
            return i.label;
          })];
          var result = charSet.reduce(function (a, b) {
            return a.flatMap(function (x) {
              return b.map(function (y) {
                return x + (x ? "," : "") + y;
              });
            });
          }, [""]);
          resolve({
            combinationLinks: result,
            locations: locations
          });
        } else {
          var _filterCriteriaListOr7, _filterCriteriaListOr8, _filterCriteriaListOr9, _filterCriteriaListOr10, _filterCriteriaListOr11, _filterCriteriaListOr12;

          var _charSet = [locations.map(function (i) {
            return i.name || i.country_name;
          }), filterCriteriaListOriginalArtist === null || filterCriteriaListOriginalArtist === void 0 ? void 0 : (_filterCriteriaListOr7 = filterCriteriaListOriginalArtist.find(function (i) {
            return i.title === "Date";
          })) === null || _filterCriteriaListOr7 === void 0 ? void 0 : (_filterCriteriaListOr8 = _filterCriteriaListOr7.detailList) === null || _filterCriteriaListOr8 === void 0 ? void 0 : _filterCriteriaListOr8.map(function (i) {
            return i.label;
          }), filterCriteriaListOriginalArtist === null || filterCriteriaListOriginalArtist === void 0 ? void 0 : (_filterCriteriaListOr9 = filterCriteriaListOriginalArtist.find(function (i) {
            return i.title === "Music";
          })) === null || _filterCriteriaListOr9 === void 0 ? void 0 : (_filterCriteriaListOr10 = _filterCriteriaListOr9.detailList) === null || _filterCriteriaListOr10 === void 0 ? void 0 : _filterCriteriaListOr10.map(function (i) {
            return i.label;
          }), filterCriteriaListOriginalArtist === null || filterCriteriaListOriginalArtist === void 0 ? void 0 : (_filterCriteriaListOr11 = filterCriteriaListOriginalArtist.find(function (i) {
            return i.title === "Category";
          })) === null || _filterCriteriaListOr11 === void 0 ? void 0 : (_filterCriteriaListOr12 = _filterCriteriaListOr11.detailList) === null || _filterCriteriaListOr12 === void 0 ? void 0 : _filterCriteriaListOr12.map(function (i) {
            return i.label;
          })];

          var _result = _charSet.reduce(function (a, b) {
            return a.flatMap(function (x) {
              return b.map(function (y) {
                return x + (x ? "," : "") + y;
              });
            });
          }, [""]);

          resolve({
            combinationLinks: _result,
            locations: locations
          });
        }
      });
    });
  };

  var getCombinationLink = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _filterCriteriaListOr13, _filterCriteriaListOr14, _filterCriteriaListOr15, _filterCriteriaListOr16, _filterCriteriaListOr17, _filterCriteriaListOr18, _yield$combinationLin, combinationLinks, locations, locationSelectedLabel, dateSelectedLabel, musicSelectedLabel, categorySelectedLabel, result, _filterCriteriaListOr19, _filterCriteriaListOr20, _filterCriteriaListOr21, _filterCriteriaListOr22, _filterCriteriaListOr23, _filterCriteriaListOr24, _yield$combinationLin2, _combinationLinks, _locations, _locationSelectedLabel, _dateSelectedLabel, _musicSelectedLabel, _categorySelectedLabel, _result2;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(dataCategory == config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL)) {
                _context.next = 14;
                break;
              }

              _context.next = 3;
              return combinationLink();

            case 3:
              _yield$combinationLin = _context.sent;
              combinationLinks = _yield$combinationLin.combinationLinks;
              locations = _yield$combinationLin.locations;
              locationSelectedLabel = (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.name) || (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_name);
              dateSelectedLabel = filterCriteriaListSelectedFestival[0];
              musicSelectedLabel = filterCriteriaListOriginalFestival === null || filterCriteriaListOriginalFestival === void 0 ? void 0 : (_filterCriteriaListOr13 = filterCriteriaListOriginalFestival.find(function (i) {
                return i.title === "Music";
              })) === null || _filterCriteriaListOr13 === void 0 ? void 0 : (_filterCriteriaListOr14 = _filterCriteriaListOr13.detailList) === null || _filterCriteriaListOr14 === void 0 ? void 0 : (_filterCriteriaListOr15 = _filterCriteriaListOr14.find(function (i) {
                return i.tagId === filterCriteriaListSelectedFestival[1];
              })) === null || _filterCriteriaListOr15 === void 0 ? void 0 : _filterCriteriaListOr15.label;
              categorySelectedLabel = filterCriteriaListOriginalFestival === null || filterCriteriaListOriginalFestival === void 0 ? void 0 : (_filterCriteriaListOr16 = filterCriteriaListOriginalFestival.find(function (i) {
                return i.title === "Category";
              })) === null || _filterCriteriaListOr16 === void 0 ? void 0 : (_filterCriteriaListOr17 = _filterCriteriaListOr16.detailList) === null || _filterCriteriaListOr17 === void 0 ? void 0 : (_filterCriteriaListOr18 = _filterCriteriaListOr17.find(function (i) {
                return i.tagId === filterCriteriaListSelectedFestival[2];
              })) === null || _filterCriteriaListOr18 === void 0 ? void 0 : _filterCriteriaListOr18.label;
              result = combinationLinks === null || combinationLinks === void 0 ? void 0 : combinationLinks.findIndex(function (i) {
                return i === "".concat(locationSelectedLabel, ",").concat(dateSelectedLabel, ",").concat(musicSelectedLabel, ",").concat(categorySelectedLabel);
              });
              router.replace({
                query: explore_search_objectSpread(explore_search_objectSpread({}, router.query), {}, {
                  category: "festivals",
                  id: result,
                  page: currentPageIndex
                })
              });
              _context.next = 25;
              break;

            case 14:
              _context.next = 16;
              return combinationLink();

            case 16:
              _yield$combinationLin2 = _context.sent;
              _combinationLinks = _yield$combinationLin2.combinationLinks;
              _locations = _yield$combinationLin2.locations;
              _locationSelectedLabel = (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.name) || (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_name);
              _dateSelectedLabel = filterCriteriaListSelectedArtist[0];
              _musicSelectedLabel = filterCriteriaListOriginalArtist === null || filterCriteriaListOriginalArtist === void 0 ? void 0 : (_filterCriteriaListOr19 = filterCriteriaListOriginalArtist.find(function (i) {
                return i.title === "Music";
              })) === null || _filterCriteriaListOr19 === void 0 ? void 0 : (_filterCriteriaListOr20 = _filterCriteriaListOr19.detailList) === null || _filterCriteriaListOr20 === void 0 ? void 0 : (_filterCriteriaListOr21 = _filterCriteriaListOr20.find(function (i) {
                return i.tagId === filterCriteriaListSelectedArtist[1];
              })) === null || _filterCriteriaListOr21 === void 0 ? void 0 : _filterCriteriaListOr21.label;
              _categorySelectedLabel = filterCriteriaListOriginalArtist === null || filterCriteriaListOriginalArtist === void 0 ? void 0 : (_filterCriteriaListOr22 = filterCriteriaListOriginalArtist.find(function (i) {
                return i.title === "Category";
              })) === null || _filterCriteriaListOr22 === void 0 ? void 0 : (_filterCriteriaListOr23 = _filterCriteriaListOr22.detailList) === null || _filterCriteriaListOr23 === void 0 ? void 0 : (_filterCriteriaListOr24 = _filterCriteriaListOr23.find(function (i) {
                return i.tagId === filterCriteriaListSelectedArtist[2];
              })) === null || _filterCriteriaListOr24 === void 0 ? void 0 : _filterCriteriaListOr24.label;
              _result2 = _combinationLinks === null || _combinationLinks === void 0 ? void 0 : _combinationLinks.findIndex(function (i) {
                return i === "".concat(_locationSelectedLabel, ",").concat(_dateSelectedLabel, ",").concat(_musicSelectedLabel, ",").concat(_categorySelectedLabel);
              });
              router.replace({
                query: explore_search_objectSpread(explore_search_objectSpread({}, router.query), {}, {
                  category: "artists",
                  id: _result2,
                  page: currentPageIndex
                })
              });

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getCombinationLink() {
      return _ref2.apply(this, arguments);
    };
  }();

  var getInitialCombinationLink = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var _combinationLinks$par;

      var _yield$combinationLin3, combinationLinks, locations, combinationSelected, _filterCriteriaListOr25, _filterCriteriaListOr26, _filterCriteriaListOr27, _filterCriteriaListOr28, _filterCriteriaListOr29, _filterCriteriaListOr30, filterSelected, filterOriginal, _filterCriteriaListOr37, _filterCriteriaListOr38, _filterCriteriaListOr39, _filterCriteriaListOr40, _filterCriteriaListOr41, _filterCriteriaListOr42, _filterSelected, _filterOriginal;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return combinationLink();

            case 2:
              _yield$combinationLin3 = _context2.sent;
              combinationLinks = _yield$combinationLin3.combinationLinks;
              locations = _yield$combinationLin3.locations;
              combinationSelected = (_combinationLinks$par = combinationLinks[parseInt(combinationLinkID)]) === null || _combinationLinks$par === void 0 ? void 0 : _combinationLinks$par.split(",");

              if (!(!combinationSelected || (combinationSelected === null || combinationSelected === void 0 ? void 0 : combinationSelected.length) <= 0)) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", false);

            case 8:
              setLocationSelected(locations === null || locations === void 0 ? void 0 : locations.find(function (i) {
                return i.name === combinationSelected[0] || i.country_name === combinationSelected[0];
              }));
              setLocationSelectedTemp(locations === null || locations === void 0 ? void 0 : locations.find(function (i) {
                return i.name === combinationSelected[0] || i.country_name === combinationSelected[0];
              }));

              if (dataCategory == config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL) {
                filterSelected = [combinationSelected[1], filterCriteriaListOriginalFestival === null || filterCriteriaListOriginalFestival === void 0 ? void 0 : (_filterCriteriaListOr25 = filterCriteriaListOriginalFestival.find(function (i) {
                  return i.title === "Music";
                })) === null || _filterCriteriaListOr25 === void 0 ? void 0 : (_filterCriteriaListOr26 = _filterCriteriaListOr25.detailList) === null || _filterCriteriaListOr26 === void 0 ? void 0 : (_filterCriteriaListOr27 = _filterCriteriaListOr26.find(function (i) {
                  return i.label === combinationSelected[2];
                })) === null || _filterCriteriaListOr27 === void 0 ? void 0 : _filterCriteriaListOr27.tagId, filterCriteriaListOriginalFestival === null || filterCriteriaListOriginalFestival === void 0 ? void 0 : (_filterCriteriaListOr28 = filterCriteriaListOriginalFestival.find(function (i) {
                  return i.title === "Category";
                })) === null || _filterCriteriaListOr28 === void 0 ? void 0 : (_filterCriteriaListOr29 = _filterCriteriaListOr28.detailList) === null || _filterCriteriaListOr29 === void 0 ? void 0 : (_filterCriteriaListOr30 = _filterCriteriaListOr29.find(function (i) {
                  return i.label === combinationSelected[3];
                })) === null || _filterCriteriaListOr30 === void 0 ? void 0 : _filterCriteriaListOr30.tagId];
                setFilterCriteriaListSelectedFestival(filterSelected);
                setFilterCriteriaListSelectedFestivalTemp(filterSelected);
                filterOriginal = filterCriteriaListOriginalFestival.map(function (item) {
                  if (item.title == "Date") {
                    return explore_search_objectSpread(explore_search_objectSpread({}, item), {}, {
                      selectedList: [combinationSelected[1]]
                    });
                  }

                  if (item.title == "Music") {
                    var _filterCriteriaListOr31, _filterCriteriaListOr32, _filterCriteriaListOr33;

                    return explore_search_objectSpread(explore_search_objectSpread({}, item), {}, {
                      selectedList: [filterCriteriaListOriginalFestival === null || filterCriteriaListOriginalFestival === void 0 ? void 0 : (_filterCriteriaListOr31 = filterCriteriaListOriginalFestival.find(function (i) {
                        return i.title === "Music";
                      })) === null || _filterCriteriaListOr31 === void 0 ? void 0 : (_filterCriteriaListOr32 = _filterCriteriaListOr31.detailList) === null || _filterCriteriaListOr32 === void 0 ? void 0 : (_filterCriteriaListOr33 = _filterCriteriaListOr32.find(function (i) {
                        return i.label === combinationSelected[2];
                      })) === null || _filterCriteriaListOr33 === void 0 ? void 0 : _filterCriteriaListOr33.tagId]
                    });
                  }

                  if (item.title == "Category") {
                    var _filterCriteriaListOr34, _filterCriteriaListOr35, _filterCriteriaListOr36;

                    return explore_search_objectSpread(explore_search_objectSpread({}, item), {}, {
                      selectedList: [filterCriteriaListOriginalFestival === null || filterCriteriaListOriginalFestival === void 0 ? void 0 : (_filterCriteriaListOr34 = filterCriteriaListOriginalFestival.find(function (i) {
                        return i.title === "Category";
                      })) === null || _filterCriteriaListOr34 === void 0 ? void 0 : (_filterCriteriaListOr35 = _filterCriteriaListOr34.detailList) === null || _filterCriteriaListOr35 === void 0 ? void 0 : (_filterCriteriaListOr36 = _filterCriteriaListOr35.find(function (i) {
                        return i.label === combinationSelected[3];
                      })) === null || _filterCriteriaListOr36 === void 0 ? void 0 : _filterCriteriaListOr36.tagId]
                    });
                  }

                  return item;
                });
                setFilterCriteriaListOriginalFestival(filterOriginal);
                setFilterCriteriaListOriginalFestivalTemp(filterOriginal);
              } else {
                _filterSelected = [combinationSelected[1], filterCriteriaListOriginalArtist === null || filterCriteriaListOriginalArtist === void 0 ? void 0 : (_filterCriteriaListOr37 = filterCriteriaListOriginalArtist.find(function (i) {
                  return i.title === "Music";
                })) === null || _filterCriteriaListOr37 === void 0 ? void 0 : (_filterCriteriaListOr38 = _filterCriteriaListOr37.detailList) === null || _filterCriteriaListOr38 === void 0 ? void 0 : (_filterCriteriaListOr39 = _filterCriteriaListOr38.find(function (i) {
                  return i.label === combinationSelected[2];
                })) === null || _filterCriteriaListOr39 === void 0 ? void 0 : _filterCriteriaListOr39.tagId, filterCriteriaListOriginalArtist === null || filterCriteriaListOriginalArtist === void 0 ? void 0 : (_filterCriteriaListOr40 = filterCriteriaListOriginalArtist.find(function (i) {
                  return i.title === "Category";
                })) === null || _filterCriteriaListOr40 === void 0 ? void 0 : (_filterCriteriaListOr41 = _filterCriteriaListOr40.detailList) === null || _filterCriteriaListOr41 === void 0 ? void 0 : (_filterCriteriaListOr42 = _filterCriteriaListOr41.find(function (i) {
                  return i.label === combinationSelected[3];
                })) === null || _filterCriteriaListOr42 === void 0 ? void 0 : _filterCriteriaListOr42.tagId];
                setFilterCriteriaListSelectedArtist(_filterSelected);
                setFilterCriteriaListSelectedArtistTemp(_filterSelected);
                _filterOriginal = filterCriteriaListOriginalArtist.map(function (item) {
                  if (item.title == "Date") {
                    return explore_search_objectSpread(explore_search_objectSpread({}, item), {}, {
                      selectedList: [combinationSelected[1]]
                    });
                  }

                  if (item.title == "Music") {
                    var _filterCriteriaListOr43, _filterCriteriaListOr44, _filterCriteriaListOr45;

                    return explore_search_objectSpread(explore_search_objectSpread({}, item), {}, {
                      selectedList: [filterCriteriaListOriginalArtist === null || filterCriteriaListOriginalArtist === void 0 ? void 0 : (_filterCriteriaListOr43 = filterCriteriaListOriginalArtist.find(function (i) {
                        return i.title === "Music";
                      })) === null || _filterCriteriaListOr43 === void 0 ? void 0 : (_filterCriteriaListOr44 = _filterCriteriaListOr43.detailList) === null || _filterCriteriaListOr44 === void 0 ? void 0 : (_filterCriteriaListOr45 = _filterCriteriaListOr44.find(function (i) {
                        return i.label === combinationSelected[2];
                      })) === null || _filterCriteriaListOr45 === void 0 ? void 0 : _filterCriteriaListOr45.tagId]
                    });
                  }

                  if (item.title == "Category") {
                    var _filterCriteriaListOr46, _filterCriteriaListOr47, _filterCriteriaListOr48;

                    return explore_search_objectSpread(explore_search_objectSpread({}, item), {}, {
                      selectedList: [filterCriteriaListOriginalArtist === null || filterCriteriaListOriginalArtist === void 0 ? void 0 : (_filterCriteriaListOr46 = filterCriteriaListOriginalArtist.find(function (i) {
                        return i.title === "Category";
                      })) === null || _filterCriteriaListOr46 === void 0 ? void 0 : (_filterCriteriaListOr47 = _filterCriteriaListOr46.detailList) === null || _filterCriteriaListOr47 === void 0 ? void 0 : (_filterCriteriaListOr48 = _filterCriteriaListOr47.find(function (i) {
                        return i.label === combinationSelected[3];
                      })) === null || _filterCriteriaListOr48 === void 0 ? void 0 : _filterCriteriaListOr48.tagId]
                    });
                  }

                  return item;
                });
                setFilterCriteriaListOriginalArtist(_filterOriginal);
                setFilterCriteriaListOriginalArtistTemp(_filterOriginal);
              }

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getInitialCombinationLink() {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (isChartsMode) {
      setTimeout(function () {
        getInitialCombinationLink();
      }, 500);
    }
  }, [passViewMode]);

  var onLoad = function onLoad() {
    var _isInitialized = isInitialized;
    setIsOpenPage(false);
    DAO/* CategoryDao.getConstantCategories */.Rr.getConstantCategories().then(function (categories) {
      var category = categories.filter(function (item) {
        return item.id == config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST || item.id == config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL || item.id == config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT || item.id == config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE || item.id == config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP || item.id == config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA || item.id == config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL || item.id == config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY || item.id == config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES || item.id == config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || item.id == config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL || item.id == config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL || item.id == config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO || item.id == config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE || item.id == config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT || item.id == config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL || item.id == config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL || item.id == config/* Constants.categoryType.CATEGORY_OTHER */.gT.categoryType.CATEGORY_OTHER;
      }).map(function (item) {
        return explore_search_objectSpread(explore_search_objectSpread({}, item), {}, {
          count: 0
        });
      });
      setCategoryList(category);

      if (!dataCategory && categories && categories.length > 0) {
        if (isInitialized) {
          setDataCategory(categories[0].id);
        }
      }

      if (isChartsMode) {
        getCombinationLink();
      }

      loadItems(false, category, !_isInitialized);
    });
    isInitialized = true;
  };

  var convertParamsFestival = function convertParamsFestival(isNextPage, category) {
    var status = [];
    var tagFilters = [];
    var startDateFrom = null;
    var startDateTo = null;
    var rating = null;
    var lineupSize = null;
    var price = null;
    var festivalGenreTagId = null;
    var sortByCharts = null;
    var isAnytime = null;

    if (filterCriteriaListOriginalFestival) {
      filterCriteriaListOriginalFestival.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList, _item$selectedList2, _item$selectedList3, _item$selectedList8;

          if (item.isDate && ((_item$selectedList = item.selectedList) !== null && _item$selectedList !== void 0 && _item$selectedList.start || (_item$selectedList2 = item.selectedList) !== null && _item$selectedList2 !== void 0 && _item$selectedList2.isUpcoming || (_item$selectedList3 = item.selectedList) !== null && _item$selectedList3 !== void 0 && _item$selectedList3.isAnytime)) {
            var _item$selectedList4, _item$selectedList5, _item$selectedList6;

            if ((_item$selectedList4 = item.selectedList) !== null && _item$selectedList4 !== void 0 && _item$selectedList4.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList5 = item.selectedList) !== null && _item$selectedList5 !== void 0 && _item$selectedList5.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
            } else if ((_item$selectedList6 = item.selectedList) !== null && _item$selectedList6 !== void 0 && _item$selectedList6.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isLineup) {
            var _item$selectedList7;

            lineupSize = ((_item$selectedList7 = item.selectedList) === null || _item$selectedList7 === void 0 ? void 0 : _item$selectedList7.length) > 0 ? item.selectedList : null;
          } else if (item.isPrice && item.selectedList.length > 0) {
            price = item.selectedList[1] === 1000 ? {
              minValue: item.selectedList[0]
            } : {
              minValue: item.selectedList[0],
              maxValue: item.selectedList[1]
            };
          } else if (item.isRating && ((_item$selectedList8 = item.selectedList) === null || _item$selectedList8 === void 0 ? void 0 : _item$selectedList8.length) > 0) {
            rating = item.selectedList;
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
            status = item.selectedList;
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: config/* Constants.tagIds.TAG_ID_AGE */.gT.tagIds.TAG_ID_AGE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
              });
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              var _item$selectedList9, _item$selectedList11;

              if ((_item$selectedList9 = item.selectedList) !== null && _item$selectedList9 !== void 0 && _item$selectedList9.filter(function (i) {
                return i > 700 && i < 800;
              })) {
                var _item$selectedList10;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE */.gT.tagCategory.TAG_CATEGORY_VENUE,
                  tags: (_item$selectedList10 = item.selectedList) === null || _item$selectedList10 === void 0 ? void 0 : _item$selectedList10.filter(function (i) {
                    return i > 700 && i < 800;
                  })
                });
              }

              if ((_item$selectedList11 = item.selectedList) !== null && _item$selectedList11 !== void 0 && _item$selectedList11.filter(function (i) {
                return i > 800 && i < 900;
              })) {
                var _item$selectedList12;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE_2 */.gT.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: (_item$selectedList12 = item.selectedList) === null || _item$selectedList12 === void 0 ? void 0 : _item$selectedList12.filter(function (i) {
                    return i > 800 && i < 900;
                  })
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0) {
              festivalGenreTagId = item.selectedList[0] !== 300 ? item.selectedList[0] : null;
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      keyword: keyword,
      festivalGenreTagId: festivalGenreTagId,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexFestival - 1 : 0 : parseInt(currentPageIndex) - 1,
      pageSize: pageSizeFestival,
      status: status.length > 0 ? status : null,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedFestival,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      sortType: sortByCharts || sortBy,
      rating: rating,
      lineupSize: lineupSize,
      price: price
    };
  };

  var convertParamsEvent = function convertParamsEvent(isNextPage, category) {
    var status = [];
    var tagFilters = [];
    var startDateFrom = null;
    var startDateTo = null;
    var rating = null;
    var lineupSize = null;
    var price = null;
    var festivalGenreTagId = null;
    var sortByCharts = null;
    var isAnytime = null;

    if (filterCriteriaListOriginalEvent) {
      filterCriteriaListOriginalEvent.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList13, _item$selectedList14, _item$selectedList15, _item$selectedList20;

          if (item.isDate && ((_item$selectedList13 = item.selectedList) !== null && _item$selectedList13 !== void 0 && _item$selectedList13.start || (_item$selectedList14 = item.selectedList) !== null && _item$selectedList14 !== void 0 && _item$selectedList14.isUpcoming || (_item$selectedList15 = item.selectedList) !== null && _item$selectedList15 !== void 0 && _item$selectedList15.isAnytime)) {
            var _item$selectedList16, _item$selectedList17, _item$selectedList18;

            if ((_item$selectedList16 = item.selectedList) !== null && _item$selectedList16 !== void 0 && _item$selectedList16.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList17 = item.selectedList) !== null && _item$selectedList17 !== void 0 && _item$selectedList17.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
            } else if ((_item$selectedList18 = item.selectedList) !== null && _item$selectedList18 !== void 0 && _item$selectedList18.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isLineup) {
            var _item$selectedList19;

            lineupSize = ((_item$selectedList19 = item.selectedList) === null || _item$selectedList19 === void 0 ? void 0 : _item$selectedList19.length) > 0 ? item.selectedList : null;
          } else if (item.isPrice && item.selectedList.length > 0) {
            price = item.selectedList[1] === 1000 ? {
              minValue: item.selectedList[0]
            } : {
              minValue: item.selectedList[0],
              maxValue: item.selectedList[1]
            };
          } else if (item.isRating && ((_item$selectedList20 = item.selectedList) === null || _item$selectedList20 === void 0 ? void 0 : _item$selectedList20.length) > 0) {
            rating = item.selectedList;
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
            status = item.selectedList;
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: config/* Constants.tagIds.TAG_ID_AGE */.gT.tagIds.TAG_ID_AGE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
              });
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              var _item$selectedList21, _item$selectedList23;

              if ((_item$selectedList21 = item.selectedList) !== null && _item$selectedList21 !== void 0 && _item$selectedList21.filter(function (i) {
                return i > 700 && i < 800;
              })) {
                var _item$selectedList22;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE */.gT.tagCategory.TAG_CATEGORY_VENUE,
                  tags: (_item$selectedList22 = item.selectedList) === null || _item$selectedList22 === void 0 ? void 0 : _item$selectedList22.filter(function (i) {
                    return i > 700 && i < 800;
                  })
                });
              }

              if ((_item$selectedList23 = item.selectedList) !== null && _item$selectedList23 !== void 0 && _item$selectedList23.filter(function (i) {
                return i > 800 && i < 900;
              })) {
                var _item$selectedList24;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE_2 */.gT.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: (_item$selectedList24 = item.selectedList) === null || _item$selectedList24 === void 0 ? void 0 : _item$selectedList24.filter(function (i) {
                    return i > 800 && i < 900;
                  })
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0) {
              festivalGenreTagId = item.selectedList[0] !== 300 ? item.selectedList[0] : null;
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT,
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      keyword: keyword,
      festivalGenreTagId: festivalGenreTagId,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexEvent - 1 : 0 : parseInt(currentPageIndex) - 1,
      pageSize: pageSizeEvent,
      status: status.length > 0 ? status : null,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedEvent,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      sortType: sortByCharts || sortBy,
      rating: rating,
      lineupSize: lineupSize,
      price: price
    };
  };

  var getDataFestival = function getDataFestival(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataFestival) {
        return false;
      }

      setIsLoadingNextPageFestival(true);
    } else {
      setIsLoadingFestival(true);

      if (!isCountOnly) {
        setItemsFestival([]);
        setListFestival([]);
      }
    }

    var params = convertParamsFestival(isNextPage, category);
    DAO/* FestivalDao.findWeb */.vB.findWeb(params).then(function (result) {
      var _result$data2;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL) {
          _category[index].count = result.totalCount;
          setCountFestival(result.totalCount);
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPageFestival(false);
      setIsLoadingFestival(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexFestival((isNextPage ? pageIndexFestival : 1) + 1);
      }

      if (isNextPage) {
        var _result$data;

        if (((_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.length) > 0) {
          setItemsFestival(uniqBy_default()(itemsFestival.concat(result.data), "id"));
          setListFestival(uniqBy_default()(itemsFestival.concat(result.data), "id"));
        }
      } else {
        setItemsFestival(uniqBy_default()(result.data, "id"));
        setListFestival(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data2 = result.data) === null || _result$data2 === void 0 ? void 0 : _result$data2.length) <= 0) {
        setIsNoMoreDataFestival(true);
      } else {
        setIsNoMoreDataFestival(false);
      }
    });
  };

  var getDataEvent = function getDataEvent(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataEvent) {
        return false;
      }

      setIsLoadingNextPageEvent(true);
    } else {
      setIsLoadingEvent(true);

      if (!isCountOnly) {
        setItemsEvent([]);
        setListEvent([]);
      }
    }

    var params = convertParamsEvent(isNextPage, category);
    DAO/* EventDao.findWeb */.SA.findWeb(params).then(function (result) {
      var _result$data4;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT) {
          _category[index].count = result.totalCount;
          setCountEvent(result.totalCount);
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPageEvent(false);
      setIsLoadingEvent(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexEvent((isNextPage ? pageIndexEvent : 1) + 1);
      }

      if (isNextPage) {
        var _result$data3;

        if (((_result$data3 = result.data) === null || _result$data3 === void 0 ? void 0 : _result$data3.length) > 0) {
          setItemsEvent(uniqBy_default()(itemsEvent.concat(result.data), "id"));
          setListEvent(uniqBy_default()(itemsEvent.concat(result.data), "id"));
        }
      } else {
        setItemsEvent(uniqBy_default()(result.data, "id"));
        setListEvent(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data4 = result.data) === null || _result$data4 === void 0 ? void 0 : _result$data4.length) <= 0) {
        setIsNoMoreDataEvent(true);
      } else {
        setIsNoMoreDataEvent(false);
      }
    });
  };

  var convertParamsArtist = function convertParamsArtist(isNextPage, category) {
    var tagFilters = [];
    var artistCountryId = null;
    var activity = null;
    var startDateFrom = null;
    var startDateTo = null;
    var eventSize = null;
    var sortByCharts = null;
    var isAnytime = null;
    var isUpcoming = null;

    if (filterCriteriaListOriginalArtist) {
      filterCriteriaListOriginalArtist.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList25, _item$selectedList26, _item$selectedList27;

          if (item.isDate && ((_item$selectedList25 = item.selectedList) !== null && _item$selectedList25 !== void 0 && _item$selectedList25.start || (_item$selectedList26 = item.selectedList) !== null && _item$selectedList26 !== void 0 && _item$selectedList26.isUpcoming || (_item$selectedList27 = item.selectedList) !== null && _item$selectedList27 !== void 0 && _item$selectedList27.isAnytime)) {
            var _item$selectedList28, _item$selectedList29, _item$selectedList30;

            if ((_item$selectedList28 = item.selectedList) !== null && _item$selectedList28 !== void 0 && _item$selectedList28.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList29 = item.selectedList) !== null && _item$selectedList29 !== void 0 && _item$selectedList29.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if ((_item$selectedList30 = item.selectedList) !== null && _item$selectedList30 !== void 0 && _item$selectedList30.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isEventSize) {
            var _item$selectedList31;

            eventSize = ((_item$selectedList31 = item.selectedList) === null || _item$selectedList31 === void 0 ? void 0 : _item$selectedList31.length) > 0 ? item.selectedList : null;
          } else if (item.isLocation && item.selectedList.length > 0) {
            artistCountryId = item.selectedList;
          } else if (item.isActivity && item.selectedList.length > 0) {
            activity = item.selectedList;
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      activity: activity,
      keyword: keyword,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexArtist - 1 : 0 : parseInt(currentPageIndex) - 1,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedArtist,
      pageSize: pageSizeArtist,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      artistCountryId: artistCountryId,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      dateSortType: isUpcoming ? config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING : null,
      sortType: sortByCharts || sortBy,
      eventSize: eventSize
    };
  };

  var getDataArtist = function getDataArtist(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataArtist) {
        return false;
      }

      setIsLoadingNextPageArtist(true);
    } else {
      setIsLoadingArtist(true);

      if (!isCountOnly) {
        setItemsArtist([]);
      }
    }

    var params = convertParamsArtist(isNextPage, category);
    DAO/* ArtistDao.findWeb */.uf.findWeb(params).then(function (result) {
      var _result$data6;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST) {
          _category[index].count = result.totalCount;
          setCountArtist(result.totalCount);
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPageArtist(false);
      setIsLoadingArtist(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexArtist((isNextPage ? pageIndexArtist : 1) + 1);
      }

      if (isNextPage) {
        var _result$data5;

        if (((_result$data5 = result.data) === null || _result$data5 === void 0 ? void 0 : _result$data5.length) > 0) {
          setItemsArtist(uniqBy_default()(itemsArtist.concat(result.data), "id"));
        }
      } else {
        setItemsArtist(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data6 = result.data) === null || _result$data6 === void 0 ? void 0 : _result$data6.length) <= 0) {
        setIsNoMoreDataArtist(true);
      } else {
        setIsNoMoreDataArtist(false);
      }
    });
  };

  var convertParamsVenue = function convertParamsVenue(isNextPage, category) {
    var tagFilters = [];
    var startDateFrom = null;
    var startDateTo = null;
    var sortByCharts = null;
    var isAnytime = null;
    var isUpcoming = null;
    var venueStatus = null;

    if (filterCriteriaListOriginalVenue) {
      filterCriteriaListOriginalVenue.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList32, _item$selectedList33, _item$selectedList34;

          if (item.isDate && ((_item$selectedList32 = item.selectedList) !== null && _item$selectedList32 !== void 0 && _item$selectedList32.start || (_item$selectedList33 = item.selectedList) !== null && _item$selectedList33 !== void 0 && _item$selectedList33.isUpcoming || (_item$selectedList34 = item.selectedList) !== null && _item$selectedList34 !== void 0 && _item$selectedList34.isAnytime)) {
            var _item$selectedList35, _item$selectedList36, _item$selectedList37;

            if ((_item$selectedList35 = item.selectedList) !== null && _item$selectedList35 !== void 0 && _item$selectedList35.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList36 = item.selectedList) !== null && _item$selectedList36 !== void 0 && _item$selectedList36.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if ((_item$selectedList37 = item.selectedList) !== null && _item$selectedList37 !== void 0 && _item$selectedList37.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: config/* Constants.tagIds.TAG_ID_AGE */.gT.tagIds.TAG_ID_AGE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
              });
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              var _item$selectedList38, _item$selectedList40;

              if ((_item$selectedList38 = item.selectedList) !== null && _item$selectedList38 !== void 0 && _item$selectedList38.filter(function (i) {
                return i > 700 && i < 800;
              })) {
                var _item$selectedList39;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE */.gT.tagCategory.TAG_CATEGORY_VENUE,
                  tags: (_item$selectedList39 = item.selectedList) === null || _item$selectedList39 === void 0 ? void 0 : _item$selectedList39.filter(function (i) {
                    return i > 700 && i < 800;
                  })
                });
              }

              if ((_item$selectedList40 = item.selectedList) !== null && _item$selectedList40 !== void 0 && _item$selectedList40.filter(function (i) {
                return i > 800 && i < 900;
              })) {
                var _item$selectedList41;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE_2 */.gT.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: (_item$selectedList41 = item.selectedList) === null || _item$selectedList41 === void 0 ? void 0 : _item$selectedList41.filter(function (i) {
                    return i > 800 && i < 900;
                  })
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      venueStatus: venueStatus,
      keyword: keyword,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexVenue - 1 : 0 : parseInt(currentPageIndex) - 1,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedVenue,
      pageSize: pageSizeVenue,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      dateSortType: isUpcoming ? config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING : null,
      sortType: sortByCharts || sortBy
    };
  };

  var getDataVenue = function getDataVenue(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataVenue) {
        return false;
      }

      setIsLoadingNextPageVenue(true);
    } else {
      setIsLoadingVenue(true);

      if (!isCountOnly) {
        setItemsVenue([]);
        setListVenue([]);
      }
    }

    var params = convertParamsVenue(isNextPage, category);
    DAO/* VenueDao.find */.eL.find(params).then(function (result) {
      var _result$data8;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE) {
          _category[index].count = result.totalCount;

          if (setCountVenue) {
            setCountVenue(result.totalCount);
          }
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPageVenue(false);
      setIsLoadingVenue(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexVenue((isNextPage ? pageIndexVenue : 1) + 1);
      }

      if (isNextPage) {
        var _result$data7;

        if (((_result$data7 = result.data) === null || _result$data7 === void 0 ? void 0 : _result$data7.length) > 0) {
          setItemsVenue(uniqBy_default()(itemsVenue.concat(result.data), "id"));
          setListVenue(uniqBy_default()(itemsVenue.concat(result.data), "id"));
        }
      } else {
        setItemsVenue(uniqBy_default()(result.data, "id"));
        setListVenue(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data8 = result.data) === null || _result$data8 === void 0 ? void 0 : _result$data8.length) <= 0) {
        setIsNoMoreDataVenue(true);
      } else {
        setIsNoMoreDataVenue(false);
      }
    });
  };

  var convertParamsRooftop = function convertParamsRooftop(isNextPage, category) {
    var tagFilters = [];
    var startDateFrom = null;
    var startDateTo = null;
    var sortByCharts = null;
    var isAnytime = null;
    var isUpcoming = null;
    var venueStatus = null;

    if (filterCriteriaListOriginalRooftop) {
      filterCriteriaListOriginalRooftop.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList42, _item$selectedList43, _item$selectedList44;

          if (item.isDate && ((_item$selectedList42 = item.selectedList) !== null && _item$selectedList42 !== void 0 && _item$selectedList42.start || (_item$selectedList43 = item.selectedList) !== null && _item$selectedList43 !== void 0 && _item$selectedList43.isUpcoming || (_item$selectedList44 = item.selectedList) !== null && _item$selectedList44 !== void 0 && _item$selectedList44.isAnytime)) {
            var _item$selectedList45, _item$selectedList46, _item$selectedList47;

            if ((_item$selectedList45 = item.selectedList) !== null && _item$selectedList45 !== void 0 && _item$selectedList45.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList46 = item.selectedList) !== null && _item$selectedList46 !== void 0 && _item$selectedList46.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if ((_item$selectedList47 = item.selectedList) !== null && _item$selectedList47 !== void 0 && _item$selectedList47.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: config/* Constants.tagIds.TAG_ID_AGE */.gT.tagIds.TAG_ID_AGE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
              });
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              var _item$selectedList48;

              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if ((_item$selectedList48 = item.selectedList) !== null && _item$selectedList48 !== void 0 && _item$selectedList48.filter(function (i) {
                return i > 800 && i < 900;
              })) {
                var _item$selectedList49;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE_2 */.gT.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: (_item$selectedList49 = item.selectedList) === null || _item$selectedList49 === void 0 ? void 0 : _item$selectedList49.filter(function (i) {
                    return i > 800 && i < 900;
                  })
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP,
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      venueStatus: venueStatus,
      keyword: keyword,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexRooftop - 1 : 0 : parseInt(currentPageIndex) - 1,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedRooftop,
      pageSize: pageSizeRooftop,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      dateSortType: isUpcoming ? config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING : null,
      sortType: sortByCharts || sortBy
    };
  };

  var getDataRooftop = function getDataRooftop(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataRooftop) {
        return false;
      }

      setIsLoadingNextPageRooftop(true);
    } else {
      setIsLoadingRooftop(true);

      if (!isCountOnly) {
        setItemsRooftop([]);
        setListRooftop([]);
      }
    }

    var params = convertParamsRooftop(isNextPage, category);
    DAO/* VenueDao.find */.eL.find(params).then(function (result) {
      var _result$data10;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP) {
          _category[index].count = result.totalCount;

          if (setCountRooftop) {
            setCountRooftop(result.totalCount);
          }
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPageRooftop(false);
      setIsLoadingRooftop(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexRooftop((isNextPage ? pageIndexRooftop : 1) + 1);
      }

      if (isNextPage) {
        var _result$data9;

        if (((_result$data9 = result.data) === null || _result$data9 === void 0 ? void 0 : _result$data9.length) > 0) {
          setItemsRooftop(uniqBy_default()(itemsRooftop.concat(result.data), "id"));
          setListRooftop(uniqBy_default()(itemsRooftop.concat(result.data), "id"));
        }
      } else {
        setItemsRooftop(uniqBy_default()(result.data, "id"));
        setListRooftop(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data10 = result.data) === null || _result$data10 === void 0 ? void 0 : _result$data10.length) <= 0) {
        setIsNoMoreDataRooftop(true);
      } else {
        setIsNoMoreDataRooftop(false);
      }
    });
  };

  var convertParamsSpa = function convertParamsSpa(isNextPage, category) {
    var tagFilters = [];
    var startDateFrom = null;
    var startDateTo = null;
    var sortByCharts = null;
    var isAnytime = null;
    var isUpcoming = null;
    var venueStatus = null;
    var amenities = null;

    if (filterCriteriaListOriginalSpa) {
      filterCriteriaListOriginalSpa.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList50, _item$selectedList51, _item$selectedList52;

          if (item.isDate && ((_item$selectedList50 = item.selectedList) !== null && _item$selectedList50 !== void 0 && _item$selectedList50.start || (_item$selectedList51 = item.selectedList) !== null && _item$selectedList51 !== void 0 && _item$selectedList51.isUpcoming || (_item$selectedList52 = item.selectedList) !== null && _item$selectedList52 !== void 0 && _item$selectedList52.isAnytime)) {
            var _item$selectedList53, _item$selectedList54, _item$selectedList55;

            if ((_item$selectedList53 = item.selectedList) !== null && _item$selectedList53 !== void 0 && _item$selectedList53.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList54 = item.selectedList) !== null && _item$selectedList54 !== void 0 && _item$selectedList54.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if ((_item$selectedList55 = item.selectedList) !== null && _item$selectedList55 !== void 0 && _item$selectedList55.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: config/* Constants.tagIds.TAG_ID_AGE */.gT.tagIds.TAG_ID_AGE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
              });
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_AMENITIES */.gT.tagCategory.TAG_CATEGORY_AMENITIES) {
            if (item.selectedList.length > 0) {
              amenities = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              var _item$selectedList56;

              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if ((_item$selectedList56 = item.selectedList) !== null && _item$selectedList56 !== void 0 && _item$selectedList56.filter(function (i) {
                return i > 800 && i < 900;
              })) {
                var _item$selectedList57;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE_2 */.gT.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: (_item$selectedList57 = item.selectedList) === null || _item$selectedList57 === void 0 ? void 0 : _item$selectedList57.filter(function (i) {
                    return i > 800 && i < 900;
                  })
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA,
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      venueStatus: venueStatus,
      amenities: amenities,
      keyword: keyword,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexSpa - 1 : 0 : parseInt(currentPageIndex) - 1,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedSpa,
      pageSize: pageSizeSpa,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      dateSortType: isUpcoming ? config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING : null,
      sortType: sortByCharts || sortBy
    };
  };

  var getDataSpa = function getDataSpa(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataSpa) {
        return false;
      }

      setIsLoadingNextPageSpa(true);
    } else {
      setIsLoadingSpa(true);

      if (!isCountOnly) {
        setItemsSpa([]);
        setListSpa([]);
      }
    }

    var params = convertParamsSpa(isNextPage, category);
    DAO/* VenueDao.find */.eL.find(params).then(function (result) {
      var _result$data12;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA) {
          _category[index].count = result.totalCount;

          if (setCountSpa) {
            setCountSpa(result.totalCount);
          }
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPageSpa(false);
      setIsLoadingSpa(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexSpa((isNextPage ? pageIndexSpa : 1) + 1);
      }

      if (isNextPage) {
        var _result$data11;

        if (((_result$data11 = result.data) === null || _result$data11 === void 0 ? void 0 : _result$data11.length) > 0) {
          setItemsSpa(uniqBy_default()(itemsSpa.concat(result.data), "id"));
          setListSpa(uniqBy_default()(itemsSpa.concat(result.data), "id"));
        }
      } else {
        setItemsSpa(uniqBy_default()(result.data, "id"));
        setListSpa(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data12 = result.data) === null || _result$data12 === void 0 ? void 0 : _result$data12.length) <= 0) {
        setIsNoMoreDataSpa(true);
      } else {
        setIsNoMoreDataSpa(false);
      }
    });
  };

  var convertParamsVenueBeachful = function convertParamsVenueBeachful(isNextPage, category) {
    var tagFilters = [];
    var startDateFrom = null;
    var startDateTo = null;
    var sortByCharts = null;
    var isAnytime = null;
    var isUpcoming = null;
    var venueStatus = null;

    if (filterCriteriaListOriginalVenueBeachful) {
      filterCriteriaListOriginalVenueBeachful.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList58, _item$selectedList59, _item$selectedList60;

          if (item.isDate && ((_item$selectedList58 = item.selectedList) !== null && _item$selectedList58 !== void 0 && _item$selectedList58.start || (_item$selectedList59 = item.selectedList) !== null && _item$selectedList59 !== void 0 && _item$selectedList59.isUpcoming || (_item$selectedList60 = item.selectedList) !== null && _item$selectedList60 !== void 0 && _item$selectedList60.isAnytime)) {
            var _item$selectedList61, _item$selectedList62, _item$selectedList63;

            if ((_item$selectedList61 = item.selectedList) !== null && _item$selectedList61 !== void 0 && _item$selectedList61.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList62 = item.selectedList) !== null && _item$selectedList62 !== void 0 && _item$selectedList62.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if ((_item$selectedList63 = item.selectedList) !== null && _item$selectedList63 !== void 0 && _item$selectedList63.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: config/* Constants.tagIds.TAG_ID_AGE */.gT.tagIds.TAG_ID_AGE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
              });
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              var _item$selectedList64;

              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if ((_item$selectedList64 = item.selectedList) !== null && _item$selectedList64 !== void 0 && _item$selectedList64.filter(function (i) {
                return i > 800 && i < 900;
              })) {
                var _item$selectedList65;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE_2 */.gT.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: (_item$selectedList65 = item.selectedList) === null || _item$selectedList65 === void 0 ? void 0 : _item$selectedList65.filter(function (i) {
                    return i > 800 && i < 900;
                  })
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL,
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      venueStatus: venueStatus,
      keyword: keyword,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexVenueBeachful - 1 : 0 : parseInt(currentPageIndex) - 1,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedVenueBeachful,
      pageSize: pageSizeVenueBeachful,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      dateSortType: isUpcoming ? config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING : null,
      sortType: sortByCharts || sortBy
    };
  };

  var getDataVenueBeachful = function getDataVenueBeachful(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataVenueBeachful) {
        return false;
      }

      setIsLoadingNextPageVenueBeachful(true);
    } else {
      setIsLoadingVenueBeachful(true);

      if (!isCountOnly) {
        setItemsVenueBeachful([]);
        setListVenueBeachful([]);
      }
    }

    var params = convertParamsVenueBeachful(isNextPage, category);
    DAO/* VenueDao.find */.eL.find(params).then(function (result) {
      var _result$data14;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL) {
          _category[index].count = result.totalCount;

          if (setCountVenueBeachful) {
            setCountVenueBeachful(result.totalCount);
          }
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPageVenueBeachful(false);
      setIsLoadingVenueBeachful(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexVenueBeachful((isNextPage ? pageIndexVenueBeachful : 1) + 1);
      }

      if (isNextPage) {
        var _result$data13;

        if (((_result$data13 = result.data) === null || _result$data13 === void 0 ? void 0 : _result$data13.length) > 0) {
          setItemsVenueBeachful(uniqBy_default()(itemsVenueBeachful.concat(result.data), "id"));
          setListVenueBeachful(uniqBy_default()(itemsVenueBeachful.concat(result.data), "id"));
        }
      } else {
        setItemsVenueBeachful(uniqBy_default()(result.data, "id"));
        setListVenueBeachful(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data14 = result.data) === null || _result$data14 === void 0 ? void 0 : _result$data14.length) <= 0) {
        setIsNoMoreDataVenueBeachful(true);
      } else {
        setIsNoMoreDataVenueBeachful(false);
      }
    });
  };

  var convertParamsPrefabCompany = function convertParamsPrefabCompany(isNextPage, category) {
    var tagFilters = [];
    var startDateFrom = null;
    var startDateTo = null;
    var sortByCharts = null;
    var isAnytime = null;
    var isUpcoming = null;
    var venueStatus = null;
    var companyHomeSize = null;

    if (filterCriteriaListOriginalPrefabCompany) {
      filterCriteriaListOriginalPrefabCompany.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList66, _item$selectedList67, _item$selectedList68;

          if (item.isDate && ((_item$selectedList66 = item.selectedList) !== null && _item$selectedList66 !== void 0 && _item$selectedList66.start || (_item$selectedList67 = item.selectedList) !== null && _item$selectedList67 !== void 0 && _item$selectedList67.isUpcoming || (_item$selectedList68 = item.selectedList) !== null && _item$selectedList68 !== void 0 && _item$selectedList68.isAnytime)) {
            var _item$selectedList69, _item$selectedList70, _item$selectedList71;

            if ((_item$selectedList69 = item.selectedList) !== null && _item$selectedList69 !== void 0 && _item$selectedList69.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList70 = item.selectedList) !== null && _item$selectedList70 !== void 0 && _item$selectedList70.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if ((_item$selectedList71 = item.selectedList) !== null && _item$selectedList71 !== void 0 && _item$selectedList71.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: config/* Constants.tagIds.TAG_ID_AGE */.gT.tagIds.TAG_ID_AGE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
              });
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              var _item$selectedList72;

              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if ((_item$selectedList72 = item.selectedList) !== null && _item$selectedList72 !== void 0 && _item$selectedList72.filter(function (i) {
                return i > 800 && i < 900;
              })) {
                var _item$selectedList73;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE_2 */.gT.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: (_item$selectedList73 = item.selectedList) === null || _item$selectedList73 === void 0 ? void 0 : _item$selectedList73.filter(function (i) {
                    return i > 800 && i < 900;
                  })
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else if (item.isCompanyHomeSize) {
            var _item$selectedList74;

            companyHomeSize = ((_item$selectedList74 = item.selectedList) === null || _item$selectedList74 === void 0 ? void 0 : _item$selectedList74.length) > 0 ? item.selectedList : null;
          } else if (item.title == "Size") {
            if (item.selectedList.length > 0) {
              tagFilters.push(explore_search_objectSpread({
                tagId: config/* Constants.tagIds.TAG_ID_SIZE_SQF */.gT.tagIds.TAG_ID_SIZE_SQF,
                category: config/* Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT */.gT.tagCategory.TAG_CATEGORY_SIZE_SQFT
              }, item.selectedList[0]));
            }
          } else if (item.title == "Price") {
            if (item.selectedList.length > 0) {
              tagFilters.push(explore_search_objectSpread({
                tagId: config/* Constants.tagIds.TAG_ID_PRICE */.gT.tagIds.TAG_ID_PRICE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_PRICE */.gT.tagCategory.TAG_CATEGORY_PRICE
              }, item.selectedList[0]));
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY,
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      venueStatus: venueStatus,
      keyword: keyword,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexPrefabCompany - 1 : 0 : parseInt(currentPageIndex) - 1,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedPrefabCompany,
      pageSize: pageSizePrefabCompany,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      dateSortType: isUpcoming ? config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING : null,
      sortType: sortByCharts || sortBy,
      companyHomeSize: companyHomeSize
    };
  };

  var getDataPrefabCompany = function getDataPrefabCompany(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataPrefabCompany) {
        return false;
      }

      setIsLoadingNextPagePrefabCompany(true);
    } else {
      setIsLoadingPrefabCompany(true);

      if (!isCountOnly) {
        setItemsPrefabCompany([]);
        setListPrefabCompany([]);
      }
    }

    var params = convertParamsPrefabCompany(isNextPage, category);
    DAO/* VenueDao.find */.eL.find(params).then(function (result) {
      var _result$data16;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY) {
          _category[index].count = result.totalCount;

          if (setCountPrefabCompany) {
            setCountPrefabCompany(result.totalCount);
          }
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPagePrefabCompany(false);
      setIsLoadingPrefabCompany(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexPrefabCompany((isNextPage ? pageIndexPrefabCompany : 1) + 1);
      }

      if (isNextPage) {
        var _result$data15;

        if (((_result$data15 = result.data) === null || _result$data15 === void 0 ? void 0 : _result$data15.length) > 0) {
          setItemsPrefabCompany(uniqBy_default()(itemsPrefabCompany.concat(result.data), "id"));
          setListPrefabCompany(uniqBy_default()(itemsPrefabCompany.concat(result.data), "id"));
        }
      } else {
        setItemsPrefabCompany(uniqBy_default()(result.data, "id"));
        setListPrefabCompany(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data16 = result.data) === null || _result$data16 === void 0 ? void 0 : _result$data16.length) <= 0) {
        setIsNoMoreDataPrefabCompany(true);
      } else {
        setIsNoMoreDataPrefabCompany(false);
      }
    });
  };

  var convertParamsPrefabHome = function convertParamsPrefabHome(isNextPage, category) {
    var tagFilters = [];
    var startDateFrom = null;
    var startDateTo = null;
    var sortByCharts = null;
    var isAnytime = null;
    var isUpcoming = null;
    var venueStatus = null;

    if (filterCriteriaListOriginalPrefabHome) {
      filterCriteriaListOriginalPrefabHome.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList75, _item$selectedList76, _item$selectedList77;

          if (item.isDate && ((_item$selectedList75 = item.selectedList) !== null && _item$selectedList75 !== void 0 && _item$selectedList75.start || (_item$selectedList76 = item.selectedList) !== null && _item$selectedList76 !== void 0 && _item$selectedList76.isUpcoming || (_item$selectedList77 = item.selectedList) !== null && _item$selectedList77 !== void 0 && _item$selectedList77.isAnytime)) {
            var _item$selectedList78, _item$selectedList79, _item$selectedList80;

            if ((_item$selectedList78 = item.selectedList) !== null && _item$selectedList78 !== void 0 && _item$selectedList78.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList79 = item.selectedList) !== null && _item$selectedList79 !== void 0 && _item$selectedList79.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if ((_item$selectedList80 = item.selectedList) !== null && _item$selectedList80 !== void 0 && _item$selectedList80.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: config/* Constants.tagIds.TAG_ID_AGE */.gT.tagIds.TAG_ID_AGE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
              });
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              var _item$selectedList81;

              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if ((_item$selectedList81 = item.selectedList) !== null && _item$selectedList81 !== void 0 && _item$selectedList81.filter(function (i) {
                return i > 800 && i < 900;
              })) {
                var _item$selectedList82;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE_2 */.gT.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: (_item$selectedList82 = item.selectedList) === null || _item$selectedList82 === void 0 ? void 0 : _item$selectedList82.filter(function (i) {
                    return i > 800 && i < 900;
                  })
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else if (item.title == "Size") {
            if (item.selectedList.length > 0) {
              tagFilters.push(explore_search_objectSpread({
                tagId: config/* Constants.tagIds.TAG_ID_SIZE_SQF */.gT.tagIds.TAG_ID_SIZE_SQF,
                category: config/* Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT */.gT.tagCategory.TAG_CATEGORY_SIZE_SQFT
              }, item.selectedList[0]));
            }
          } else if (item.title == "Bathrooms") {
            if (item.selectedList.length > 0) {
              tagFilters.push(explore_search_objectSpread({
                tagId: config/* Constants.tagIds.TAG_ID_BATHROOM */.gT.tagIds.TAG_ID_BATHROOM,
                category: config/* Constants.tagCategory.TAG_CATEGORY_PREFAB_BATHROOM */.gT.tagCategory.TAG_CATEGORY_PREFAB_BATHROOM
              }, item.selectedList[0]));
            }
          } else if (item.title == "Price") {
            if (item.selectedList.length > 0) {
              tagFilters.push(explore_search_objectSpread({
                tagId: config/* Constants.tagIds.TAG_ID_PRICE */.gT.tagIds.TAG_ID_PRICE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_PRICE */.gT.tagCategory.TAG_CATEGORY_PRICE
              }, item.selectedList[0]));
            }
          } else if (item.title == "Capacity") {
            if (item.selectedList.length > 0) {
              tagFilters.push(explore_search_objectSpread({
                tagId: config/* Constants.tagIds.TAG_ID_CAPACITY */.gT.tagIds.TAG_ID_CAPACITY,
                category: config/* Constants.tagCategory.TAG_CATEGORY_PREFAB_CAPACITY */.gT.tagCategory.TAG_CATEGORY_PREFAB_CAPACITY
              }, item.selectedList[0]));
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES,
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      venueStatus: venueStatus,
      keyword: keyword,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexPrefabHome - 1 : 0 : parseInt(currentPageIndex) - 1,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedPrefabHome,
      pageSize: pageSizePrefabHome,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      dateSortType: isUpcoming ? config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING : null,
      sortType: sortByCharts || sortBy
    };
  };

  var getDataPrefabHome = function getDataPrefabHome(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataPrefabHome) {
        return false;
      }

      setIsLoadingNextPagePrefabHome(true);
    } else {
      setIsLoadingPrefabHome(true);

      if (!isCountOnly) {
        setItemsPrefabHome([]);
        setListPrefabHome([]);
      }
    }

    var params = convertParamsPrefabHome(isNextPage, category);
    DAO/* VenueDao.find */.eL.find(params).then(function (result) {
      var _result$data18;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES) {
          _category[index].count = result.totalCount;

          if (setCountPrefabHome) {
            setCountPrefabHome(result.totalCount);
          }
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPagePrefabHome(false);
      setIsLoadingPrefabHome(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexPrefabHome((isNextPage ? pageIndexPrefabHome : 1) + 1);
      }

      if (isNextPage) {
        var _result$data17;

        if (((_result$data17 = result.data) === null || _result$data17 === void 0 ? void 0 : _result$data17.length) > 0) {
          setItemsPrefabHome(uniqBy_default()(itemsPrefabHome.concat(result.data), "id"));
          setListPrefabHome(uniqBy_default()(itemsPrefabHome.concat(result.data), "id"));
        }
      } else {
        setItemsPrefabHome(uniqBy_default()(result.data, "id"));
        setListPrefabHome(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data18 = result.data) === null || _result$data18 === void 0 ? void 0 : _result$data18.length) <= 0) {
        setIsNoMoreDataPrefabHome(true);
      } else {
        setIsNoMoreDataPrefabHome(false);
      }
    });
  };

  var convertParamsZoo = function convertParamsZoo(isNextPage, category) {
    var tagFilters = [];
    var startDateFrom = null;
    var startDateTo = null;
    var sortByCharts = null;
    var isAnytime = null;
    var isUpcoming = null;
    var venueStatus = null;

    if (filterCriteriaListOriginalZoo) {
      filterCriteriaListOriginalZoo.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList83, _item$selectedList84, _item$selectedList85;

          if (item.isDate && ((_item$selectedList83 = item.selectedList) !== null && _item$selectedList83 !== void 0 && _item$selectedList83.start || (_item$selectedList84 = item.selectedList) !== null && _item$selectedList84 !== void 0 && _item$selectedList84.isUpcoming || (_item$selectedList85 = item.selectedList) !== null && _item$selectedList85 !== void 0 && _item$selectedList85.isAnytime)) {
            var _item$selectedList86, _item$selectedList87, _item$selectedList88;

            if ((_item$selectedList86 = item.selectedList) !== null && _item$selectedList86 !== void 0 && _item$selectedList86.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList87 = item.selectedList) !== null && _item$selectedList87 !== void 0 && _item$selectedList87.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if ((_item$selectedList88 = item.selectedList) !== null && _item$selectedList88 !== void 0 && _item$selectedList88.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: config/* Constants.tagIds.TAG_ID_AGE */.gT.tagIds.TAG_ID_AGE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
              });
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              var _item$selectedList89;

              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if ((_item$selectedList89 = item.selectedList) !== null && _item$selectedList89 !== void 0 && _item$selectedList89.filter(function (i) {
                return i > 800 && i < 900;
              })) {
                var _item$selectedList90;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE_2 */.gT.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: (_item$selectedList90 = item.selectedList) === null || _item$selectedList90 === void 0 ? void 0 : _item$selectedList90.filter(function (i) {
                    return i > 800 && i < 900;
                  })
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else if (item.title == "Animals") {
            if (item.selectedList.length > 0) {
              tagFilters.push(explore_search_objectSpread({
                tagId: config/* Constants.tagIds.TAG_ID_SPECIES */.gT.tagIds.TAG_ID_SPECIES,
                category: config/* Constants.tagCategory.TAG_CATEGORY_ZOO_SPECIES */.gT.tagCategory.TAG_CATEGORY_ZOO_SPECIES
              }, item.selectedList[0]));
            }
          } else if (item.title == "Population") {
            if (item.selectedList.length > 0) {
              tagFilters.push(explore_search_objectSpread({
                tagId: config/* Constants.tagIds.TAG_ID_POPULATION */.gT.tagIds.TAG_ID_POPULATION,
                category: config/* Constants.tagCategory.TAG_CATEGORY_ZOO_POPULATION */.gT.tagCategory.TAG_CATEGORY_ZOO_POPULATION
              }, item.selectedList[0]));
            }
          } else if (item.title == "Price") {
            if (item.selectedList.length > 0) {
              tagFilters.push(explore_search_objectSpread({
                tagId: config/* Constants.tagIds.TAG_ID_PRICE */.gT.tagIds.TAG_ID_PRICE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_PRICE */.gT.tagCategory.TAG_CATEGORY_PRICE
              }, item.selectedList[0]));
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO,
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      venueStatus: venueStatus,
      keyword: keyword,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexZoo - 1 : 0 : parseInt(currentPageIndex) - 1,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedZoo,
      pageSize: pageSizeZoo,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      dateSortType: isUpcoming ? config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING : null,
      sortType: sortByCharts || sortBy
    };
  };

  var getDataZoo = function getDataZoo(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataZoo) {
        return false;
      }

      setIsLoadingNextPageZoo(true);
    } else {
      setIsLoadingZoo(true);

      if (!isCountOnly) {
        setItemsZoo([]);
        setListZoo([]);
      }
    }

    var params = convertParamsZoo(isNextPage, category);
    DAO/* VenueDao.find */.eL.find(params).then(function (result) {
      var _result$data20;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO) {
          _category[index].count = result.totalCount;

          if (setCountZoo) {
            setCountZoo(result.totalCount);
          }
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPageZoo(false);
      setIsLoadingZoo(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexZoo((isNextPage ? pageIndexZoo : 1) + 1);
      }

      if (isNextPage) {
        var _result$data19;

        if (((_result$data19 = result.data) === null || _result$data19 === void 0 ? void 0 : _result$data19.length) > 0) {
          setItemsZoo(uniqBy_default()(itemsZoo.concat(result.data), "id"));
          setListZoo(uniqBy_default()(itemsZoo.concat(result.data), "id"));
        }
      } else {
        setItemsZoo(uniqBy_default()(result.data, "id"));
        setListZoo(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data20 = result.data) === null || _result$data20 === void 0 ? void 0 : _result$data20.length) <= 0) {
        setIsNoMoreDataZoo(true);
      } else {
        setIsNoMoreDataZoo(false);
      }
    });
  };

  var convertParamsAnimal = function convertParamsAnimal(isNextPage, category) {
    var tagFilters = [];
    var startDateFrom = null;
    var startDateTo = null;
    var sortByCharts = null;
    var isAnytime = null;
    var isUpcoming = null;
    var venueStatus = null;

    if (filterCriteriaListOriginalAnimal) {
      filterCriteriaListOriginalAnimal.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList91, _item$selectedList92, _item$selectedList93;

          if (item.isDate && ((_item$selectedList91 = item.selectedList) !== null && _item$selectedList91 !== void 0 && _item$selectedList91.start || (_item$selectedList92 = item.selectedList) !== null && _item$selectedList92 !== void 0 && _item$selectedList92.isUpcoming || (_item$selectedList93 = item.selectedList) !== null && _item$selectedList93 !== void 0 && _item$selectedList93.isAnytime)) {
            var _item$selectedList94, _item$selectedList95, _item$selectedList96;

            if ((_item$selectedList94 = item.selectedList) !== null && _item$selectedList94 !== void 0 && _item$selectedList94.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList95 = item.selectedList) !== null && _item$selectedList95 !== void 0 && _item$selectedList95.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if ((_item$selectedList96 = item.selectedList) !== null && _item$selectedList96 !== void 0 && _item$selectedList96.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: config/* Constants.tagIds.TAG_ID_AGE */.gT.tagIds.TAG_ID_AGE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
              });
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              var _item$selectedList97;

              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if ((_item$selectedList97 = item.selectedList) !== null && _item$selectedList97 !== void 0 && _item$selectedList97.filter(function (i) {
                return i > 800 && i < 900;
              })) {
                var _item$selectedList98;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE_2 */.gT.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: (_item$selectedList98 = item.selectedList) === null || _item$selectedList98 === void 0 ? void 0 : _item$selectedList98.filter(function (i) {
                    return i > 800 && i < 900;
                  })
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL,
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      venueStatus: venueStatus,
      keyword: keyword,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexAnimal - 1 : 0 : parseInt(currentPageIndex) - 1,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedAnimal,
      pageSize: pageSizeAnimal,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      dateSortType: isUpcoming ? config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING : null,
      sortType: sortByCharts || sortBy
    };
  };

  var getDataAnimal = function getDataAnimal(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataAnimal) {
        return false;
      }

      setIsLoadingNextPageAnimal(true);
    } else {
      setIsLoadingAnimal(true);

      if (!isCountOnly) {
        setItemsAnimal([]);
        setListAnimal([]);
      }
    }

    var params = convertParamsAnimal(isNextPage, category);
    DAO/* VenueDao.find */.eL.find(params).then(function (result) {
      var _result$data22;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL) {
          _category[index].count = result.totalCount;

          if (setCountAnimal) {
            setCountAnimal(result.totalCount);
          }
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPageAnimal(false);
      setIsLoadingAnimal(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexAnimal((isNextPage ? pageIndexAnimal : 1) + 1);
      }

      if (isNextPage) {
        var _result$data21;

        if (((_result$data21 = result.data) === null || _result$data21 === void 0 ? void 0 : _result$data21.length) > 0) {
          setItemsAnimal(uniqBy_default()(itemsAnimal.concat(result.data), "id"));
          setListAnimal(uniqBy_default()(itemsAnimal.concat(result.data), "id"));
        }
      } else {
        setItemsAnimal(uniqBy_default()(result.data, "id"));
        setListAnimal(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data22 = result.data) === null || _result$data22 === void 0 ? void 0 : _result$data22.length) <= 0) {
        setIsNoMoreDataAnimal(true);
      } else {
        setIsNoMoreDataAnimal(false);
      }
    });
  };

  var convertParamsParkful = function convertParamsParkful(isNextPage, category) {
    var tagFilters = [];
    var startDateFrom = null;
    var startDateTo = null;
    var sortByCharts = null;
    var isAnytime = null;
    var isUpcoming = null;
    var venueStatus = null;
    var amenities = null;

    if (filterCriteriaListOriginalParkful) {
      filterCriteriaListOriginalParkful.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList99, _item$selectedList100, _item$selectedList101;

          if (item.isDate && ((_item$selectedList99 = item.selectedList) !== null && _item$selectedList99 !== void 0 && _item$selectedList99.start || (_item$selectedList100 = item.selectedList) !== null && _item$selectedList100 !== void 0 && _item$selectedList100.isUpcoming || (_item$selectedList101 = item.selectedList) !== null && _item$selectedList101 !== void 0 && _item$selectedList101.isAnytime)) {
            var _item$selectedList102, _item$selectedList103, _item$selectedList104;

            if ((_item$selectedList102 = item.selectedList) !== null && _item$selectedList102 !== void 0 && _item$selectedList102.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList103 = item.selectedList) !== null && _item$selectedList103 !== void 0 && _item$selectedList103.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if ((_item$selectedList104 = item.selectedList) !== null && _item$selectedList104 !== void 0 && _item$selectedList104.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: config/* Constants.tagIds.TAG_ID_AGE */.gT.tagIds.TAG_ID_AGE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
              });
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_AMENITIES */.gT.tagCategory.TAG_CATEGORY_AMENITIES) {
            if (item.selectedList.length > 0) {
              amenities = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              var _item$selectedList105;

              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if ((_item$selectedList105 = item.selectedList) !== null && _item$selectedList105 !== void 0 && _item$selectedList105.filter(function (i) {
                return i > 800 && i < 900;
              })) {
                var _item$selectedList106;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE_2 */.gT.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: (_item$selectedList106 = item.selectedList) === null || _item$selectedList106 === void 0 ? void 0 : _item$selectedList106.filter(function (i) {
                    return i > 800 && i < 900;
                  })
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL,
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      venueStatus: venueStatus,
      amenities: amenities,
      keyword: keyword,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexAnimal - 1 : 0 : parseInt(currentPageIndex) - 1,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedAnimal,
      pageSize: pageSizeAnimal,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      dateSortType: isUpcoming ? config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING : null,
      sortType: sortByCharts || sortBy
    };
  };

  var getDataParkful = function getDataParkful(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataParkful) {
        return false;
      }

      setIsLoadingNextPageParkful(true);
    } else {
      setIsLoadingParkful(true);

      if (!isCountOnly) {
        setItemsParkful([]);
        setListParkful([]);
      }
    }

    var params = convertParamsParkful(isNextPage, category);
    DAO/* VenueDao.find */.eL.find(params).then(function (result) {
      var _result$data24;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL) {
          _category[index].count = result.totalCount;

          if (setCountParkful) {
            setCountParkful(result.totalCount);
          }
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPageParkful(false);
      setIsLoadingParkful(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexParkful((isNextPage ? pageIndexParkful : 1) + 1);
      }

      if (isNextPage) {
        var _result$data23;

        if (((_result$data23 = result.data) === null || _result$data23 === void 0 ? void 0 : _result$data23.length) > 0) {
          setItemsParkful(uniqBy_default()(itemsParkful.concat(result.data), "id"));
          setListParkful(uniqBy_default()(itemsParkful.concat(result.data), "id"));
        }
      } else {
        setItemsParkful(uniqBy_default()(result.data, "id"));
        setListParkful(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data24 = result.data) === null || _result$data24 === void 0 ? void 0 : _result$data24.length) <= 0) {
        setIsNoMoreDataParkful(true);
      } else {
        setIsNoMoreDataParkful(false);
      }
    });
  };

  var convertParamsCasino = function convertParamsCasino(isNextPage, category) {
    var tagFilters = [];
    var startDateFrom = null;
    var startDateTo = null;
    var sortByCharts = null;
    var isAnytime = null;
    var isUpcoming = null;
    var venueStatus = null;

    if (filterCriteriaListOriginalCasino) {
      filterCriteriaListOriginalCasino.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList107, _item$selectedList108, _item$selectedList109;

          if (item.isDate && ((_item$selectedList107 = item.selectedList) !== null && _item$selectedList107 !== void 0 && _item$selectedList107.start || (_item$selectedList108 = item.selectedList) !== null && _item$selectedList108 !== void 0 && _item$selectedList108.isUpcoming || (_item$selectedList109 = item.selectedList) !== null && _item$selectedList109 !== void 0 && _item$selectedList109.isAnytime)) {
            var _item$selectedList110, _item$selectedList111, _item$selectedList112;

            if ((_item$selectedList110 = item.selectedList) !== null && _item$selectedList110 !== void 0 && _item$selectedList110.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList111 = item.selectedList) !== null && _item$selectedList111 !== void 0 && _item$selectedList111.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if ((_item$selectedList112 = item.selectedList) !== null && _item$selectedList112 !== void 0 && _item$selectedList112.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: config/* Constants.tagIds.TAG_ID_AGE */.gT.tagIds.TAG_ID_AGE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
              });
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              var _item$selectedList113;

              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if ((_item$selectedList113 = item.selectedList) !== null && _item$selectedList113 !== void 0 && _item$selectedList113.filter(function (i) {
                return i > 800 && i < 900;
              })) {
                var _item$selectedList114;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE_2 */.gT.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: (_item$selectedList114 = item.selectedList) === null || _item$selectedList114 === void 0 ? void 0 : _item$selectedList114.filter(function (i) {
                    return i > 800 && i < 900;
                  })
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else if (item.title == "Size") {
            if (item.selectedList.length > 0) {
              tagFilters.push(explore_search_objectSpread({
                tagId: config/* Constants.tagIds.TAG_ID_SIZE_SQF */.gT.tagIds.TAG_ID_SIZE_SQF,
                category: config/* Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT */.gT.tagCategory.TAG_CATEGORY_SIZE_SQFT
              }, item.selectedList[0]));
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO,
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      venueStatus: venueStatus,
      keyword: keyword,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexAnimal - 1 : 0 : parseInt(currentPageIndex) - 1,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedAnimal,
      pageSize: pageSizeAnimal,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      dateSortType: isUpcoming ? config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING : null,
      sortType: sortByCharts || sortBy
    };
  };

  var getDataCasino = function getDataCasino(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataCasino) {
        return false;
      }

      setIsLoadingNextPageCasino(true);
    } else {
      setIsLoadingCasino(true);

      if (!isCountOnly) {
        setItemsCasino([]);
        setListCasino([]);
      }
    }

    var params = convertParamsCasino(isNextPage, category);
    DAO/* VenueDao.find */.eL.find(params).then(function (result) {
      var _result$data26;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO) {
          _category[index].count = result.totalCount;

          if (setCountCasino) {
            setCountCasino(result.totalCount);
          }
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPageCasino(false);
      setIsLoadingCasino(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexCasino((isNextPage ? pageIndexCasino : 1) + 1);
      }

      if (isNextPage) {
        var _result$data25;

        if (((_result$data25 = result.data) === null || _result$data25 === void 0 ? void 0 : _result$data25.length) > 0) {
          setItemsCasino(uniqBy_default()(itemsCasino.concat(result.data), "id"));
          setListCasino(uniqBy_default()(itemsCasino.concat(result.data), "id"));
        }
      } else {
        setItemsCasino(uniqBy_default()(result.data, "id"));
        setListCasino(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data26 = result.data) === null || _result$data26 === void 0 ? void 0 : _result$data26.length) <= 0) {
        setIsNoMoreDataCasino(true);
      } else {
        setIsNoMoreDataCasino(false);
      }
    });
  };

  var convertParamsCastle = function convertParamsCastle(isNextPage, category) {
    var tagFilters = [];
    var startDateFrom = null;
    var startDateTo = null;
    var sortByCharts = null;
    var isAnytime = null;
    var isUpcoming = null;
    var venueStatus = null;
    var amenities = null;

    if (filterCriteriaListOriginalCastle) {
      filterCriteriaListOriginalCastle.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList115, _item$selectedList116, _item$selectedList117;

          if (item.isDate && ((_item$selectedList115 = item.selectedList) !== null && _item$selectedList115 !== void 0 && _item$selectedList115.start || (_item$selectedList116 = item.selectedList) !== null && _item$selectedList116 !== void 0 && _item$selectedList116.isUpcoming || (_item$selectedList117 = item.selectedList) !== null && _item$selectedList117 !== void 0 && _item$selectedList117.isAnytime)) {
            var _item$selectedList118, _item$selectedList119, _item$selectedList120;

            if ((_item$selectedList118 = item.selectedList) !== null && _item$selectedList118 !== void 0 && _item$selectedList118.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList119 = item.selectedList) !== null && _item$selectedList119 !== void 0 && _item$selectedList119.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if ((_item$selectedList120 = item.selectedList) !== null && _item$selectedList120 !== void 0 && _item$selectedList120.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: config/* Constants.tagIds.TAG_ID_AGE */.gT.tagIds.TAG_ID_AGE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
              });
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_AMENITIES */.gT.tagCategory.TAG_CATEGORY_AMENITIES) {
            if (item.selectedList.length > 0) {
              amenities = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              var _item$selectedList121;

              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if ((_item$selectedList121 = item.selectedList) !== null && _item$selectedList121 !== void 0 && _item$selectedList121.filter(function (i) {
                return i > 800 && i < 900;
              })) {
                var _item$selectedList122;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE_2 */.gT.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: (_item$selectedList122 = item.selectedList) === null || _item$selectedList122 === void 0 ? void 0 : _item$selectedList122.filter(function (i) {
                    return i > 800 && i < 900;
                  })
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE,
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      venueStatus: venueStatus,
      amenities: amenities,
      keyword: keyword,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexAnimal - 1 : 0 : parseInt(currentPageIndex) - 1,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedAnimal,
      pageSize: pageSizeAnimal,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      dateSortType: isUpcoming ? config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING : null,
      sortType: sortByCharts || sortBy
    };
  };

  var getDataCastle = function getDataCastle(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataCastle) {
        return false;
      }

      setIsLoadingNextPageCastle(true);
    } else {
      setIsLoadingCastle(true);

      if (!isCountOnly) {
        setItemsCastle([]);
        setListCastle([]);
      }
    }

    var params = convertParamsCastle(isNextPage, category);
    DAO/* VenueDao.find */.eL.find(params).then(function (result) {
      var _result$data28;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE) {
          _category[index].count = result.totalCount;

          if (setCountCastle) {
            setCountCastle(result.totalCount);
          }
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPageCastle(false);
      setIsLoadingCastle(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexCastle((isNextPage ? pageIndexCastle : 1) + 1);
      }

      if (isNextPage) {
        var _result$data27;

        if (((_result$data27 = result.data) === null || _result$data27 === void 0 ? void 0 : _result$data27.length) > 0) {
          setItemsCastle(uniqBy_default()(itemsCastle.concat(result.data), "id"));
          setListCastle(uniqBy_default()(itemsCastle.concat(result.data), "id"));
        }
      } else {
        setItemsCastle(uniqBy_default()(result.data, "id"));
        setListCastle(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data28 = result.data) === null || _result$data28 === void 0 ? void 0 : _result$data28.length) <= 0) {
        setIsNoMoreDataCastle(true);
      } else {
        setIsNoMoreDataCastle(false);
      }
    });
  };

  var convertParamsResort = function convertParamsResort(isNextPage, category) {
    var tagFilters = [];
    var startDateFrom = null;
    var startDateTo = null;
    var sortByCharts = null;
    var isAnytime = null;
    var isUpcoming = null;
    var venueStatus = null;
    var amenities = null;

    if (filterCriteriaListOriginalResort) {
      filterCriteriaListOriginalResort.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList123, _item$selectedList124, _item$selectedList125;

          if (item.isDate && ((_item$selectedList123 = item.selectedList) !== null && _item$selectedList123 !== void 0 && _item$selectedList123.start || (_item$selectedList124 = item.selectedList) !== null && _item$selectedList124 !== void 0 && _item$selectedList124.isUpcoming || (_item$selectedList125 = item.selectedList) !== null && _item$selectedList125 !== void 0 && _item$selectedList125.isAnytime)) {
            var _item$selectedList126, _item$selectedList127, _item$selectedList128;

            if ((_item$selectedList126 = item.selectedList) !== null && _item$selectedList126 !== void 0 && _item$selectedList126.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList127 = item.selectedList) !== null && _item$selectedList127 !== void 0 && _item$selectedList127.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if ((_item$selectedList128 = item.selectedList) !== null && _item$selectedList128 !== void 0 && _item$selectedList128.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: config/* Constants.tagIds.TAG_ID_AGE */.gT.tagIds.TAG_ID_AGE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
              });
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_AMENITIES */.gT.tagCategory.TAG_CATEGORY_AMENITIES) {
            if (item.selectedList.length > 0) {
              amenities = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              var _item$selectedList129;

              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if ((_item$selectedList129 = item.selectedList) !== null && _item$selectedList129 !== void 0 && _item$selectedList129.filter(function (i) {
                return i > 800 && i < 900;
              })) {
                var _item$selectedList130;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE_2 */.gT.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: (_item$selectedList130 = item.selectedList) === null || _item$selectedList130 === void 0 ? void 0 : _item$selectedList130.filter(function (i) {
                    return i > 800 && i < 900;
                  })
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT,
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      venueStatus: venueStatus,
      amenities: amenities,
      keyword: keyword,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexAnimal - 1 : 0 : parseInt(currentPageIndex) - 1,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedAnimal,
      pageSize: pageSizeAnimal,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      dateSortType: isUpcoming ? config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING : null,
      sortType: sortByCharts || sortBy
    };
  };

  var getDataResort = function getDataResort(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataResort) {
        return false;
      }

      setIsLoadingNextPageResort(true);
    } else {
      setIsLoadingResort(true);

      if (!isCountOnly) {
        setItemsResort([]);
        setListResort([]);
      }
    }

    var params = convertParamsResort(isNextPage, category);
    DAO/* VenueDao.find */.eL.find(params).then(function (result) {
      var _result$data30;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT) {
          _category[index].count = result.totalCount;

          if (setCountResort) {
            setCountResort(result.totalCount);
          }
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPageResort(false);
      setIsLoadingResort(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexResort((isNextPage ? pageIndexResort : 1) + 1);
      }

      if (isNextPage) {
        var _result$data29;

        if (((_result$data29 = result.data) === null || _result$data29 === void 0 ? void 0 : _result$data29.length) > 0) {
          setItemsResort(uniqBy_default()(itemsResort.concat(result.data), "id"));
          setListResort(uniqBy_default()(itemsResort.concat(result.data), "id"));
        }
      } else {
        setItemsResort(uniqBy_default()(result.data, "id"));
        setListResort(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data30 = result.data) === null || _result$data30 === void 0 ? void 0 : _result$data30.length) <= 0) {
        setIsNoMoreDataResort(true);
      } else {
        setIsNoMoreDataResort(false);
      }
    });
  };

  var convertParamsAparthotel = function convertParamsAparthotel(isNextPage, category) {
    var tagFilters = [];
    var startDateFrom = null;
    var startDateTo = null;
    var sortByCharts = null;
    var isAnytime = null;
    var isUpcoming = null;
    var venueStatus = null;
    var amenities = null;

    if (filterCriteriaListOriginalAparthotel) {
      filterCriteriaListOriginalAparthotel.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList131, _item$selectedList132, _item$selectedList133;

          if (item.isDate && ((_item$selectedList131 = item.selectedList) !== null && _item$selectedList131 !== void 0 && _item$selectedList131.start || (_item$selectedList132 = item.selectedList) !== null && _item$selectedList132 !== void 0 && _item$selectedList132.isUpcoming || (_item$selectedList133 = item.selectedList) !== null && _item$selectedList133 !== void 0 && _item$selectedList133.isAnytime)) {
            var _item$selectedList134, _item$selectedList135, _item$selectedList136;

            if ((_item$selectedList134 = item.selectedList) !== null && _item$selectedList134 !== void 0 && _item$selectedList134.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList135 = item.selectedList) !== null && _item$selectedList135 !== void 0 && _item$selectedList135.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if ((_item$selectedList136 = item.selectedList) !== null && _item$selectedList136 !== void 0 && _item$selectedList136.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: config/* Constants.tagIds.TAG_ID_AGE */.gT.tagIds.TAG_ID_AGE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
              });
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_AMENITIES */.gT.tagCategory.TAG_CATEGORY_AMENITIES) {
            if (item.selectedList.length > 0) {
              amenities = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              var _item$selectedList137;

              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if ((_item$selectedList137 = item.selectedList) !== null && _item$selectedList137 !== void 0 && _item$selectedList137.filter(function (i) {
                return i > 800 && i < 900;
              })) {
                var _item$selectedList138;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE_2 */.gT.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: (_item$selectedList138 = item.selectedList) === null || _item$selectedList138 === void 0 ? void 0 : _item$selectedList138.filter(function (i) {
                    return i > 800 && i < 900;
                  })
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL,
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      venueStatus: venueStatus,
      amenities: amenities,
      keyword: keyword,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexAnimal - 1 : 0 : parseInt(currentPageIndex) - 1,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedAnimal,
      pageSize: pageSizeAnimal,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      dateSortType: isUpcoming ? config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING : null,
      sortType: sortByCharts || sortBy
    };
  };

  var getDataAparthotel = function getDataAparthotel(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataAparthotel) {
        return false;
      }

      setIsLoadingNextPageAparthotel(true);
    } else {
      setIsLoadingAparthotel(true);

      if (!isCountOnly) {
        setItemsAparthotel([]);
        setListAparthotel([]);
      }
    }

    var params = convertParamsAparthotel(isNextPage, category);
    DAO/* VenueDao.find */.eL.find(params).then(function (result) {
      var _result$data32;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL) {
          _category[index].count = result.totalCount;

          if (setCountAparthotel) {
            setCountAparthotel(result.totalCount);
          }
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPageAparthotel(false);
      setIsLoadingAparthotel(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexAparthotel((isNextPage ? pageIndexAparthotel : 1) + 1);
      }

      if (isNextPage) {
        var _result$data31;

        if (((_result$data31 = result.data) === null || _result$data31 === void 0 ? void 0 : _result$data31.length) > 0) {
          setItemsAparthotel(uniqBy_default()(itemsAparthotel.concat(result.data), "id"));
          setListAparthotel(uniqBy_default()(itemsAparthotel.concat(result.data), "id"));
        }
      } else {
        setItemsAparthotel(uniqBy_default()(result.data, "id"));
        setListAparthotel(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data32 = result.data) === null || _result$data32 === void 0 ? void 0 : _result$data32.length) <= 0) {
        setIsNoMoreDataAparthotel(true);
      } else {
        setIsNoMoreDataAparthotel(false);
      }
    });
  };

  var convertParamsVenueCocktail = function convertParamsVenueCocktail(isNextPage, category) {
    var tagFilters = [];
    var startDateFrom = null;
    var startDateTo = null;
    var sortByCharts = null;
    var isAnytime = null;
    var isUpcoming = null;
    var venueStatus = null;

    if (filterCriteriaListOriginalVenueCocktail) {
      filterCriteriaListOriginalVenueCocktail.forEach(function (item) {
        if (item.selectedList) {
          var _item$selectedList139, _item$selectedList140, _item$selectedList141;

          if (item.isDate && ((_item$selectedList139 = item.selectedList) !== null && _item$selectedList139 !== void 0 && _item$selectedList139.start || (_item$selectedList140 = item.selectedList) !== null && _item$selectedList140 !== void 0 && _item$selectedList140.isUpcoming || (_item$selectedList141 = item.selectedList) !== null && _item$selectedList141 !== void 0 && _item$selectedList141.isAnytime)) {
            var _item$selectedList142, _item$selectedList143, _item$selectedList144;

            if ((_item$selectedList142 = item.selectedList) !== null && _item$selectedList142 !== void 0 && _item$selectedList142.start) {
              startDateFrom = item.selectedList.start;
              startDateTo = item.selectedList.end;
            } else if ((_item$selectedList143 = item.selectedList) !== null && _item$selectedList143 !== void 0 && _item$selectedList143.isUpcoming) {
              startDateFrom = moment_default()().format("YYYY-MM-DD");
              startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              isUpcoming = true;
            } else if ((_item$selectedList144 = item.selectedList) !== null && _item$selectedList144 !== void 0 && _item$selectedList144.isAnytime) {
              isAnytime = true;
            }
          } else if (item.isAge) {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                tagId: config/* Constants.tagIds.TAG_ID_AGE */.gT.tagIds.TAG_ID_AGE,
                category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                maxValue: item.selectedList[1],
                unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
              });
            }
          } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
            if (item.selectedList.length > 0) {
              venueStatus = item.selectedList;
            }
          } else if (item.title === "Venue") {
            if (item.selectedList.length > 0) {
              var _item$selectedList145;

              // if (item.selectedList?.filter((i) => i > 700 && i < 800)) {
              //   tagFilters.push({
              //     category: Constants.tagCategory.TAG_CATEGORY_VENUE,
              //     tags: item.selectedList?.filter((i) => i > 700 && i < 800),
              //   });
              // }
              if ((_item$selectedList145 = item.selectedList) !== null && _item$selectedList145 !== void 0 && _item$selectedList145.filter(function (i) {
                return i > 800 && i < 900;
              })) {
                var _item$selectedList146;

                tagFilters.push({
                  category: config/* Constants.tagCategory.TAG_CATEGORY_VENUE_2 */.gT.tagCategory.TAG_CATEGORY_VENUE_2,
                  tags: (_item$selectedList146 = item.selectedList) === null || _item$selectedList146 === void 0 ? void 0 : _item$selectedList146.filter(function (i) {
                    return i > 800 && i < 900;
                  })
                });
              }
            }
          } else if (item.title === "Date" && isChartsMode) {
            if (item.selectedList.length > 0) {
              startDateFrom = moment_default()("".concat(item.selectedList[0], "-01-01")).format("YYYY-MM-DD");
              startDateTo = moment_default()("".concat(item.selectedList[0], "-12-31")).format("YYYY-MM-DD");
            }
          } else if (item.title === "Music" && isChartsMode) {
            if (item.selectedList.length > 0 && item.selectedList[0] !== 300) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          } else if (item.title === "Category" && isChartsMode) {
            if (item.selectedList.length > 0) {
              sortByCharts = item.selectedList[0];
            }
          } else {
            if (item.selectedList.length > 0) {
              tagFilters.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        }
      });
      tagFilters = JSON.stringify(tagFilters);
    }

    return {
      categoryType: config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL,
      startDateFrom: startDateFrom,
      startDateTo: startDateTo,
      isAnytime: isAnytime,
      venueStatus: venueStatus,
      keyword: keyword,
      pageIndex: isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP ? isNextPage ? pageIndexVenueCocktail - 1 : 0 : parseInt(currentPageIndex) - 1,
      tagFilters: tagFilters,
      filterFollowLogic: filterTabSelectedVenueCocktail,
      pageSize: pageSizeVenueCocktail,
      range: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id && (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance) > 0 ? locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance : null,
      distanceUnit: locationSelected !== null && locationSelected !== void 0 && locationSelected.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
      countryId: locationSelected !== null && locationSelected !== void 0 && locationSelected.country_id ? [locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id] : null,
      cityId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.city_id,
      stateId: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id,
      dateSortType: isUpcoming ? config/* Constants.dateFilterType.DATE_FILTER_UPCOMING */.gT.dateFilterType.DATE_FILTER_UPCOMING : null,
      sortType: sortByCharts || sortBy
    };
  };

  var getDataVenueCocktail = function getDataVenueCocktail(isNextPage, category, isCountOnly) {
    if (isNextPage) {
      if (isNoMoreDataVenueCocktail) {
        return false;
      }

      setIsLoadingNextPageVenueCocktail(true);
    } else {
      setIsLoadingVenueCocktail(true);

      if (!isCountOnly) {
        setItemsVenueCocktail([]);
        setListVenueCocktail([]);
      }
    }

    var params = convertParamsVenueCocktail(isNextPage, category);
    DAO/* VenueDao.find */.eL.find(params).then(function (result) {
      var _result$data34;

      var _category = category;

      _category.forEach(function (item, index) {
        if (item.id === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL) {
          _category[index].count = result.totalCount;

          if (setCountVenueCocktail) {
            setCountVenueCocktail(result.totalCount);
          }
        }
      });

      setCategoryList(_category);
      setIsLoadingNextPageVenueCocktail(false);
      setIsLoadingVenueCocktail(false);

      if (isCountOnly) {
        return false;
      }

      if (isEnabledInfiniteScroll || passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP) {
        setPageIndexVenueCocktail((isNextPage ? pageIndexVenueCocktail : 1) + 1);
      }

      if (isNextPage) {
        var _result$data33;

        if (((_result$data33 = result.data) === null || _result$data33 === void 0 ? void 0 : _result$data33.length) > 0) {
          setItemsVenueCocktail(uniqBy_default()(itemsVenueCocktail.concat(result.data), "id"));
          setListVenueCocktail(uniqBy_default()(itemsVenueCocktail.concat(result.data), "id"));
        }
      } else {
        setItemsVenueCocktail(uniqBy_default()(result.data, "id"));
        setListVenueCocktail(uniqBy_default()(result.data, "id"));
      }

      if (((_result$data34 = result.data) === null || _result$data34 === void 0 ? void 0 : _result$data34.length) <= 0) {
        setIsNoMoreDataVenueCocktail(true);
      } else {
        setIsNoMoreDataVenueCocktail(false);
      }
    });
  };

  var loadItems = function loadItems(isNextPage, category, isPartialLoad) {
    if (isMobileVersion) {
      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL && "Rooftops".split(",").find(function (i) {
        return i === "Festivals";
      })) {
        if (false) {}
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT && "Rooftops".split(",").find(function (i) {
        return i === "Events";
      })) {
        if (false) {}
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST && "Rooftops".split(",").find(function (i) {
        return i === "Artists";
      })) {
        if (false) {}
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE && "Rooftops".split(",").find(function (i) {
        return i === "Venues";
      })) {
        if (false) {}
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP && "Rooftops".split(",").find(function (i) {
        return i === "Rooftops";
      })) {
        if (true) {
          getDataRooftop(isNextPage, category, false);
        }
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA && "Rooftops".split(",").find(function (i) {
        return i === "Spas";
      })) {
        if (false) {}
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL && "Rooftops".split(",").find(function (i) {
        return i === "Venue Beachful";
      })) {
        if (false) {}
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY && "Rooftops".split(",").find(function (i) {
        return i === "Prefab Company";
      })) {
        if (false) {}
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES && "Rooftops".split(",").find(function (i) {
        return i === "Prefab Home";
      })) {
        if (false) {}
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO && "Rooftops".split(",").find(function (i) {
        return i === "Zoos";
      })) {
        if (false) {}
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL && "Rooftops".split(",").find(function (i) {
        return i === "Animals";
      })) {
        if (false) {}
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL && "Rooftops".split(",").find(function (i) {
        return i === "Parks";
      })) {
        if (false) {}
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO && "Rooftops".split(",").find(function (i) {
        return i === "Casinos";
      })) {
        if (false) {}
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE && "Rooftops".split(",").find(function (i) {
        return i === "Castles";
      })) {
        if (false) {}
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT && "Rooftops".split(",").find(function (i) {
        return i === "Resorts";
      })) {
        if (false) {}
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL && "Rooftops".split(",").find(function (i) {
        return i === "Aparthotels";
      })) {
        if (false) {}
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL && "Rooftops".split(",").find(function (i) {
        return i === "Venue Cocktail";
      })) {
        if (false) {}
      }
    } else {
      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL && "Rooftops".split(",").find(function (i) {
        return i === "Festivals";
      })) {
        getDataFestival(isNextPage, category);
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT && "Rooftops".split(",").find(function (i) {
        return i === "Events";
      })) {
        getDataEvent(isNextPage, category);
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST && "Rooftops".split(",").find(function (i) {
        return i === "Artists";
      })) {
        getDataArtist(isNextPage, category);
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE && "Rooftops".split(",").find(function (i) {
        return i === "Venues";
      })) {
        getDataVenue(isNextPage, category);
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP && "Rooftops".split(",").find(function (i) {
        return i === "Rooftops";
      })) {
        getDataRooftop(isNextPage, category);
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA && "Rooftops".split(",").find(function (i) {
        return i === "Spas";
      })) {
        getDataSpa(isNextPage, category);
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL && "Rooftops".split(",").find(function (i) {
        return i === "Venue Beachful";
      })) {
        getDataVenueBeachful(isNextPage, category);
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY && "Rooftops".split(",").find(function (i) {
        return i === "Prefab Company";
      })) {
        getDataPrefabCompany(isNextPage, category);
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES && "Rooftops".split(",").find(function (i) {
        return i === "Prefab Home";
      })) {
        getDataPrefabHome(isNextPage, category);
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO && "Rooftops".split(",").find(function (i) {
        return i === "Zoos";
      })) {
        getDataZoo(isNextPage, category);
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL && "Rooftops".split(",").find(function (i) {
        return i === "Animals";
      })) {
        getDataAnimal(isNextPage, category);
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL && "Rooftops".split(",").find(function (i) {
        return i === "Parks";
      })) {
        getDataParkful(isNextPage, category);
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO && "Rooftops".split(",").find(function (i) {
        return i === "Casinos";
      })) {
        getDataCasino(isNextPage, category);
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE && "Rooftops".split(",").find(function (i) {
        return i === "Castles";
      })) {
        getDataCastle(isNextPage, category);
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT && "Rooftops".split(",").find(function (i) {
        return i === "Resorts";
      })) {
        getDataResort(isNextPage, category);
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL && "Rooftops".split(",").find(function (i) {
        return i === "Aparthotels";
      })) {
        getDataAparthotel(isNextPage, category);
      }

      if (isPartialLoad && dataCategory == config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL && "Rooftops".split(",").find(function (i) {
        return i === "Venue Cocktail";
      })) {
        getDataVenueCocktail(isNextPage, category);
      }
    }
  }; // Search keyword change


  (0,react.useEffect)(function () {
    var delayDebounceFn = setTimeout(function () {
      if (!isInitialized || keyword) {
        if (keyword !== "") {
          onLoad();
        }
      }
    }, 500);
    return function () {
      return clearTimeout(delayDebounceFn);
    };
  }, [keyword, isInitialized]); // Non mobile version load

  (0,react.useEffect)(function () {
    if (!isInitialized && sortBy && !isMobileVersion) {
      onLoad();
    }
  }, [sortBy, currentPageIndex, isInitialized, isMobileVersion, dataCategory, JSON.stringify(locationSelected)]); // Mobile version load

  (0,react.useEffect)(function () {
    if (!isInitialized && sortBy && isMobileVersion) {
      onLoad();
    }
  }, [sortBy, currentPageIndex, isInitialized, isMobileVersion, dataCategory, JSON.stringify(locationSelected)]); // Filter Criteria Change

  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalFestival) {
      onLoad();
    }
  }, [filterCriteriaListOriginalFestival]);
  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalEvent) {
      onLoad();
    }
  }, [filterCriteriaListOriginalEvent]);
  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalArtist) {
      onLoad();
    }
  }, [filterCriteriaListOriginalArtist]);
  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalVenue) {
      onLoad();
    }
  }, [filterCriteriaListOriginalVenue]);
  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalRooftop) {
      onLoad();
    }
  }, [filterCriteriaListOriginalRooftop]);
  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalSpa) {
      onLoad();
    }
  }, [filterCriteriaListOriginalSpa]);
  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalVenueBeachful) {
      onLoad();
    }
  }, [filterCriteriaListOriginalVenueBeachful]);
  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalPrefabCompany) {
      onLoad();
    }
  }, [filterCriteriaListOriginalPrefabCompany]);
  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalPrefabHome) {
      onLoad();
    }
  }, [filterCriteriaListOriginalPrefabHome]);
  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalZoo) {
      onLoad();
    }
  }, [filterCriteriaListOriginalZoo]);
  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalAnimal) {
      onLoad();
    }
  }, [filterCriteriaListOriginalAnimal]);
  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalParkful) {
      onLoad();
    }
  }, [filterCriteriaListOriginalParkful]);
  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalCasino) {
      onLoad();
    }
  }, [filterCriteriaListOriginalCasino]);
  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalCastle) {
      onLoad();
    }
  }, [filterCriteriaListOriginalCastle]);
  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalResort) {
      onLoad();
    }
  }, [filterCriteriaListOriginalResort]);
  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalAparthotel) {
      onLoad();
    }
  }, [filterCriteriaListOriginalAparthotel]);
  (0,react.useEffect)(function () {
    if (filterCriteriaListOriginalVenueCocktail) {
      onLoad();
    }
  }, [filterCriteriaListOriginalVenueCocktail]);
  var showPageList = 1000;
  var totalPage = dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? Math.ceil((countFestival > 100 && isChartsMode ? 100 : countFestival) / pageSizeFestival) : dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? Math.ceil((countEvent > 100 && isChartsMode ? 100 : countEvent) / pageSizeEvent) : dataCategory === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? Math.ceil((countArtist > 100 && isChartsMode ? 100 : countArtist) / pageSizeArtist) : dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP ? Math.ceil((countRooftop > 100 && isChartsMode ? 100 : countRooftop) / pageSizeRooftop) : dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA ? Math.ceil((countSpa > 100 && isChartsMode ? 100 : countSpa) / pageSizeSpa) : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL ? Math.ceil((countVenueBeachful > 100 && isChartsMode ? 100 : countVenueBeachful) / pageSizeVenueBeachful) : dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? Math.ceil((countPrefabCompany > 100 && isChartsMode ? 100 : countPrefabCompany) / pageSizePrefabCompany) : dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES ? Math.ceil((countPrefabHome > 100 && isChartsMode ? 100 : countPrefabHome) / pageSizePrefabHome) : dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO ? Math.ceil((countZoo > 100 && isChartsMode ? 100 : countZoo) / pageSizeZoo) : dataCategory === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? Math.ceil((countAnimal > 100 && isChartsMode ? 100 : countAnimal) / pageSizeAnimal) : dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? Math.ceil((countParkful > 100 && isChartsMode ? 100 : countParkful) / pageSizeParkful) : dataCategory === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO ? Math.ceil((countCasino > 100 && isChartsMode ? 100 : countCasino) / pageSizeCasino) : dataCategory === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE ? Math.ceil((countCastle > 100 && isChartsMode ? 100 : countCastle) / pageSizeCastle) : dataCategory === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT ? Math.ceil((countResort > 100 && isChartsMode ? 100 : countResort) / pageSizeResort) : dataCategory === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL ? Math.ceil((countAparthotel > 100 && isChartsMode ? 100 : countAparthotel) / pageSizeAparthotel) : dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? Math.ceil((countVenueCocktail > 100 && isChartsMode ? 100 : countVenueCocktail) / pageSizeVenueCocktail) : Math.ceil((countVenue > 100 && isChartsMode ? 100 : countVenue) / pageSizeVenue);
  var startPage = parseInt(currentPageIndex) - showPageList <= 0 ? 1 : parseInt(currentPageIndex) - showPageList;
  var endPage = parseInt(currentPageIndex) + showPageList > totalPage ? totalPage : parseInt(currentPageIndex) + showPageList;
  var nextPage = parseInt(currentPageIndex) + 1 > totalPage ? totalPage : parseInt(currentPageIndex) + 1;
  var prevPage = parseInt(currentPageIndex) - 1 < 1 ? 1 : parseInt(currentPageIndex) - 1;
  (0,react.useEffect)(function () {
    var _pageScrollRef$curren;

    (_pageScrollRef$curren = pageScrollRef.current) === null || _pageScrollRef$curren === void 0 ? void 0 : _pageScrollRef$curren.scrollIntoView();
  }, [isOpenPage]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
    style: explore_search_styles.background,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: explore_search_styles.background,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* StatusBar */.A_, {}), dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsFestival,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageFestival,
          isLoading: isLoadingFestival,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingFestival ? getDataFestival(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingFestival ? getDataFestival(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeFestival
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsFestival,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageFestival,
          isLoading: isLoadingFestival,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingFestival ? getDataFestival(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingFestival ? getDataFestival(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeFestival
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_PopularListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsArtist: convertParamsArtist(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
            isChartsMode: isChartsMode,
            mapFocused: props.mapFocused,
            setMapFocused: props.setMapFocused,
            horizontal: false,
            gridView: true,
            mapView: true,
            items: itemsFestival,
            category: dataCategory,
            style: {
              marginTop: 16
            } // onItemAction={({ type, item }) =>
            //   onItemAction({ type, item })
            // }
            ,
            isLoadingNextPage: isLoadingNextPageFestival,
            isLoading: isLoadingFestival,
            isExploreSearch: true,
            onRefresh: function onRefresh() {
              return !isLoadingFestival ? getDataFestival(false, categoryList) : null;
            },
            onLoadMore: function onLoadMore() {
              return !isLoadingFestival ? getDataFestival(true, categoryList) : null;
            },
            gapHeight: 150,
            currentPageIndex: parseInt(currentPageIndex) * pageSizeFestival
          })
        }), isLoadingFestival && pageIndexFestival > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), dataCategory === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsEvent,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageEvent,
          isLoading: isLoadingEvent,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingEvent ? getDataEvent(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingEvent ? getDataEvent(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeEvent
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsEvent,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageEvent,
          isLoading: isLoadingEvent,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingEvent ? getDataEvent(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingEvent ? getDataEvent(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeEvent
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_PopularListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginaPrefabCompany: filterCriteriaListOriginaPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
            isChartsMode: isChartsMode,
            mapFocused: props.mapFocused,
            setMapFocused: props.setMapFocused,
            horizontal: false,
            gridView: true,
            mapView: true,
            items: itemsEvent,
            category: dataCategory,
            style: {
              marginTop: 16
            } // onItemAction={({ type, item }) =>
            //   onItemAction({ type, item })
            // }
            ,
            isLoadingNextPage: isLoadingNextPageEvent,
            isLoading: isLoadingEvent,
            isExploreSearch: true,
            onRefresh: function onRefresh() {
              return !isLoadingEvent ? getDataEvent(false, categoryList) : null;
            },
            onLoadMore: function onLoadMore() {
              return !isLoadingEvent ? getDataEvent(true, categoryList) : null;
            },
            gapHeight: 150,
            currentPageIndex: parseInt(currentPageIndex) * pageSizeEvent
          })
        }), isLoadingEvent && pageIndexEvent > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), dataCategory === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsArtist,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageArtist,
          isLoading: isLoadingArtist,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingArtist ? getDataArtist(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingArtist ? getDataArtist(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeArtist
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsArtist,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageArtist,
          isLoading: isLoadingArtist,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingArtist ? getDataArtist(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingArtist ? getDataArtist(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeArtist
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_PopularListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsArtist: convertParamsArtist(),
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsCAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsArtist: convertParamsArtist(),
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), isLoadingArtist && pageIndexArtist > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), dataCategory === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsVenue,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageVenue,
          isLoading: isLoadingVenue,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingVenue ? getDataVenue(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingVenue ? getDataVenue(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeVenue
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsVenue,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageVenue,
          isLoading: isLoadingVenue,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingVenue ? getDataVenue(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingVenue ? getDataVenue(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeVenue
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_RecommendedListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
            isChartsMode: isChartsMode,
            mapFocused: props.mapFocused,
            setMapFocused: props.setMapFocused,
            horizontal: false,
            gridView: true,
            mapView: true,
            items: itemsVenue,
            category: dataCategory,
            style: {
              marginTop: 16
            } // onItemAction={({ type, item }) =>
            //   onItemAction({ type, item })
            // }
            ,
            isLoadingNextPage: isLoadingNextPageVenue,
            isLoading: isLoadingVenue,
            isExploreSearch: true,
            onRefresh: function onRefresh() {
              return !isLoadingVenue ? getDataVenue(false, categoryList) : null;
            },
            onLoadMore: function onLoadMore() {
              return !isLoadingVenue ? getDataVenue(true, categoryList) : null;
            },
            gapHeight: 150,
            currentPageIndex: parseInt(currentPageIndex) * pageSizeVenue
          })
        }), isLoadingVenue && pageIndexVenue > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsRooftop,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageRooftop,
          isLoading: isLoadingRooftop,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingRooftop ? getDataRooftop(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingRooftop ? getDataRooftop(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeRooftop
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsRooftop,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageRooftop,
          isLoading: isLoadingRooftop,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingRooftop ? getDataRooftop(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingRooftop ? getDataRooftop(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeRooftop
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_RecommendedListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
            isChartsMode: isChartsMode,
            mapFocused: props.mapFocused,
            setMapFocused: props.setMapFocused,
            horizontal: false,
            gridView: true,
            mapView: true,
            items: itemsRooftop,
            category: dataCategory,
            style: {
              marginTop: 16
            } // onItemAction={({ type, item }) =>
            //   onItemAction({ type, item })
            // }
            ,
            isLoadingNextPage: isLoadingNextPageRooftop,
            isLoading: isLoadingRooftop,
            isExploreSearch: true,
            onRefresh: function onRefresh() {
              return !isLoadingRooftop ? getDataRooftop(false, categoryList) : null;
            },
            onLoadMore: function onLoadMore() {
              return !isLoadingRooftop ? getDataRooftop(true, categoryList) : null;
            },
            gapHeight: 150,
            currentPageIndex: parseInt(currentPageIndex) * pageSizeRooftop
          })
        }), isLoadingRooftop && pageIndexRooftop > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsSpa,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageSpa,
          isLoading: isLoadingSpa,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingSpa ? getDataSpa(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingSpa ? getDataSpa(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeSpa
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsSpa,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageSpa,
          isLoading: isLoadingSpa,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingSpa ? getDataSpa(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingSpa ? getDataSpa(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeSpa
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_RecommendedListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
            isChartsMode: isChartsMode,
            mapFocused: props.mapFocused,
            setMapFocused: props.setMapFocused,
            horizontal: false,
            gridView: true,
            mapView: true,
            items: itemsSpa,
            category: dataCategory,
            style: {
              marginTop: 16
            } // onItemAction={({ type, item }) =>
            //   onItemAction({ type, item })
            // }
            ,
            isLoadingNextPage: isLoadingNextPageSpa,
            isLoading: isLoadingSpa,
            isExploreSearch: true,
            onRefresh: function onRefresh() {
              return !isLoadingSpa ? getDataSpa(false, categoryList) : null;
            },
            onLoadMore: function onLoadMore() {
              return !isLoadingSpa ? getDataSpa(true, categoryList) : null;
            },
            gapHeight: 150,
            currentPageIndex: parseInt(currentPageIndex) * pageSizeSpa
          })
        }), isLoadingSpa && pageIndexSpa > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsVenueBeachful,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageVenueBeachful,
          isLoading: isLoadingVenueBeachful,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingVenueBeachful ? getDataVenueBeachful(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingVenueBeachful ? getDataVenueBeachful(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeVenueBeachful
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsVenueBeachful,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageVenueBeachful,
          isLoading: isLoadingVenueBeachful,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingVenueBeachful ? getDataVenueBeachful(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingVenueBeachful ? getDataVenueBeachful(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeVenueBeachful
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_RecommendedListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
            isChartsMode: isChartsMode,
            mapFocused: props.mapFocused,
            setMapFocused: props.setMapFocused,
            horizontal: false,
            gridView: true,
            mapView: true,
            items: itemsVenueBeachful,
            category: dataCategory,
            style: {
              marginTop: 16
            } // onItemAction={({ type, item }) =>
            //   onItemAction({ type, item })
            // }
            ,
            isLoadingNextPage: isLoadingNextPageVenueBeachful,
            isLoading: isLoadingVenueBeachful,
            isExploreSearch: true,
            onRefresh: function onRefresh() {
              return !isLoadingVenueBeachful ? getDataVenueBeachful(false, categoryList) : null;
            },
            onLoadMore: function onLoadMore() {
              return !isLoadingVenueBeachful ? getDataVenueBeachful(true, categoryList) : null;
            },
            gapHeight: 150,
            currentPageIndex: parseInt(currentPageIndex) * pageSizeVenueBeachful
          })
        }), isLoadingVenueBeachful && pageIndexVenueBeachful > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsPrefabCompany,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPagePrefabCompany,
          isLoading: isLoadingPrefabCompany,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingPrefabCompany ? getDataPrefabCompany(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingPrefabCompany ? getDataPrefabCompany(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizePrefabCompany
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsPrefabCompany,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPagePrefabCompany,
          isLoading: isLoadingPrefabCompany,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingPrefabCompany ? getDataPrefabCompany(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingPrefabCompany ? getDataPrefabCompany(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizePrefabCompany
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_RecommendedListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
            isChartsMode: isChartsMode,
            mapFocused: props.mapFocused,
            setMapFocused: props.setMapFocused,
            horizontal: false,
            gridView: true,
            mapView: true,
            items: itemsPrefabCompany,
            category: dataCategory,
            style: {
              marginTop: 16
            } // onItemAction={({ type, item }) =>
            //   onItemAction({ type, item })
            // }
            ,
            isLoadingNextPage: isLoadingNextPagePrefabCompany,
            isLoading: isLoadingPrefabCompany,
            isExploreSearch: true,
            onRefresh: function onRefresh() {
              return !isLoadingPrefabCompany ? getDataPrefabCompany(false, categoryList) : null;
            },
            onLoadMore: function onLoadMore() {
              return !isLoadingPrefabCompany ? getDataPrefabCompany(true, categoryList) : null;
            },
            gapHeight: 150,
            currentPageIndex: parseInt(currentPageIndex) * pageSizePrefabCompany
          })
        }), isLoadingPrefabCompany && pageIndexPrefabCompany > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsPrefabHome,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPagePrefabHome,
          isLoading: isLoadingPrefabHome,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingPrefabHome ? getDataPrefabHome(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingPrefabHome ? getDataPrefabHome(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizePrefabHome
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsPrefabHome,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPagePrefabHome,
          isLoading: isLoadingPrefabHome,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingPrefabHome ? getDataPrefabHome(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingPrefabHome ? getDataPrefabHome(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizePrefabHome
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_RecommendedListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
            isChartsMode: isChartsMode,
            mapFocused: props.mapFocused,
            setMapFocused: props.setMapFocused,
            horizontal: false,
            gridView: true,
            mapView: true,
            items: itemsPrefabHome,
            category: dataCategory,
            style: {
              marginTop: 16
            } // onItemAction={({ type, item }) =>
            //   onItemAction({ type, item })
            // }
            ,
            isLoadingNextPage: isLoadingNextPagePrefabHome,
            isLoading: isLoadingPrefabHome,
            isExploreSearch: true,
            onRefresh: function onRefresh() {
              return !isLoadingPrefabHome ? getDataPrefabHome(false, categoryList) : null;
            },
            onLoadMore: function onLoadMore() {
              return !isLoadingPrefabHome ? getDataPrefabHome(true, categoryList) : null;
            },
            gapHeight: 150,
            currentPageIndex: parseInt(currentPageIndex) * pageSizePrefabHome
          })
        }), isLoadingPrefabHome && pageIndexPrefabHome > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsZoo,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageZoo,
          isLoading: isLoadingZoo,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingZoo ? getDataZoo(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingZoo ? getDataZoo(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeZoo
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsZoo,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageZoo,
          isLoading: isLoadingZoo,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingZoo ? getDataZoo(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingZoo ? getDataZoo(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeZoo
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_RecommendedListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsAnimal: convertParamsAnimal(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsAnimal: convertParamsAnimal(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
            isChartsMode: isChartsMode,
            mapFocused: props.mapFocused,
            setMapFocused: props.setMapFocused,
            horizontal: false,
            gridView: true,
            mapView: true,
            items: itemsZoo,
            category: dataCategory,
            style: {
              marginTop: 16
            } // onItemAction={({ type, item }) =>
            //   onItemAction({ type, item })
            // }
            ,
            isLoadingNextPage: isLoadingNextPageZoo,
            isLoading: isLoadingZoo,
            isExploreSearch: true,
            onRefresh: function onRefresh() {
              return !isLoadingZoo ? getDataZoo(false, categoryList) : null;
            },
            onLoadMore: function onLoadMore() {
              return !isLoadingZoo ? getDataZoo(true, categoryList) : null;
            },
            gapHeight: 150,
            currentPageIndex: parseInt(currentPageIndex) * pageSizeZoo
          })
        }), isLoadingZoo && pageIndexZoo > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), dataCategory === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsAnimal,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageAnimal,
          isLoading: isLoadingAnimal,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingAnimal ? getDataAnimal(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingAnimal ? getDataAnimal(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeAnimal
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsAnimal,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageAnimal,
          isLoading: isLoadingAnimal,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingAnimal ? getDataAnimal(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingAnimal ? getDataAnimal(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeAnimal
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_RecommendedListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsAnimal: convertParamsAnimal(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsAnimal: convertParamsAnimal(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
            isChartsMode: isChartsMode,
            mapFocused: props.mapFocused,
            setMapFocused: props.setMapFocused,
            horizontal: false,
            gridView: true,
            mapView: true,
            items: itemsAnimal,
            category: dataCategory,
            style: {
              marginTop: 16
            } // onItemAction={({ type, item }) =>
            //   onItemAction({ type, item })
            // }
            ,
            isLoadingNextPage: isLoadingNextPageAnimal,
            isLoading: isLoadingAnimal,
            isExploreSearch: true,
            onRefresh: function onRefresh() {
              return !isLoadingAnimal ? getDataAnimal(false, categoryList) : null;
            },
            onLoadMore: function onLoadMore() {
              return !isLoadingAnimal ? getDataAnimal(true, categoryList) : null;
            },
            gapHeight: 150,
            currentPageIndex: parseInt(currentPageIndex) * pageSizeAnimal
          })
        }), isLoadingAnimal && pageIndexAnimal > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsParkful,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageParkful,
          isLoading: isLoadingParkful,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingParkful ? getDataParkful(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingParkful ? getDataParkful(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeParkful
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsParkful,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageParkful,
          isLoading: isLoadingParkful,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingParkful ? getDataParkful(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingParkful ? getDataParkful(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeParkful
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_RecommendedListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsAnimal: convertParamsAnimal(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsAnimal: convertParamsAnimal(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
            isChartsMode: isChartsMode,
            mapFocused: props.mapFocused,
            setMapFocused: props.setMapFocused,
            horizontal: false,
            gridView: true,
            mapView: true,
            items: itemsParkful,
            category: dataCategory,
            style: {
              marginTop: 16
            } // onItemAction={({ type, item }) =>
            //   onItemAction({ type, item })
            // }
            ,
            isLoadingNextPage: isLoadingNextPageParkful,
            isLoading: isLoadingParkful,
            isExploreSearch: true,
            onRefresh: function onRefresh() {
              return !isLoadingParkful ? getDataParkful(false, categoryList) : null;
            },
            onLoadMore: function onLoadMore() {
              return !isLoadingParkful ? getDataParkful(true, categoryList) : null;
            },
            gapHeight: 150,
            currentPageIndex: parseInt(currentPageIndex) * pageSizeParkful
          })
        }), isLoadingParkful && pageIndexParkful > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), dataCategory === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsCasino,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageCasino,
          isLoading: isLoadingCasino,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingCasino ? getDataCasino(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingCasino ? getDataCasino(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeCasino
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsCasino,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageCasino,
          isLoading: isLoadingCasino,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingCasino ? getDataCasino(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingCasino ? getDataCasino(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeCasino
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_RecommendedListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsAnimal: convertParamsAnimal(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsAnimal: convertParamsAnimal(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
            isChartsMode: isChartsMode,
            mapFocused: props.mapFocused,
            setMapFocused: props.setMapFocused,
            horizontal: false,
            gridView: true,
            mapView: true,
            items: itemsCasino,
            category: dataCategory,
            style: {
              marginTop: 16
            } // onItemAction={({ type, item }) =>
            //   onItemAction({ type, item })
            // }
            ,
            isLoadingNextPage: isLoadingNextPageCasino,
            isLoading: isLoadingCasino,
            isExploreSearch: true,
            onRefresh: function onRefresh() {
              return !isLoadingCasino ? getDataCasino(false, categoryList) : null;
            },
            onLoadMore: function onLoadMore() {
              return !isLoadingCasino ? getDataCasino(true, categoryList) : null;
            },
            gapHeight: 150,
            currentPageIndex: parseInt(currentPageIndex) * pageSizeCasino
          })
        }), isLoadingCasino && pageIndexCasino > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), dataCategory === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsCastle,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageCastle,
          isLoading: isLoadingCastle,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingCastle ? getDataCastle(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingCastle ? getDataCastle(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeCastle
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsCastle,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageCastle,
          isLoading: isLoadingCastle,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingCastle ? getDataCastle(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingCastle ? getDataCastle(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeCastle
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_RecommendedListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsAnimal: convertParamsAnimal(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsAnimal: convertParamsAnimal(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
            isChartsMode: isChartsMode,
            mapFocused: props.mapFocused,
            setMapFocused: props.setMapFocused,
            horizontal: false,
            gridView: true,
            mapView: true,
            items: itemsCastle,
            category: dataCategory,
            style: {
              marginTop: 16
            } // onItemAction={({ type, item }) =>
            //   onItemAction({ type, item })
            // }
            ,
            isLoadingNextPage: isLoadingNextPageCastle,
            isLoading: isLoadingCastle,
            isExploreSearch: true,
            onRefresh: function onRefresh() {
              return !isLoadingCastle ? getDataCastle(false, categoryList) : null;
            },
            onLoadMore: function onLoadMore() {
              return !isLoadingCastle ? getDataCastle(true, categoryList) : null;
            },
            gapHeight: 150,
            currentPageIndex: parseInt(currentPageIndex) * pageSizeCastle
          })
        }), isLoadingCastle && pageIndexCastle > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), dataCategory === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsResort,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageResort,
          isLoading: isLoadingResort,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingResort ? getDataResort(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingResort ? getDataResort(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeResort
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsResort,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageResort,
          isLoading: isLoadingResort,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingResort ? getDataResort(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingResort ? getDataResort(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeResort
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_RecommendedListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsAnimal: convertParamsAnimal(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsAnimal: convertParamsAnimal(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
            isChartsMode: isChartsMode,
            mapFocused: props.mapFocused,
            setMapFocused: props.setMapFocused,
            horizontal: false,
            gridView: true,
            mapView: true,
            items: itemsResort,
            category: dataCategory,
            style: {
              marginTop: 16
            } // onItemAction={({ type, item }) =>
            //   onItemAction({ type, item })
            // }
            ,
            isLoadingNextPage: isLoadingNextPageResort,
            isLoading: isLoadingResort,
            isExploreSearch: true,
            onRefresh: function onRefresh() {
              return !isLoadingResort ? getDataResort(false, categoryList) : null;
            },
            onLoadMore: function onLoadMore() {
              return !isLoadingResort ? getDataResort(true, categoryList) : null;
            },
            gapHeight: 150,
            currentPageIndex: parseInt(currentPageIndex) * pageSizeResort
          })
        }), isLoadingResort && pageIndexResort > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), dataCategory === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsAparthotel,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageAparthotel,
          isLoading: isLoadingAparthotel,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingAparthotel ? getDataAparthotel(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingAparthotel ? getDataAparthotel(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeAparthotel
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsAparthotel,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageAparthotel,
          isLoading: isLoadingAparthotel,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingAparthotel ? getDataAparthotel(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingAparthotel ? getDataAparthotel(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeAparthotel
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_RecommendedListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsAnimal: convertParamsAnimal(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsAnimal: convertParamsAnimal(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
            isChartsMode: isChartsMode,
            mapFocused: props.mapFocused,
            setMapFocused: props.setMapFocused,
            horizontal: false,
            gridView: true,
            mapView: true,
            items: itemsAparthotel,
            category: dataCategory,
            style: {
              marginTop: 16
            } // onItemAction={({ type, item }) =>
            //   onItemAction({ type, item })
            // }
            ,
            isLoadingNextPage: isLoadingNextPageAparthotel,
            isLoading: isLoadingAparthotel,
            isExploreSearch: true,
            onRefresh: function onRefresh() {
              return !isLoadingAparthotel ? getDataAparthotel(false, categoryList) : null;
            },
            onLoadMore: function onLoadMore() {
              return !isLoadingAparthotel ? getDataAparthotel(true, categoryList) : null;
            },
            gapHeight: 150,
            currentPageIndex: parseInt(currentPageIndex) * pageSizeAparthotel
          })
        }), isLoadingAparthotel && pageIndexAparthotel > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [passViewMode === config/* Constants.viewType.VIEW_TYPE_GRID */.gT.viewType.VIEW_TYPE_GRID && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: true,
          items: itemsVenueCocktail,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageVenueCocktail,
          isLoading: isLoadingVenueCocktail,
          isExploreSearch: true,
          onRefresh: function onRefresh() {
            return !isLoadingVenueCocktail ? getDataVenueCocktail(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingVenueCocktail ? getDataVenueCocktail(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeVenueCocktail
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_LIST */.gT.viewType.VIEW_TYPE_LIST && /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
          isChartsMode: isChartsMode,
          horizontal: false,
          gridView: false,
          items: itemsVenueCocktail,
          category: dataCategory,
          style: {
            marginTop: 16
          } // onItemAction={({ type, item }) => onItemAction({ type, item })}
          ,
          isLoadingNextPage: isLoadingNextPageVenueCocktail,
          isLoading: isLoadingVenueCocktail,
          isExploreSearch: true,
          isMobileVersion: isMobileVersion,
          onRefresh: function onRefresh() {
            return !isLoadingVenueCocktail ? getDataVenueCocktail(false, categoryList) : null;
          },
          onLoadMore: function onLoadMore() {
            return !isLoadingVenueCocktail ? getDataVenueCocktail(true, categoryList) : null;
          },
          disabledInfiniteScroll: !isEnabledInfiniteScroll,
          gapHeight: 0,
          currentPageIndex: (parseInt(currentPageIndex) - 1) * pageSizeVenueCocktail
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "overflow-hidden mr-0 ".concat(contentWidth),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers_RecommendedListSectionContainer, {
            style: {
              marginBottom: 20,
              marginTop: 35
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsAnimal: convertParamsAnimal(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(containers_TrendingListSectionContainer, {
            style: {
              marginBottom: 20
            },
            category: dataCategory,
            locationSelected: locationSelected,
            paramsFestival: convertParamsFestival(),
            paramsEvent: convertParamsEvent(),
            paramsArtist: convertParamsArtist(),
            paramsVenue: convertParamsVenue(),
            paramsRooftop: convertParamsRooftop(),
            paramsSpa: convertParamsSpa(),
            paramsVenueBeachful: convertParamsVenueBeachful(),
            paramsPrefabCompany: convertParamsPrefabCompany(),
            paramsPrefabHome: convertParamsPrefabHome(),
            paramsZoo: convertParamsZoo(),
            paramsAnimal: convertParamsAnimal(),
            paramsParkful: convertParamsParkful(),
            paramsCasino: convertParamsCasino(),
            paramsCastle: convertParamsCastle(),
            paramsResort: convertParamsResort(),
            paramsAparthotel: convertParamsAparthotel(),
            paramsVenueCocktail: convertParamsVenueCocktail(),
            filterCriteriaListOriginalFestival: filterCriteriaListOriginalFestival,
            filterCriteriaListOriginalEvent: filterCriteriaListOriginalEvent,
            filterCriteriaListOriginalArtist: filterCriteriaListOriginalArtist,
            filterCriteriaListOriginalVenue: filterCriteriaListOriginalVenue,
            filterCriteriaListOriginalRooftop: filterCriteriaListOriginalRooftop,
            filterCriteriaListOriginalSpa: filterCriteriaListOriginalSpa,
            filterCriteriaListOriginalVenueBeachful: filterCriteriaListOriginalVenueBeachful,
            filterCriteriaListOriginalPrefabCompany: filterCriteriaListOriginalPrefabCompany,
            filterCriteriaListOriginalPrefabHome: filterCriteriaListOriginalPrefabHome,
            filterCriteriaListOriginalZoo: filterCriteriaListOriginalZoo,
            filterCriteriaListOriginalAnimal: filterCriteriaListOriginalAnimal,
            filterCriteriaListOriginalParkful: filterCriteriaListOriginalParkful,
            filterCriteriaListOriginalCasino: filterCriteriaListOriginalCasino,
            filterCriteriaListOriginalCastle: filterCriteriaListOriginalCastle,
            filterCriteriaListOriginalResort: filterCriteriaListOriginalResort,
            filterCriteriaListOriginalAparthotel: filterCriteriaListOriginalAparthotel,
            filterCriteriaListOriginalVenueCocktail: filterCriteriaListOriginalVenueCocktail,
            isChartsMode: isChartsMode
          })]
        }), passViewMode === config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* CardList */.CS, {
            isChartsMode: isChartsMode,
            mapFocused: props.mapFocused,
            setMapFocused: props.setMapFocused,
            horizontal: false,
            gridView: true,
            mapView: true,
            items: itemsVenueCocktail,
            category: dataCategory,
            style: {
              marginTop: 16
            } // onItemAction={({ type, item }) =>
            //   onItemAction({ type, item })
            // }
            ,
            isLoadingNextPage: isLoadingNextPageVenueCocktail,
            isLoading: isLoadingVenueCocktail,
            isExploreSearch: true,
            onRefresh: function onRefresh() {
              return !isLoadingVenueCocktail ? getDataVenueCocktail(false, categoryList) : null;
            },
            onLoadMore: function onLoadMore() {
              return !isLoadingVenueCocktail ? getDataVenueCocktail(true, categoryList) : null;
            },
            gapHeight: 150,
            currentPageIndex: parseInt(currentPageIndex) * pageSizeVenueCocktail
          })
        }), isLoadingVenueCocktail && pageIndexVenueCocktail > 0 && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            paddingTop: 20
          }
        })]
      }), passViewMode !== config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row items-center justify-between self-center w-full mt-20px sm:max-w-500px max-w-300px",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          prefetch: false,
          href: {
            pathname: router.pathname,
            query: explore_search_objectSpread(explore_search_objectSpread({}, router.query), {}, {
              page: prevPage
            })
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "cursor-pointer",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/icons/".concat( true ? ((_process$env$NEXT_PUB = "RooftopClub") === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.replace(" ", "")) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : _process$env$NEXT_PUB2.toLowerCase()) + "/" : 0, "ic_arrow_left.png"),
              width: isMobileVersion ? 30 : 50,
              height: isMobileVersion ? 30 : 50,
              alt: "arrow"
            })
          })
        }), passViewMode !== config/* Constants.viewType.VIEW_TYPE_MAP */.gT.viewType.VIEW_TYPE_MAP && passViewMode !== config/* Constants.viewType.VIEW_TYPE_OVERVIEW */.gT.viewType.VIEW_TYPE_OVERVIEW && (dataCategory === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL && itemsFestival.length > 0 || dataCategory === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST && itemsArtist.length > 0 || dataCategory === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE && itemsVenue.length > 0 || dataCategory === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP && itemsRooftop.length > 0 || dataCategory === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA && itemsSpa.length > 0 || dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL && itemsVenueBeachful.length > 0 || dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY && itemsPrefabCompany.length > 0 || dataCategory === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES && itemsPrefabHome.length > 0 || dataCategory === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO && itemsZoo.length > 0 || dataCategory === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL && itemsAnimal.length > 0 || dataCategory === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL && itemsParkful.length > 0 || dataCategory === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO && itemsCasino.length > 0 || dataCategory === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE && itemsCastle.length > 0 || dataCategory === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT && itemsResort.length > 0 || dataCategory === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL && itemsAparthotel.length > 0 || dataCategory === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL && itemsVenueCocktail.length > 0) && !isLoadingArtist && !isLoadingFestival && !isEnabledInfiniteScroll && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", explore_search_objectSpread(explore_search_objectSpread({}, buttonPropsPage), {}, {
            className: "".concat((0,formatHelpers/* getClass */.ll)("custom-gradient"), " cursor-pointer rounded-full p-1px sm:h-50px h-30px sm:w-180px w-140px"),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-row justify-center items-center sm:text-base text-xs font-bold ".concat((0,formatHelpers/* getClass */.ll)("text-white", true), " ").concat((0,formatHelpers/* getClass */.ll)("background", true), " w-full h-full rounded-full"),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: parseInt(currentPageIndex)
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "px-4",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: "/icons/ic_arrow_down.png",
                  width: "20",
                  height: "24",
                  alt: "arrow"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: totalPage
              })]
            })
          })), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "".concat(isOpenPage ? "visible" : "", " absolute sm:bottom-[50px] bottom-[30px] flex flex-col items-center justify-center left-0 right-0 z-[999] sm:w-180px w-140px overflow-hidden"),
            role: "menu",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "".concat((0,formatHelpers/* getClass */.ll)("bg-black8", true), " border ").concat((0,formatHelpers/* getClass */.ll)("border-black", true), " sm:w-140px w-115px overflow-hidden rounded-t-2xl py-2"),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "".concat(endPage > 10 ? "h-376px" : "", " w-full overflow-y-auto py-2"),
                children: [totalPage > 2000 && /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), explore_search_objectSpread(explore_search_objectSpread({
                  prefetch: false
                }, itemPropsPage[2000]), {}, {
                  href: {
                    pathname: router.pathname,
                    query: explore_search_objectSpread(explore_search_objectSpread({}, router.query), {}, {
                      page: totalPage
                    })
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: "sm:text-base text-xs font-bold text-center ".concat((0,formatHelpers/* getClass */.ll)("text-white", true), " h-40px flex flex-1 justify-center items-center cursor-pointer transition-all ").concat((0,formatHelpers/* getClass */.ll)("hover:bg-black8")),
                    children: totalPage
                  })
                })), totalPage > 2000 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "sm:text-base text-xs font-bold text-center ".concat((0,formatHelpers/* getClass */.ll)("text-white", true), " h-40px flex flex-1 justify-center items-center cursor-pointer transition-all ").concat((0,formatHelpers/* getClass */.ll)("hover:bg-black8")),
                  children: "..."
                }), reverse_default()(range_default()(startPage, endPage + 1, 1)).map(function (item, index) {
                  return item === parseInt(currentPageIndex) ? null : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), explore_search_objectSpread(explore_search_objectSpread({
                    prefetch: false
                  }, itemPropsPage[index]), {}, {
                    href: {
                      pathname: router.pathname,
                      query: explore_search_objectSpread(explore_search_objectSpread({}, router.query), {}, {
                        page: item
                      })
                    },
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      onClick: function onClick() {
                        return setIsOpenPage(function (prev) {
                          return !prev;
                        });
                      },
                      className: "sm:text-base text-xs font-bold text-center ".concat((0,formatHelpers/* getClass */.ll)("text-white", true), " h-40px flex flex-1 justify-center items-center cursor-pointer transition-all ").concat((0,formatHelpers/* getClass */.ll)("hover:bg-black8")),
                      children: item
                    })
                  }));
                }), startPage > 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "sm:text-base text-xs font-bold text-center ".concat((0,formatHelpers/* getClass */.ll)("text-white", true), " h-40px flex flex-1 justify-center items-center cursor-pointer transition-all ").concat((0,formatHelpers/* getClass */.ll)("hover:bg-black8")),
                  children: "..."
                }), startPage > 1 && /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), explore_search_objectSpread(explore_search_objectSpread({
                  prefetch: false
                }, itemPropsPage[1]), {}, {
                  href: {
                    pathname: router.pathname,
                    query: explore_search_objectSpread(explore_search_objectSpread({}, router.query), {}, {
                      page: 1
                    })
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    className: "sm:text-base text-xs font-bold text-center ".concat((0,formatHelpers/* getClass */.ll)("text-white", true), " h-40px flex flex-1 justify-center items-center cursor-pointer transition-all hover:bg-black8"),
                    children: "1"
                  })
                })), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  ref: pageScrollRef
                })]
              })
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          prefetch: false,
          href: {
            pathname: router.pathname,
            query: explore_search_objectSpread(explore_search_objectSpread({}, router.query), {}, {
              page: nextPage < 1 ? 1 : nextPage
            })
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "cursor-pointer",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "/icons/".concat( true ? ((_process$env$NEXT_PUB3 = "RooftopClub") === null || _process$env$NEXT_PUB3 === void 0 ? void 0 : (_process$env$NEXT_PUB4 = _process$env$NEXT_PUB3.replace(" ", "")) === null || _process$env$NEXT_PUB4 === void 0 ? void 0 : _process$env$NEXT_PUB4.toLowerCase()) + "/" : 0, "ic_arrow_right.png"),
              width: isMobileVersion ? 30 : 50,
              height: isMobileVersion ? 30 : 50,
              alt: "arrow"
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: explore_search_styles.gap
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* LocationModal */.F8, {
        ref: locationModal,
        category: dataCategory,
        locationSelected: locationSelected,
        distanceValue: locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.distance,
        isDistance: true,
        isCountryOnly: isChartsMode,
        onPressApply: function onPressApply(location, distance) {
          router.replace({
            query: explore_search_objectSpread(explore_search_objectSpread({}, router.query), {}, {
              page: 1
            })
          });
          setLocationSelected(explore_search_objectSpread(explore_search_objectSpread({}, location), {}, {
            distance: distance
          }));

          if (locationModal) {
            locationModal.current.hideModal();
          }
        },
        onPressCancel: function onPressCancel() {
          if (locationModal) {
            locationModal.current.hideModal();
          }
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* SingleSelectModal */.c2, {
        ref: sortMenuModal,
        icon: config/* Images.iconSortColored */.rU.iconSortColored,
        title: t("key_sort"),
        checkedItemId: sortBy,
        items: sortMenu.filter(function (item) {
          return item.isHide === false;
        }),
        onPressItem: function onPressItem(item) {
          setSortBy(item.id);

          if (sortMenuModal) {
            sortMenuModal.current.hideModal();
          }
        }
      })]
    })
  });
};

var explore_search_styles = StyleSheet_default().create({
  background: {
    overflow: "hidden",
    backgroundColor: (0,formatHelpers/* getClass */.ll)("background")
  },
  container: {
    flex: 1,
    alignItems: "center"
  },
  gap: {
    height: 20
  }
});
/* harmony default export */ var explore_search = (ExploreSearchScreen);

/***/ }),

/***/ 8559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ filter; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/config/index.js + 8 modules
var config = __webpack_require__(54176);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__(79057);
var View_default = /*#__PURE__*/__webpack_require__.n(View);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/TouchableOpacity/index.js
var TouchableOpacity = __webpack_require__(28908);
var TouchableOpacity_default = /*#__PURE__*/__webpack_require__.n(TouchableOpacity);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Text/index.js
var Text = __webpack_require__(48409);
var Text_default = /*#__PURE__*/__webpack_require__.n(Text);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(77058);
// EXTERNAL MODULE: ./node_modules/lodash/find.js
var find = __webpack_require__(13311);
var find_default = /*#__PURE__*/__webpack_require__.n(find);
// EXTERNAL MODULE: ./node_modules/lodash/findIndex.js
var findIndex = __webpack_require__(30998);
var findIndex_default = /*#__PURE__*/__webpack_require__.n(findIndex);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 38 modules
var atoms = __webpack_require__(52738);
// EXTERNAL MODULE: ./src/helpers/formatHelpers.js
var formatHelpers = __webpack_require__(9465);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/modules/filter/components/NavigationView.js











var NavigationView = function NavigationView(props) {
  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion,
      categoryTitle = props.categoryTitle;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: isMobileVersion ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-row items-center justify-between",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* BackButton */.xE, {
        onBackPressed: props.onBack,
        isNotAbsolute: true,
        isMobileVersion: isMobileVersion
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)((Text_default()), {
        style: [styles.title, {
          fontSize: 16
        }],
        children: [t("key_title_filter"), " ", categoryTitle]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-16 h-16"
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: styles.container,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: styles.title,
        children: t("key_title_filter")
      }), props.onClear && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: styles.action,
        onPress: props.onClear,
        children: t("key_web_button_clear_all")
      })]
    })
  });
};

var styles = StyleSheet_default().create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    paddingTop: 4
  },
  title: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: (0,formatHelpers/* getClass */.ll)("text-white"),
    fontSize: 20
  },
  action: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: config/* Colors.white50 */.wL.white50,
    textDecorationLine: "underline",
    fontSize: 14,
    cursor: "pointer"
  }
});
/* harmony default export */ var components_NavigationView = (NavigationView);
// EXTERNAL MODULE: ./src/DAO/index.js + 12 modules
var DAO = __webpack_require__(90793);
// EXTERNAL MODULE: ./src/components/molecules/index.js + 37 modules
var molecules = __webpack_require__(53732);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment_moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment_moment);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/modules/filter/data/venue.js





var venueFilterCriteria = function venueFilterCriteria(isMobileVersion, styles) {
  return [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Status",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Open",
      tagId: 1
    }, {
      id: 2,
      label: "Closed",
      tagId: 2
    }, {
      id: 3,
      label: "Temporarily Closed",
      tagId: 4
    }, {
      id: 4,
      label: "Permanently Closed",
      tagId: 3
    }],
    selectedList: [1, 2, 4]
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_VENUE */.gT.tagCategory.TAG_CATEGORY_VENUE,
    icon: config/* Images.iconTagTagVenue */.rU.iconTagTagVenue,
    width: 20,
    height: 20,
    title: "Venue",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Club",
      tagId: 701
    }, {
      id: 2,
      label: "Bar",
      tagId: 702
    }, {
      id: 3,
      label: "Hall",
      tagId: 703
    }, {
      id: 4,
      label: "Stadium",
      tagId: 704
    }, {
      id: 5,
      label: "Open Air",
      tagId: 705
    }, {
      id: 6,
      label: "Other",
      tagId: 706
    }, {
      id: null,
      label: null,
      isSeparator: true
    }, {
      id: 7,
      label: "Indoor & Outdoor",
      tagId: 801
    }, {
      id: 8,
      label: "Indoor Only",
      tagId: 802
    }, {
      id: 9,
      label: "Outdoor Only",
      tagId: 803
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_FEATURES */.gT.tagCategory.TAG_CATEGORY_FEATURES,
    icon: config/* Images.iconTagLightning */.rU.iconTagLightning,
    width: 20,
    height: 20,
    title: "Features",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Upscale",
      tagId: 601
    }, {
      id: 2,
      label: "Elegant",
      tagId: 602
    }, {
      id: 3,
      label: "Underground",
      tagId: 603
    }, {
      id: 4,
      label: "Casual",
      tagId: 604
    }, {
      id: 5,
      label: "Alternative",
      tagId: 605
    }, {
      id: 6,
      label: "International",
      tagId: 606
    }, {
      id: 7,
      label: "Local",
      tagId: 607
    }, {
      id: 8,
      label: "Live Music",
      tagId: 608
    }, {
      id: 9,
      label: "Rooftop",
      tagId: 609
    }, {
      id: 10,
      label: "LGBT+",
      tagId: 610
    }, {
      id: 11,
      label: "Students",
      tagId: 611
    }, {
      id: 12,
      label: "Members",
      tagId: 612
    }, {
      id: 13,
      label: "Pool",
      tagId: 613
    }, {
      id: 14,
      label: "VIP",
      tagId: 614
    }, {
      id: 15,
      label: "Romantic",
      tagId: 616
    }, {
      id: 16,
      label: "Themed",
      tagId: 617
    }, {
      id: 17,
      label: "Pub",
      tagId: 618
    }, {
      id: 18,
      label: "Cocktail",
      tagId: 619
    }, {
      id: 19,
      label: "Swimming Pool",
      tagId: 620
    }, {
      id: 20,
      label: "Shisha",
      tagId: 621
    }, {
      id: 22,
      label: "Karaoke",
      tagId: 623
    }, {
      id: 23,
      label: "Live show",
      tagId: 624
    }, {
      id: 24,
      label: "Sex-positive",
      tagId: 625
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_MUSIC */.gT.tagCategory.TAG_CATEGORY_MUSIC,
    icon: config/* Images.iconTagMusic */.rU.iconTagMusic,
    width: 20,
    height: 20,
    title: "Music",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Electronic",
      tagId: 301
    }, {
      id: 2,
      label: "Pop",
      tagId: 302
    }, {
      id: 3,
      label: "Rock",
      tagId: 303
    }, {
      id: 4,
      label: "Hip-Hop",
      tagId: 304
    }, {
      id: 5,
      label: "R&B",
      tagId: 305
    }, {
      id: 6,
      label: "Reggae",
      tagId: 306
    }, {
      id: 7,
      label: "Jazz",
      tagId: 307
    }, {
      id: 8,
      label: "Blues",
      tagId: 308
    }, {
      id: 9,
      label: "Metal",
      tagId: 309
    }, {
      id: 10,
      label: "Punk",
      tagId: 310
    }, {
      id: 11,
      label: "Country",
      tagId: 311
    }, {
      id: 12,
      label: "Folk",
      tagId: 312
    }, {
      id: 13,
      label: "Latin",
      tagId: 313
    }, {
      id: 14,
      label: "Classical",
      tagId: 314
    }, {
      id: 15,
      label: "Religious",
      tagId: 315
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PRICE_VENUE */.gT.tagCategory.TAG_CATEGORY_PRICE_VENUE,
    icon: config/* Images.iconTagPrice */.rU.iconTagPrice,
    width: 20,
    height: 20,
    title: "Price",
    isHide: false,
    detailList: [{
      id: 1,
      label: "1",
      tagId: 1501,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }, {
      id: 2,
      label: "2",
      tagId: 1502,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }, {
      id: 3,
      label: "3",
      tagId: 1503,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }, {
      id: 4,
      label: "4",
      tagId: 1504,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RATING */.gT.tagCategory.TAG_CATEGORY_RATING,
    icon: config/* Images.iconTagRating */.rU.iconTagRating,
    width: 21.5,
    height: isMobileVersion ? 21 : 20,
    title: "Rating",
    isHide: true,
    isRating: true,
    detailList: [{
      id: 1,
      label: "1",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating1 */.rU.iconTagRating1,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 2,
      label: "2",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating2 */.rU.iconTagRating2,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 3,
      label: "3",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating3 */.rU.iconTagRating3,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 4,
      label: "4",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating4 */.rU.iconTagRating4,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 5,
      label: "5",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating5 */.rU.iconTagRating5,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_SERVICE */.gT.tagCategory.TAG_CATEGORY_SERVICE,
    icon: config/* Images.iconTagService */.rU.iconTagService,
    width: 20,
    height: 20,
    title: "Service",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Club",
      tagId: 1601
    }, {
      id: 2,
      label: "Bar",
      tagId: 1602
    }, {
      id: 3,
      label: "Restaurant",
      tagId: 1603
    }, {
      id: 4,
      label: "None",
      tagId: 1605
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_SIZE */.gT.tagCategory.TAG_CATEGORY_SIZE,
    icon: config/* Images.iconTagSize */.rU.iconTagSize,
    width: 20,
    height: 20,
    title: "Size",
    isHide: false,
    detailList: [{
      id: 1,
      label: "XXS",
      suffix: "0 - 200",
      tagId: 501
    }, {
      id: 2,
      label: "XS",
      suffix: "200 - 500",
      tagId: 502
    }, {
      id: 3,
      label: "S",
      suffix: "500 - 2K",
      tagId: 503
    }, {
      id: 4,
      label: "M",
      suffix: "2K - 5K",
      tagId: 504
    }, {
      id: 5,
      label: "L",
      suffix: "5K - 20K",
      tagId: 505
    }, {
      id: 6,
      label: "XL",
      suffix: "20K - 50K",
      tagId: 506
    }, {
      id: 7,
      label: "XXL",
      suffix: "50K+",
      tagId: 507
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_AREA */.gT.tagCategory.TAG_CATEGORY_AREA,
    icon: config/* Images.iconTagArea */.rU.iconTagArea,
    width: 20,
    height: 20,
    title: "Area",
    isHide: false,
    detailList: [{
      id: 1,
      label: "City",
      tagId: 901
    }, {
      id: 2,
      label: "Town",
      tagId: 902
    }, {
      id: 3,
      label: "Countryside",
      tagId: 903
    }, {
      id: 4,
      label: "Field",
      tagId: 904
    }, {
      id: 5,
      label: "Forest",
      tagId: 905
    }, {
      id: 6,
      label: "Lake",
      tagId: 906
    }, {
      id: 7,
      label: "Beach",
      tagId: 907
    }, {
      id: 8,
      label: "Mountain",
      tagId: 908
    }, {
      id: 9,
      label: "Park",
      tagId: 909
    }, {
      id: 10,
      label: "Resort",
      tagId: 910
    }, {
      id: 11,
      label: "Unique Location",
      tagId: 911
    }, {
      id: 12,
      label: "Ship",
      tagId: 912
    }, {
      id: 13,
      label: "Other",
      tagId: 913
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
    icon: config/* Images.iconTagAge */.rU.iconTagAge,
    width: 20,
    height: 20,
    title: "Age",
    isHide: false,
    isAge: true
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_DRESS_CODE */.gT.tagCategory.TAG_CATEGORY_DRESS_CODE,
    icon: config/* Images.iconTagDressCode */.rU.iconTagDressCode,
    width: 20,
    height: 20,
    title: "Dress Code",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Casual",
      tagId: 1001
    }, {
      id: 2,
      label: "Smart",
      tagId: 1002
    }, {
      id: 3,
      label: "Elegant",
      tagId: 1003
    }],
    selectedList: []
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/rooftop.js





var rooftopFilterCriteria = function rooftopFilterCriteria(isMobileVersion, styles) {
  return [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_VENUE */.gT.tagCategory.TAG_CATEGORY_VENUE,
    icon: config/* Images.iconTagGeneral */.rU.iconTagGeneral,
    width: 20,
    height: 20,
    title: "Venue",
    isHide: false,
    detailList: [{
      id: 7,
      label: "Indoor & Outdoor",
      tagId: 801
    }, {
      id: 8,
      label: "Indoor Only",
      tagId: 802
    }, {
      id: 9,
      label: "Outdoor Only",
      tagId: 803
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_SERVICE */.gT.tagCategory.TAG_CATEGORY_SERVICE,
    icon: config/* Images.iconTagService */.rU.iconTagService,
    width: 20,
    height: 20,
    title: "Service",
    isHide: false,
    detailList: [{
      id: 2,
      label: "Bar",
      tagId: 1602
    }, {
      id: 3,
      label: "Restaurant",
      tagId: 1603
    }, {
      id: 1,
      label: "Club",
      tagId: 1601
    }, {
      id: 4,
      label: "Wellness",
      tagId: 1604
    }, {
      id: 5,
      label: "Other",
      tagId: 1605
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_ROOFTOP_FEATURES */.gT.tagCategory.TAG_CATEGORY_ROOFTOP_FEATURES,
    icon: config/* Images.iconTagLightning */.rU.iconTagLightning,
    width: 20,
    height: 20,
    title: "Features",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Pool",
      tagId: 2501
    }, {
      id: 2,
      label: "Wellness",
      tagId: 2502
    }, {
      id: 3,
      label: "Upscale",
      tagId: 2503
    }, {
      id: 4,
      label: "Elegant",
      tagId: 2504
    }, {
      id: 5,
      label: "Underground",
      tagId: 2505
    }, {
      id: 6,
      label: "Casual",
      tagId: 2506
    }, {
      id: 7,
      label: "Live music",
      tagId: 2507
    }, {
      id: 8,
      label: "Members",
      tagId: 2508
    }, {
      id: 9,
      label: "Live Show",
      tagId: 2509
    }, {
      id: 10,
      label: "Cinema",
      tagId: 2510
    }, {
      id: 11,
      label: "N/A",
      tagId: 2511
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_VIEW */.gT.tagCategory.TAG_CATEGORY_VIEW,
    icon: config/* Images.iconTagView */.rU.iconTagView,
    width: 20,
    height: 20,
    title: "View",
    isHide: false,
    detailList: [{
      id: 1,
      label: "90°",
      tagId: 2201
    }, {
      id: 2,
      label: "180°",
      tagId: 2202
    }, {
      id: 3,
      label: "270°",
      tagId: 2203
    }, {
      id: 4,
      label: "360°",
      tagId: 2204
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PRICE_VENUE */.gT.tagCategory.TAG_CATEGORY_PRICE_VENUE,
    icon: config/* Images.iconTagPrice */.rU.iconTagPrice,
    width: 20,
    height: 20,
    title: "Price",
    isHide: false,
    detailList: [{
      id: 1,
      label: "1",
      tagId: 1501,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }, {
      id: 2,
      label: "2",
      tagId: 1502,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }, {
      id: 3,
      label: "3",
      tagId: 1503,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }, {
      id: 4,
      label: "4",
      tagId: 1504,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }, {
      id: 5,
      label: "N/A",
      tagId: 1505
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_ROOFTOP_SIZE */.gT.tagCategory.TAG_CATEGORY_ROOFTOP_SIZE,
    icon: config/* Images.iconTagSize */.rU.iconTagSize,
    width: 20,
    height: 20,
    title: "Size",
    isHide: false,
    detailList: [{
      id: 1,
      label: "XS",
      suffix: "0-20",
      tagId: 2401
    }, {
      id: 2,
      label: "S",
      suffix: "21-50",
      tagId: 2402
    }, {
      id: 3,
      label: "M",
      suffix: "51-100",
      tagId: 2403
    }, {
      id: 4,
      label: "L",
      suffix: "101-200",
      tagId: 2404
    }, {
      id: 5,
      label: "XL",
      suffix: "201-500",
      tagId: 2405
    }, {
      id: 6,
      label: "XXL",
      suffix: "500+",
      tagId: 2406
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_DRESS_CODE */.gT.tagCategory.TAG_CATEGORY_DRESS_CODE,
    icon: config/* Images.iconTagDressCode */.rU.iconTagDressCode,
    width: 20,
    height: 20,
    title: "Dress Code",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Casual",
      tagId: 1001
    }, {
      id: 2,
      label: "Smart",
      tagId: 1002
    }, {
      id: 3,
      label: "Elegant",
      tagId: 1003
    }, {
      id: 4,
      label: "N/A",
      tagId: 1004
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Status",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Open",
      tagId: 1
    }, {
      id: 2,
      label: "Closed",
      tagId: 2
    }, {
      id: 3,
      label: "Temporarily Closed",
      tagId: 4
    }, {
      id: 4,
      label: "Permanently Closed",
      tagId: 3
    }],
    selectedList: [1, 2, 4]
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_AREA */.gT.tagCategory.TAG_CATEGORY_AREA,
    icon: config/* Images.iconTagArea */.rU.iconTagArea,
    width: 20,
    height: 20,
    title: "Area",
    isHide: false,
    detailList: [{
      id: 1,
      label: "City",
      tagId: 901
    }, {
      id: 2,
      label: "Town",
      tagId: 902
    }, {
      id: 3,
      label: "Countryside",
      tagId: 903
    }, {
      id: 4,
      label: "Field",
      tagId: 904
    }, {
      id: 5,
      label: "Forest",
      tagId: 905
    }, {
      id: 6,
      label: "Lake",
      tagId: 906
    }, {
      id: 7,
      label: "Beach",
      tagId: 907
    }, {
      id: 8,
      label: "Mountain",
      tagId: 908
    }, {
      id: 9,
      label: "Park",
      tagId: 909
    }, {
      id: 10,
      label: "Resort",
      tagId: 910
    }, {
      id: 11,
      label: "Unique Location",
      tagId: 911
    }, {
      id: 12,
      label: "Ship",
      tagId: 912
    }, {
      id: 13,
      label: "Other",
      tagId: 913
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RATING */.gT.tagCategory.TAG_CATEGORY_RATING,
    icon: config/* Images.iconTagRating */.rU.iconTagRating,
    width: 21.5,
    height: isMobileVersion ? 21 : 20,
    title: "Rating",
    isHide: true,
    isRating: true,
    detailList: [{
      id: 1,
      label: "1",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating1 */.rU.iconTagRating1,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 2,
      label: "2",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating2 */.rU.iconTagRating2,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 3,
      label: "3",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating3 */.rU.iconTagRating3,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 4,
      label: "4",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating4 */.rU.iconTagRating4,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 5,
      label: "5",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating5 */.rU.iconTagRating5,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }],
    selectedList: []
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/venue_cocktail.js





var venueCocktailFilterCriteria = function venueCocktailFilterCriteria(isMobileVersion, styles) {
  return [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_VENUE */.gT.tagCategory.TAG_CATEGORY_VENUE,
    icon: config/* Images.iconTagGeneral */.rU.iconTagGeneral,
    width: 20,
    height: 20,
    title: "Venue",
    isHide: false,
    detailList: [{
      id: 7,
      label: "Indoor & Outdoor",
      tagId: 801
    }, {
      id: 8,
      label: "Indoor Only",
      tagId: 802
    }, {
      id: 9,
      label: "Outdoor Only",
      tagId: 803
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_SERVICE */.gT.tagCategory.TAG_CATEGORY_SERVICE,
    icon: config/* Images.iconTagService */.rU.iconTagService,
    width: 20,
    height: 20,
    title: "Service",
    isHide: false,
    detailList: [{
      id: 3,
      label: "Restaurant",
      tagId: 1603
    }, {
      id: 2,
      label: "Bar",
      tagId: 1602
    }, {
      id: 1,
      label: "Club",
      tagId: 1601
    }, // {
    //   id: 4,
    //   label: "Wellness",
    //   tagId: 1604,
    // },
    {
      id: 5,
      label: "Other",
      tagId: 1605
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_FEATURES */.gT.tagCategory.TAG_CATEGORY_FEATURES,
    icon: config/* Images.iconTagLightning */.rU.iconTagLightning,
    width: 20,
    height: 20,
    title: "Features",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Casual",
      tagId: 604
    }, {
      id: 2,
      label: "Upscale",
      tagId: 601
    }, {
      id: 3,
      label: "Elegant",
      tagId: 602
    }, {
      id: 4,
      label: "VIP",
      tagId: 614
    }, {
      id: 5,
      label: "Glam",
      tagId: 626
    }, {
      id: 6,
      label: "Romantic",
      tagId: 616
    }, {
      id: 7,
      label: "Party",
      tagId: 627
    }, {
      id: 8,
      label: "Underground",
      tagId: 603
    }, {
      id: 9,
      label: "Members",
      tagId: 612
    }, {
      id: 10,
      label: "Themed",
      tagId: 617
    }, {
      id: 11,
      label: "Rooftop",
      tagId: 609
    }, {
      id: 12,
      label: "Terrace",
      tagId: 628
    }, {
      id: 13,
      label: "Basement",
      tagId: 629
    }, {
      id: 14,
      label: "Swimming Pool",
      tagId: 620
    }, {
      id: 15,
      label: "Pool",
      tagId: 613
    }, {
      id: 16,
      label: "Live music",
      tagId: 608
    }, {
      id: 17,
      label: "Live Show",
      tagId: 624
    }, {
      id: 18,
      label: "Cigar",
      tagId: 630
    }, {
      id: 19,
      label: "Shisha",
      tagId: 621
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_ROOFTOP_SIZE */.gT.tagCategory.TAG_CATEGORY_ROOFTOP_SIZE,
    icon: config/* Images.iconTagSize */.rU.iconTagSize,
    width: 20,
    height: 20,
    title: "Size",
    isHide: false,
    detailList: [{
      id: 1,
      label: "XS",
      suffix: "0-20",
      tagId: 2401
    }, {
      id: 2,
      label: "S",
      suffix: "21-50",
      tagId: 2402
    }, {
      id: 3,
      label: "M",
      suffix: "51-100",
      tagId: 2403
    }, {
      id: 4,
      label: "L",
      suffix: "101-200",
      tagId: 2404
    }, {
      id: 5,
      label: "XL",
      suffix: "201-500",
      tagId: 2405
    }, {
      id: 6,
      label: "XXL",
      suffix: "500+",
      tagId: 2406
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PRICE_VENUE */.gT.tagCategory.TAG_CATEGORY_PRICE_VENUE,
    icon: config/* Images.iconTagPrice */.rU.iconTagPrice,
    width: 20,
    height: 20,
    title: "Price",
    isHide: false,
    detailList: [{
      id: 1,
      label: "1",
      tagId: 1501,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }, {
      id: 2,
      label: "2",
      tagId: 1502,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }, {
      id: 3,
      label: "3",
      tagId: 1503,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }, {
      id: 4,
      label: "4",
      tagId: 1504,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_DRESS_CODE */.gT.tagCategory.TAG_CATEGORY_DRESS_CODE,
    icon: config/* Images.iconTagDressCode */.rU.iconTagDressCode,
    width: 20,
    height: 20,
    title: "Dress Code",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Casual",
      tagId: 1001
    }, {
      id: 2,
      label: "Smart",
      tagId: 1002
    }, {
      id: 3,
      label: "Elegant",
      tagId: 1003
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_AREA */.gT.tagCategory.TAG_CATEGORY_AREA,
    icon: config/* Images.iconTagArea */.rU.iconTagArea,
    width: 20,
    height: 20,
    title: "Area",
    isHide: false,
    detailList: [{
      id: 1,
      label: "City",
      tagId: 901
    }, {
      id: 2,
      label: "Town",
      tagId: 902
    }, {
      id: 3,
      label: "Countryside",
      tagId: 903
    }, {
      id: 4,
      label: "Field",
      tagId: 904
    }, {
      id: 5,
      label: "Forest",
      tagId: 905
    }, {
      id: 6,
      label: "Lake",
      tagId: 906
    }, {
      id: 7,
      label: "Beach",
      tagId: 907
    }, {
      id: 8,
      label: "Mountain",
      tagId: 908
    }, {
      id: 9,
      label: "Park",
      tagId: 909
    }, {
      id: 10,
      label: "Resort",
      tagId: 910
    }, {
      id: 11,
      label: "Unique Location",
      tagId: 911
    }, {
      id: 12,
      label: "Ship",
      tagId: 912
    }, {
      id: 13,
      label: "Other",
      tagId: 913
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Status",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Open",
      tagId: 1
    }, {
      id: 2,
      label: "Closed",
      tagId: 2
    }, {
      id: 3,
      label: "Temporarily Closed",
      tagId: 4
    }, {
      id: 4,
      label: "Permanently Closed",
      tagId: 3
    }],
    selectedList: [1, 2, 4]
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RATING */.gT.tagCategory.TAG_CATEGORY_RATING,
    icon: config/* Images.iconTagRating */.rU.iconTagRating,
    width: 21.5,
    height: isMobileVersion ? 21 : 20,
    title: "Rating",
    isHide: true,
    isRating: true,
    detailList: [{
      id: 1,
      label: "1",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating1 */.rU.iconTagRating1,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 2,
      label: "2",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating2 */.rU.iconTagRating2,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 3,
      label: "3",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating3 */.rU.iconTagRating3,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 4,
      label: "4",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating4 */.rU.iconTagRating4,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 5,
      label: "5",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating5 */.rU.iconTagRating5,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }],
    selectedList: []
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/event.js




var eventFilterCriteria = function eventFilterCriteria(isMobileVersion, styles) {
  return [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    icon: config/* Images.iconCalendarColored */.rU.iconCalendarColored,
    width: 20,
    height: 20,
    title: "Date",
    isHide: false,
    // isHide: !isSearch,
    isDate: true,
    dateType: "anytime"
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Status",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Upcoming - Confirmed"
    }, {
      id: 2,
      label: "Upcoming - To Be Confirmed"
    }, {
      id: 3,
      label: "Upcoming - Live"
    }, {
      id: 4,
      label: "Upcoming - Cancelled"
    }, {
      id: 5,
      label: "Upcoming - Rescheduled"
    }, {
      id: 6,
      label: "Past"
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_EVENT_TYPE */.gT.tagCategory.TAG_CATEGORY_EVENT_TYPE,
    icon: config/* Images.iconTagEventType */.rU.iconTagEventType,
    width: 20,
    height: 20,
    title: "Event type",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Concert",
      tagId: 101,
      isDisabled: true
    }, {
      id: 2,
      label: "Party",
      tagId: 102,
      isDisabled: true
    }, {
      id: 3,
      label: "Festival",
      tagId: 103
    }, {
      id: 4,
      label: "Other",
      tagId: 104,
      isDisabled: true
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_MUSIC */.gT.tagCategory.TAG_CATEGORY_MUSIC,
    icon: config/* Images.iconTagMusic */.rU.iconTagMusic,
    width: 20,
    height: 20,
    title: "Music",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Electronic",
      tagId: 301
    }, {
      id: 2,
      label: "Pop",
      tagId: 302
    }, {
      id: 3,
      label: "Rock",
      tagId: 303
    }, {
      id: 4,
      label: "Hip-Hop",
      tagId: 304
    }, {
      id: 5,
      label: "R&B",
      tagId: 305
    }, {
      id: 6,
      label: "Reggae",
      tagId: 306
    }, {
      id: 7,
      label: "Jazz",
      tagId: 307
    }, {
      id: 8,
      label: "Blues",
      tagId: 308
    }, {
      id: 9,
      label: "Metal",
      tagId: 309
    }, {
      id: 10,
      label: "Punk",
      tagId: 310
    }, {
      id: 11,
      label: "Country",
      tagId: 311
    }, {
      id: 12,
      label: "Folk",
      tagId: 312
    }, {
      id: 13,
      label: "Latin",
      tagId: 313
    }, {
      id: 14,
      label: "Classical",
      tagId: 314
    }, {
      id: 15,
      label: "Religious",
      tagId: 315
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PARTICIPATION */.gT.tagCategory.TAG_CATEGORY_PARTICIPATION,
    icon: config/* Images.iconTagParticipation */.rU.iconTagParticipation,
    width: 20,
    height: 20,
    title: "Participation",
    isHide: false,
    detailList: [{
      id: 1,
      label: "In-person only",
      tagId: 201
    }, {
      id: 2,
      label: "In-person & Virtual",
      tagId: 203
    }, {
      id: 3,
      label: "Virtual only",
      tagId: 202
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_ENTRY */.gT.tagCategory.TAG_CATEGORY_ENTRY,
    icon: config/* Images.iconTagEntry */.rU.iconTagEntry,
    width: 20,
    height: 20,
    title: "Entry",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Guestlist",
      tagId: 1201
    }, {
      id: 2,
      label: "Table",
      tagId: 1202
    }, {
      id: 3,
      label: "Tickets",
      tagId: 1203
    }, {
      id: 4,
      label: "Door",
      tagId: 1204
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PRICE */.gT.tagCategory.TAG_CATEGORY_PRICE,
    icon: config/* Images.iconTagPrice */.rU.iconTagPrice,
    width: 20,
    height: 20,
    title: "Price",
    isHide: false,
    isPrice: true,
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RATING */.gT.tagCategory.TAG_CATEGORY_RATING,
    icon: config/* Images.iconTagRating */.rU.iconTagRating,
    width: 21.5,
    height: isMobileVersion ? 21 : 20,
    title: "Rating",
    isHide: true,
    isRating: true,
    detailList: [{
      id: 1,
      label: "1",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating1 */.rU.iconTagRating1,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 2,
      label: "2",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating2 */.rU.iconTagRating2,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 3,
      label: "3",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating3 */.rU.iconTagRating3,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 4,
      label: "4",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating4 */.rU.iconTagRating4,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 5,
      label: "5",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating5 */.rU.iconTagRating5,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_FEATURES */.gT.tagCategory.TAG_CATEGORY_FEATURES,
    icon: config/* Images.iconTagLightning */.rU.iconTagLightning,
    width: 20,
    height: 20,
    title: "Features",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Upscale",
      tagId: 601
    }, {
      id: 2,
      label: "Elegant",
      tagId: 602
    }, {
      id: 3,
      label: "Underground",
      tagId: 603
    }, {
      id: 4,
      label: "Casual",
      tagId: 604
    }, {
      id: 5,
      label: "Alternative",
      tagId: 605
    }, {
      id: 6,
      label: "International",
      tagId: 606
    }, {
      id: 7,
      label: "Local",
      tagId: 607
    }, {
      id: 8,
      label: "Live Music",
      tagId: 608
    }, {
      id: 9,
      label: "Rooftop",
      tagId: 609
    }, {
      id: 10,
      label: "LGBT",
      tagId: 610
    }, {
      id: 11,
      label: "Students",
      tagId: 611
    }, {
      id: 12,
      label: "Members",
      tagId: 612
    }, {
      id: 13,
      label: "Pool",
      tagId: 613
    }, {
      id: 14,
      label: "VIP",
      tagId: 614
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_DURATION */.gT.tagCategory.TAG_CATEGORY_DURATION,
    icon: config/* Images.iconTagDuration */.rU.iconTagDuration,
    width: 20,
    height: 20,
    title: "Duration",
    isHide: false,
    detailList: [{
      id: 1,
      label: "0 - 3h",
      tagId: 405
    }, {
      id: 2,
      label: "3h - 6h",
      tagId: 406
    }, {
      id: 2,
      label: "6h - 1 Day",
      tagId: 407
    }, {
      id: 3,
      label: "2 Days",
      tagId: 403
    }, {
      id: 4,
      label: "+3 Days",
      tagId: 404
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_VENUE */.gT.tagCategory.TAG_CATEGORY_VENUE,
    icon: config/* Images.iconTagTagVenue */.rU.iconTagTagVenue,
    width: 20,
    height: 20,
    title: "Venue",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Club",
      tagId: 701
    }, {
      id: 2,
      label: "Bar",
      tagId: 702
    }, {
      id: 3,
      label: "Hall",
      tagId: 703
    }, {
      id: 4,
      label: "Stadium",
      tagId: 704
    }, {
      id: 5,
      label: "Open Air",
      tagId: 705
    }, {
      id: 6,
      label: "Other",
      tagId: 706
    }, {
      id: null,
      label: null,
      isSeparator: true
    }, {
      id: 7,
      label: "Indoor & Outdoor",
      tagId: 801
    }, {
      id: 8,
      label: "Indoor Only",
      tagId: 802
    }, {
      id: 9,
      label: "Outdoor Only",
      tagId: 803
    }],
    selectedList: []
  }, {
    icon: config/* Images.iconSearchArtist */.rU.iconSearchArtist,
    width: 20,
    height: 20,
    title: "Lineup",
    isHide: false,
    isLineup: true,
    detailList: [{
      id: 1,
      label: "0",
      value: {
        value: 0
      }
    }, {
      id: 2,
      label: "1",
      value: {
        value: 1
      }
    }, {
      id: 3,
      label: "2-4",
      value: {
        minValue: 2,
        maxValue: 4
      }
    }, {
      id: 4,
      label: "5-19",
      value: {
        minValue: 5,
        maxValue: 19
      }
    }, {
      id: 5,
      label: "20-49",
      value: {
        minValue: 20,
        maxValue: 49
      }
    }, {
      id: 6,
      label: "+50",
      value: {
        minValue: 50
      }
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_SIZE */.gT.tagCategory.TAG_CATEGORY_SIZE,
    icon: config/* Images.iconTagSize */.rU.iconTagSize,
    width: 20,
    height: 20,
    title: "Size",
    isHide: false,
    detailList: [{
      id: 1,
      label: "XXS",
      suffix: "0 - 200",
      tagId: 501
    }, {
      id: 2,
      label: "XS",
      suffix: "200 - 500",
      tagId: 502
    }, {
      id: 3,
      label: "S",
      suffix: "500 - 2K",
      tagId: 503
    }, {
      id: 4,
      label: "M",
      suffix: "2K - 5K",
      tagId: 504
    }, {
      id: 5,
      label: "L",
      suffix: "5K - 20K",
      tagId: 505
    }, {
      id: 6,
      label: "XL",
      suffix: "20K - 50K",
      tagId: 506
    }, {
      id: 7,
      label: "XXL",
      suffix: "50K+",
      tagId: 507
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_AREA */.gT.tagCategory.TAG_CATEGORY_AREA,
    icon: config/* Images.iconTagArea */.rU.iconTagArea,
    width: 20,
    height: 20,
    title: "Area",
    isHide: false,
    detailList: [{
      id: 1,
      label: "City",
      tagId: 901
    }, {
      id: 2,
      label: "Town",
      tagId: 902
    }, {
      id: 3,
      label: "Countryside",
      tagId: 903
    }, {
      id: 4,
      label: "Field",
      tagId: 904
    }, {
      id: 5,
      label: "Forest",
      tagId: 905
    }, {
      id: 6,
      label: "Lake",
      tagId: 906
    }, {
      id: 7,
      label: "Beach",
      tagId: 907
    }, {
      id: 8,
      label: "Mountain",
      tagId: 908
    }, {
      id: 9,
      label: "Park",
      tagId: 909
    }, {
      id: 10,
      label: "Resort",
      tagId: 910
    }, {
      id: 11,
      label: "Unique Location",
      tagId: 911
    }, {
      id: 12,
      label: "Ship",
      tagId: 912
    }, {
      id: 13,
      label: "Other",
      tagId: 913
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_ACCOMODATION */.gT.tagCategory.TAG_CATEGORY_ACCOMODATION,
    icon: config/* Images.iconTagAccomodation */.rU.iconTagAccomodation,
    width: 20,
    height: 20,
    title: "Accommodation",
    isHide: false,
    detailList: [{
      id: 1,
      label: "No camping",
      tagId: 1401
    }, {
      id: 2,
      label: "Camping",
      suffix: "Car parking",
      tagId: 1402
    }, {
      id: 1403,
      label: "Camping",
      suffix: "RC / Van parking",
      tagId: 1403
    }, {
      id: 4,
      label: "Camping",
      suffix: "Tent area",
      tagId: 1404
    }, {
      id: 1405,
      label: "Camping",
      suffix: "Tent",
      tagId: 1405
    }, {
      id: 6,
      label: "Camping",
      suffix: "Glamping",
      tagId: 1406
    }, {
      id: 7,
      label: "Hotel",
      tagId: 1407
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_DRESS_CODE */.gT.tagCategory.TAG_CATEGORY_DRESS_CODE,
    icon: config/* Images.iconTagDressCode */.rU.iconTagDressCode,
    width: 20,
    height: 20,
    title: "Dress Code",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Casual",
      tagId: 1001
    }, {
      id: 2,
      label: "Smart",
      tagId: 1002
    }, {
      id: 3,
      label: "Elegant",
      tagId: 1003
    }],
    selectedList: []
  }, {
    icon: config/* Images.iconTagAge */.rU.iconTagAge,
    width: 20,
    height: 20,
    title: "Age",
    isHide: false,
    isAge: true
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/festival.js




var festivalFilterCriteria = function festivalFilterCriteria(isMobileVersion, styles, isChartsMode) {
  return isChartsMode ? [{
    title: "Location",
    isHide: false,
    isLocation: true
  }, {
    icon: config/* Images.iconCalendarColored */.rU.iconCalendarColored,
    width: 20,
    height: 20,
    title: "Date",
    isHide: false,
    isSingle: true,
    isMinimumOneSelect: true,
    detailList: [{
      id: 1,
      label: moment().subtract(1, "year").format("YYYY"),
      tagId: moment().subtract(1, "year").format("YYYY")
    }, {
      id: 2,
      label: moment().format("YYYY"),
      tagId: moment().format("YYYY")
    }, {
      id: 3,
      label: moment().add(1, "year").format("YYYY"),
      tagId: moment().add(1, "year").format("YYYY")
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_MUSIC */.gT.tagCategory.TAG_CATEGORY_MUSIC,
    icon: config/* Images.iconTagMusic */.rU.iconTagMusic,
    width: 20,
    height: 20,
    title: "Music",
    isHide: false,
    isSingle: true,
    isMinimumOneSelect: true,
    detailList: [{
      id: 0,
      label: "All",
      tagId: 300
    }, {
      id: 1,
      label: "Electronic",
      tagId: 301
    }, {
      id: 2,
      label: "Pop",
      tagId: 302
    }, {
      id: 3,
      label: "Rock",
      tagId: 303
    }, {
      id: 4,
      label: "Hip-Hop",
      tagId: 304
    }, {
      id: 5,
      label: "R&B",
      tagId: 305
    }, {
      id: 6,
      label: "Reggae",
      tagId: 306
    }, {
      id: 7,
      label: "Jazz",
      tagId: 307
    }, {
      id: 8,
      label: "Blues",
      tagId: 308
    }, {
      id: 9,
      label: "Metal",
      tagId: 309
    }, {
      id: 10,
      label: "Punk",
      tagId: 310
    }, {
      id: 11,
      label: "Country",
      tagId: 311
    }, {
      id: 12,
      label: "Folk",
      tagId: 312
    }, {
      id: 13,
      label: "Latin",
      tagId: 313
    }, {
      id: 14,
      label: "Classical",
      tagId: 314
    }, {
      id: 15,
      label: "Religious",
      tagId: 315
    }, {
      id: 16,
      label: "Mix",
      tagId: 9999
    }],
    selectedList: []
  }, {
    icon: config/* Images.iconTagEventType */.rU.iconTagEventType,
    width: 20,
    height: 20,
    title: "Category",
    isHide: false,
    isSingle: true,
    isMinimumOneSelect: true,
    detailList: [{
      id: 1,
      label: "Popularity",
      tagId: config/* Constants.sortByAction.SORT_BY_SOCIAL_MEDIA_POPULARITY */.gT.sortByAction.SORT_BY_SOCIAL_MEDIA_POPULARITY
    }, {
      id: 2,
      label: "Lineup Size",
      tagId: config/* Constants.sortByAction.SORT_BY_LINEUP_SIZE */.gT.sortByAction.SORT_BY_LINEUP_SIZE
    }, {
      id: 3,
      label: "Lineup Popularity",
      tagId: config/* Constants.sortByAction.SORT_BY_LINEUP_POPULARITY */.gT.sortByAction.SORT_BY_LINEUP_POPULARITY
    }],
    selectedList: [config/* Constants.sortByAction.SORT_BY_LINEUP_POPULARITY */.gT.sortByAction.SORT_BY_LINEUP_POPULARITY]
  }] : [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    icon: config/* Images.iconCalendarColored */.rU.iconCalendarColored,
    width: 20,
    height: 20,
    title: "Date",
    isHide: false,
    // isHide: !isSearch,
    isDate: true,
    dateType: "anytime"
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Status",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Upcoming - Confirmed"
    }, {
      id: 2,
      label: "Upcoming - To Be Confirmed"
    }, {
      id: 3,
      label: "Upcoming - Live"
    }, {
      id: 4,
      label: "Upcoming - Cancelled"
    }, {
      id: 5,
      label: "Upcoming - Rescheduled"
    }, {
      id: 6,
      label: "Past"
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_EVENT_TYPE */.gT.tagCategory.TAG_CATEGORY_EVENT_TYPE,
    icon: config/* Images.iconTagEventType */.rU.iconTagEventType,
    width: 20,
    height: 20,
    title: "Event type",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Concert",
      tagId: 101,
      isDisabled: true
    }, {
      id: 2,
      label: "Party",
      tagId: 102,
      isDisabled: true
    }, {
      id: 3,
      label: "Festival",
      tagId: 103
    }, {
      id: 4,
      label: "Other",
      tagId: 104,
      isDisabled: true
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_MUSIC */.gT.tagCategory.TAG_CATEGORY_MUSIC,
    icon: config/* Images.iconTagMusic */.rU.iconTagMusic,
    width: 20,
    height: 20,
    title: "Music",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Electronic",
      tagId: 301
    }, {
      id: 2,
      label: "Pop",
      tagId: 302
    }, {
      id: 3,
      label: "Rock",
      tagId: 303
    }, {
      id: 4,
      label: "Hip-Hop",
      tagId: 304
    }, {
      id: 5,
      label: "R&B",
      tagId: 305
    }, {
      id: 6,
      label: "Reggae",
      tagId: 306
    }, {
      id: 7,
      label: "Jazz",
      tagId: 307
    }, {
      id: 8,
      label: "Blues",
      tagId: 308
    }, {
      id: 9,
      label: "Metal",
      tagId: 309
    }, {
      id: 10,
      label: "Punk",
      tagId: 310
    }, {
      id: 11,
      label: "Country",
      tagId: 311
    }, {
      id: 12,
      label: "Folk",
      tagId: 312
    }, {
      id: 13,
      label: "Latin",
      tagId: 313
    }, {
      id: 14,
      label: "Classical",
      tagId: 314
    }, {
      id: 15,
      label: "Religious",
      tagId: 315
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PARTICIPATION */.gT.tagCategory.TAG_CATEGORY_PARTICIPATION,
    icon: config/* Images.iconTagParticipation */.rU.iconTagParticipation,
    width: 20,
    height: 20,
    title: "Participation",
    isHide: false,
    detailList: [{
      id: 1,
      label: "In-person only",
      tagId: 201
    }, {
      id: 2,
      label: "In-person & Virtual",
      tagId: 203
    }, {
      id: 3,
      label: "Virtual only",
      tagId: 202
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_ENTRY */.gT.tagCategory.TAG_CATEGORY_ENTRY,
    icon: config/* Images.iconTagEntry */.rU.iconTagEntry,
    width: 20,
    height: 20,
    title: "Entry",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Guestlist",
      tagId: 1201
    }, {
      id: 2,
      label: "Table",
      tagId: 1202
    }, {
      id: 3,
      label: "Tickets",
      tagId: 1203
    }, {
      id: 4,
      label: "Door",
      tagId: 1204
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PRICE */.gT.tagCategory.TAG_CATEGORY_PRICE,
    icon: config/* Images.iconTagPrice */.rU.iconTagPrice,
    width: 20,
    height: 20,
    title: "Price",
    isHide: false,
    isPrice: true,
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RATING */.gT.tagCategory.TAG_CATEGORY_RATING,
    icon: config/* Images.iconTagRating */.rU.iconTagRating,
    width: 21.5,
    height: isMobileVersion ? 21 : 20,
    title: "Rating",
    isHide: true,
    isRating: true,
    detailList: [{
      id: 1,
      label: "1",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating1 */.rU.iconTagRating1,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 2,
      label: "2",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating2 */.rU.iconTagRating2,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 3,
      label: "3",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating3 */.rU.iconTagRating3,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 4,
      label: "4",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating4 */.rU.iconTagRating4,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 5,
      label: "5",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating5 */.rU.iconTagRating5,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_FEATURES */.gT.tagCategory.TAG_CATEGORY_FEATURES,
    icon: config/* Images.iconTagLightning */.rU.iconTagLightning,
    width: 20,
    height: 20,
    title: "Features",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Upscale",
      tagId: 601
    }, {
      id: 2,
      label: "Elegant",
      tagId: 602
    }, {
      id: 3,
      label: "Underground",
      tagId: 603
    }, {
      id: 4,
      label: "Casual",
      tagId: 604
    }, {
      id: 5,
      label: "Alternative",
      tagId: 605
    }, {
      id: 6,
      label: "International",
      tagId: 606
    }, {
      id: 7,
      label: "Local",
      tagId: 607
    }, {
      id: 8,
      label: "Live Music",
      tagId: 608
    }, {
      id: 9,
      label: "Rooftop",
      tagId: 609
    }, {
      id: 10,
      label: "LGBT",
      tagId: 610
    }, {
      id: 11,
      label: "Students",
      tagId: 611
    }, {
      id: 12,
      label: "Members",
      tagId: 612
    }, {
      id: 13,
      label: "Pool",
      tagId: 613
    }, {
      id: 14,
      label: "VIP",
      tagId: 614
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_DURATION */.gT.tagCategory.TAG_CATEGORY_DURATION,
    icon: config/* Images.iconTagDuration */.rU.iconTagDuration,
    width: 20,
    height: 20,
    title: "Duration",
    isHide: false,
    detailList: [{
      id: 1,
      label: "0 - 3h",
      tagId: 405
    }, {
      id: 2,
      label: "3h - 6h",
      tagId: 406
    }, {
      id: 2,
      label: "6h - 1 Day",
      tagId: 407
    }, {
      id: 3,
      label: "2 Days",
      tagId: 403
    }, {
      id: 4,
      label: "+3 Days",
      tagId: 404
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_VENUE */.gT.tagCategory.TAG_CATEGORY_VENUE,
    icon: config/* Images.iconTagTagVenue */.rU.iconTagTagVenue,
    width: 20,
    height: 20,
    title: "Venue",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Club",
      tagId: 701
    }, {
      id: 2,
      label: "Bar",
      tagId: 702
    }, {
      id: 3,
      label: "Hall",
      tagId: 703
    }, {
      id: 4,
      label: "Stadium",
      tagId: 704
    }, {
      id: 5,
      label: "Open Air",
      tagId: 705
    }, {
      id: 6,
      label: "Other",
      tagId: 706
    }, {
      id: null,
      label: null,
      isSeparator: true
    }, {
      id: 7,
      label: "Indoor & Outdoor",
      tagId: 801
    }, {
      id: 8,
      label: "Indoor Only",
      tagId: 802
    }, {
      id: 9,
      label: "Outdoor Only",
      tagId: 803
    }],
    selectedList: []
  }, {
    icon: config/* Images.iconSearchArtist */.rU.iconSearchArtist,
    width: 20,
    height: 20,
    title: "Lineup",
    isHide: false,
    isLineup: true,
    detailList: [{
      id: 1,
      label: "0",
      value: {
        value: 0
      }
    }, {
      id: 2,
      label: "1",
      value: {
        value: 1
      }
    }, {
      id: 3,
      label: "2-4",
      value: {
        minValue: 2,
        maxValue: 4
      }
    }, {
      id: 4,
      label: "5-19",
      value: {
        minValue: 5,
        maxValue: 19
      }
    }, {
      id: 5,
      label: "20-49",
      value: {
        minValue: 20,
        maxValue: 49
      }
    }, {
      id: 6,
      label: "+50",
      value: {
        minValue: 50
      }
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_SIZE */.gT.tagCategory.TAG_CATEGORY_SIZE,
    icon: config/* Images.iconTagSize */.rU.iconTagSize,
    width: 20,
    height: 20,
    title: "Size",
    isHide: false,
    detailList: [{
      id: 1,
      label: "XXS",
      suffix: "0 - 200",
      tagId: 501
    }, {
      id: 2,
      label: "XS",
      suffix: "200 - 500",
      tagId: 502
    }, {
      id: 3,
      label: "S",
      suffix: "500 - 2K",
      tagId: 503
    }, {
      id: 4,
      label: "M",
      suffix: "2K - 5K",
      tagId: 504
    }, {
      id: 5,
      label: "L",
      suffix: "5K - 20K",
      tagId: 505
    }, {
      id: 6,
      label: "XL",
      suffix: "20K - 50K",
      tagId: 506
    }, {
      id: 7,
      label: "XXL",
      suffix: "50K+",
      tagId: 507
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_AREA */.gT.tagCategory.TAG_CATEGORY_AREA,
    icon: config/* Images.iconTagArea */.rU.iconTagArea,
    width: 20,
    height: 20,
    title: "Area",
    isHide: false,
    detailList: [{
      id: 1,
      label: "City",
      tagId: 901
    }, {
      id: 2,
      label: "Town",
      tagId: 902
    }, {
      id: 3,
      label: "Countryside",
      tagId: 903
    }, {
      id: 4,
      label: "Field",
      tagId: 904
    }, {
      id: 5,
      label: "Forest",
      tagId: 905
    }, {
      id: 6,
      label: "Lake",
      tagId: 906
    }, {
      id: 7,
      label: "Beach",
      tagId: 907
    }, {
      id: 8,
      label: "Mountain",
      tagId: 908
    }, {
      id: 9,
      label: "Park",
      tagId: 909
    }, {
      id: 10,
      label: "Resort",
      tagId: 910
    }, {
      id: 11,
      label: "Unique Location",
      tagId: 911
    }, {
      id: 12,
      label: "Ship",
      tagId: 912
    }, {
      id: 13,
      label: "Other",
      tagId: 913
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_ACCOMODATION */.gT.tagCategory.TAG_CATEGORY_ACCOMODATION,
    icon: config/* Images.iconTagAccomodation */.rU.iconTagAccomodation,
    width: 20,
    height: 20,
    title: "Accommodation",
    isHide: false,
    detailList: [{
      id: 1,
      label: "No camping",
      tagId: 1401
    }, {
      id: 2,
      label: "Camping",
      suffix: "Car parking",
      tagId: 1402
    }, {
      id: 1403,
      label: "Camping",
      suffix: "RC / Van parking",
      tagId: 1403
    }, {
      id: 4,
      label: "Camping",
      suffix: "Tent area",
      tagId: 1404
    }, {
      id: 1405,
      label: "Camping",
      suffix: "Tent",
      tagId: 1405
    }, {
      id: 6,
      label: "Camping",
      suffix: "Glamping",
      tagId: 1406
    }, {
      id: 7,
      label: "Hotel",
      tagId: 1407
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_DRESS_CODE */.gT.tagCategory.TAG_CATEGORY_DRESS_CODE,
    icon: config/* Images.iconTagDressCode */.rU.iconTagDressCode,
    width: 20,
    height: 20,
    title: "Dress Code",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Casual",
      tagId: 1001
    }, {
      id: 2,
      label: "Smart",
      tagId: 1002
    }, {
      id: 3,
      label: "Elegant",
      tagId: 1003
    }],
    selectedList: []
  }, {
    icon: config/* Images.iconTagAge */.rU.iconTagAge,
    width: 20,
    height: 20,
    title: "Age",
    isHide: false,
    isAge: true
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/artist.js



var artistFilterCriteria = function artistFilterCriteria(isMobileVersion, styles, isChartsMode) {
  return isChartsMode ? [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    icon: config/* Images.iconCalendarColored */.rU.iconCalendarColored,
    width: 20,
    height: 20,
    title: "Date",
    isHide: false,
    isSingle: true,
    isMinimumOneSelect: true,
    detailList: [{
      id: 1,
      label: moment().subtract(1, "year").format("YYYY"),
      tagId: moment().subtract(1, "year").format("YYYY")
    }, {
      id: 2,
      label: moment().format("YYYY"),
      tagId: moment().format("YYYY")
    }, {
      id: 3,
      label: moment().add(1, "year").format("YYYY"),
      tagId: moment().add(1, "year").format("YYYY")
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_MUSIC */.gT.tagCategory.TAG_CATEGORY_MUSIC,
    icon: config/* Images.iconTagMusic */.rU.iconTagMusic,
    width: 20,
    height: 20,
    title: "Music",
    isHide: false,
    isSingle: true,
    isMinimumOneSelect: true,
    detailList: [{
      id: 0,
      label: "All",
      tagId: 300
    }, {
      id: 1,
      label: "Electronic",
      tagId: 301
    }, {
      id: 2,
      label: "Pop",
      tagId: 302
    }, {
      id: 3,
      label: "Rock",
      tagId: 303
    }, {
      id: 4,
      label: "Hip-Hop",
      tagId: 304
    }, {
      id: 5,
      label: "R&B",
      tagId: 305
    }, {
      id: 6,
      label: "Reggae",
      tagId: 306
    }, {
      id: 7,
      label: "Jazz",
      tagId: 307
    }, {
      id: 8,
      label: "Blues",
      tagId: 308
    }, {
      id: 9,
      label: "Metal",
      tagId: 309
    }, {
      id: 10,
      label: "Punk",
      tagId: 310
    }, {
      id: 11,
      label: "Country",
      tagId: 311
    }, {
      id: 12,
      label: "Folk",
      tagId: 312
    }, {
      id: 13,
      label: "Latin",
      tagId: 313
    }, {
      id: 14,
      label: "Classical",
      tagId: 314
    }, {
      id: 15,
      label: "Religious",
      tagId: 315
    }],
    selectedList: []
  }, {
    icon: config/* Images.iconTagEventType */.rU.iconTagEventType,
    width: 20,
    height: 20,
    title: "Category",
    isHide: false,
    isSingle: true,
    isMinimumOneSelect: true,
    detailList: [{
      id: 1,
      label: "Acts",
      tagId: config/* Constants.sortByAction.SORT_BY_EVENT_COUNT */.gT.sortByAction.SORT_BY_EVENT_COUNT
    }, {
      id: 2,
      label: "Popularity",
      tagId: config/* Constants.sortByAction.SORT_BY_EVENT_POPULARITY */.gT.sortByAction.SORT_BY_EVENT_POPULARITY
    }],
    selectedList: []
  }] : [{
    id: config/* Constants.tagCategory.TAG_CATEGORY_MUSIC */.gT.tagCategory.TAG_CATEGORY_MUSIC,
    icon: config/* Images.iconTagMusic */.rU.iconTagMusic,
    width: 20,
    height: 20,
    title: "Music",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Electronic",
      tagId: 301
    }, {
      id: 2,
      label: "Pop",
      tagId: 302
    }, {
      id: 3,
      label: "Rock",
      tagId: 303
    }, {
      id: 4,
      label: "Hip-Hop",
      tagId: 304
    }, {
      id: 5,
      label: "R&B",
      tagId: 305
    }, {
      id: 6,
      label: "Reggae",
      tagId: 306
    }, {
      id: 7,
      label: "Jazz",
      tagId: 307
    }, {
      id: 8,
      label: "Blues",
      tagId: 308
    }, {
      id: 9,
      label: "Metal",
      tagId: 309
    }, {
      id: 10,
      label: "Punk",
      tagId: 310
    }, {
      id: 11,
      label: "Country",
      tagId: 311
    }, {
      id: 12,
      label: "Folk",
      tagId: 312
    }, {
      id: 13,
      label: "Latin",
      tagId: 313
    }, {
      id: 14,
      label: "Classical",
      tagId: 314
    }, {
      id: 15,
      label: "Religious",
      tagId: 315
    }],
    selectedList: []
  }, // {
  //   isLocation: true,
  //   icon: Images.iconTagCountry,
  //   width: 16,
  //   height: 19.5,
  //   title: "Country",
  //   isHide: false,
  //   isSearchable: true,
  //   isCountry: true,
  //   detailList: [
  //     // from api country
  //   ],
  //   selectedList: [],
  // },
  {
    isActivity: true,
    icon: config/* Images.iconTagActivity */.rU.iconTagActivity,
    width: 18,
    height: isMobileVersion ? 20 : 22,
    title: "Activity",
    isHide: false,
    detailList: [{
      id: 1,
      label: "On Tour"
    }, {
      id: 2,
      label: "Inactive"
    }],
    selectedList: []
  }, {
    icon: config/* Images.iconSearchEvent */.rU.iconSearchEvent,
    width: 20,
    height: 20,
    title: "Events",
    isHide: false,
    isEventSize: true,
    detailList: [{
      id: 1,
      label: "0",
      value: {
        value: 0
      }
    }, {
      id: 2,
      label: "1-4",
      value: {
        minValue: 1,
        maxValue: 4
      }
    }, {
      id: 3,
      label: "5-9",
      value: {
        minValue: 5,
        maxValue: 9
      }
    }, {
      id: 4,
      label: "10-19",
      value: {
        minValue: 10,
        maxValue: 19
      }
    }, {
      id: 5,
      label: "20-49",
      value: {
        minValue: 20,
        maxValue: 49
      }
    }, {
      id: 6,
      label: "+50",
      value: {
        minValue: 50
      }
    }],
    selectedList: []
  }, {
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    icon: config/* Images.iconCalendarColored */.rU.iconCalendarColored,
    width: 20,
    height: 20,
    title: "Date",
    isHide: false,
    // isHide: !isSearch,
    isDate: true,
    dateType: "anytime"
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/promoter.js



var promoterFilterCriteria = function promoterFilterCriteria(isMobileVersion, styles) {
  return [{
    icon: config/* Images.iconTagMusic */.rU.iconTagMusic,
    width: 20,
    height: 20,
    title: "Music",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Electronic",
      tagId: 301
    }, {
      id: 2,
      label: "Pop",
      tagId: 302
    }, {
      id: 3,
      label: "Rock",
      tagId: 303
    }, {
      id: 4,
      label: "Hip-Hop",
      tagId: 304
    }, {
      id: 5,
      label: "R&B",
      tagId: 305
    }, {
      id: 6,
      label: "Reggae",
      tagId: 306
    }, {
      id: 7,
      label: "Jazz",
      tagId: 307
    }, {
      id: 8,
      label: "Blues",
      tagId: 308
    }, {
      id: 9,
      label: "Metal",
      tagId: 309
    }, {
      id: 10,
      label: "Punk",
      tagId: 310
    }, {
      id: 11,
      label: "Country",
      tagId: 311
    }, {
      id: 12,
      label: "Folk",
      tagId: 312
    }, {
      id: 13,
      label: "Latin",
      tagId: 313
    }, {
      id: 14,
      label: "Classical",
      tagId: 314
    }, {
      id: 15,
      label: "Religious",
      tagId: 315
    }],
    selectedList: []
  }, {
    icon: config/* Images.iconTagActivity */.rU.iconTagActivity,
    width: 20,
    height: 20,
    title: "Activity",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Promoting"
    }, {
      id: 2,
      label: "Inactive"
    }],
    selectedList: []
  }, {
    icon: config/* Images.iconCalendarColored */.rU.iconCalendarColored,
    width: 20,
    height: 20,
    title: "Date",
    isHide: false,
    // isHide: !isSearch,
    isDate: true,
    dateType: "anytime"
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/other.js



var otherFilterCriteria = function otherFilterCriteria(isMobileVersion, styles) {
  return [{
    id: config/* Constants.tagCategory.TAG_CATEGORY_MUSIC */.gT.tagCategory.TAG_CATEGORY_MUSIC,
    icon: config/* Images.iconTagMusic */.rU.iconTagMusic,
    width: 20,
    height: 20,
    title: "Music",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Electronic",
      tagId: 301
    }, {
      id: 2,
      label: "Pop",
      tagId: 302
    }, {
      id: 3,
      label: "Rock",
      tagId: 303
    }, {
      id: 4,
      label: "Hip-Hop",
      tagId: 304
    }, {
      id: 5,
      label: "R&B",
      tagId: 305
    }, {
      id: 6,
      label: "Reggae",
      tagId: 306
    }, {
      id: 7,
      label: "Jazz",
      tagId: 307
    }, {
      id: 8,
      label: "Blues",
      tagId: 308
    }, {
      id: 9,
      label: "Metal",
      tagId: 309
    }, {
      id: 10,
      label: "Punk",
      tagId: 310
    }, {
      id: 11,
      label: "Country",
      tagId: 311
    }, {
      id: 12,
      label: "Folk",
      tagId: 312
    }, {
      id: 13,
      label: "Latin",
      tagId: 313
    }, {
      id: 14,
      label: "Classical",
      tagId: 314
    }, {
      id: 15,
      label: "Religious",
      tagId: 315
    }],
    selectedList: []
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/spa.js





var spaFilterCriteria = function spaFilterCriteria(isMobileVersion, styles) {
  return [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_VENUE */.gT.tagCategory.TAG_CATEGORY_VENUE,
    icon: config/* Images.iconTagGeneral */.rU.iconTagGeneral,
    width: 20,
    height: 20,
    title: "Venue",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Spa",
      tagId: 707
    }, {
      id: 2,
      label: "Hotel",
      tagId: 708
    }, {
      id: 3,
      label: "Club",
      tagId: 701
    }, {
      id: 4,
      label: "Other",
      tagId: 706
    }, {
      id: null,
      label: null,
      isSeparator: true
    }, {
      id: 8,
      label: "Indoor Only",
      tagId: 802
    }, {
      id: 9,
      label: "Outdoor Only",
      tagId: 803
    }, {
      id: 7,
      label: "Indoor & Outdoor",
      tagId: 801
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_AREA */.gT.tagCategory.TAG_CATEGORY_AREA,
    icon: config/* Images.iconTagArea */.rU.iconTagArea,
    width: 20,
    height: 20,
    title: "Area",
    isHide: false,
    detailList: [{
      id: 1,
      label: "City",
      tagId: 901
    }, {
      id: 2,
      label: "Town",
      tagId: 902
    }, {
      id: 3,
      label: "Countryside",
      tagId: 903
    }, {
      id: 4,
      label: "Field",
      tagId: 904
    }, {
      id: 5,
      label: "Forest",
      tagId: 905
    }, {
      id: 6,
      label: "Lake",
      tagId: 906
    }, {
      id: 7,
      label: "Beach",
      tagId: 907
    }, {
      id: 8,
      label: "Mountain",
      tagId: 908
    }, {
      id: 9,
      label: "Park",
      tagId: 909
    }, {
      id: 10,
      label: "Resort",
      tagId: 910
    }, {
      id: 11,
      label: "Unique Location",
      tagId: 911
    }, {
      id: 12,
      label: "Ship",
      tagId: 912
    }, {
      id: 13,
      label: "Other",
      tagId: 913
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_FEATURES */.gT.tagCategory.TAG_CATEGORY_FEATURES,
    icon: config/* Images.iconTagLightning */.rU.iconTagLightning,
    width: 20,
    height: 20,
    title: "Features",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Day Spa",
      tagId: 631
    }, {
      id: 2,
      label: "Destination Spa",
      tagId: 632
    }, {
      id: 3,
      label: "Thermal Spa",
      tagId: 633
    }, {
      id: 4,
      label: "Hotel Spa",
      tagId: 634
    }, {
      id: 5,
      label: "Club Spa",
      tagId: 635
    }, {
      id: 6,
      label: "Medical Spa",
      tagId: 637
    }, {
      id: 7,
      label: "Adults Only",
      tagId: 638
    }, {
      id: 8,
      label: "Luxury",
      tagId: 639
    }, {
      id: 9,
      label: "Rooftop",
      tagId: 609
    }, {
      id: 10,
      label: "Basement",
      tagId: 629
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_FACILITIES */.gT.tagCategory.TAG_CATEGORY_FACILITIES,
    icon: config/* Images.iconTagView */.rU.iconTagView,
    width: 20,
    height: 20,
    title: "Facilities",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Indoor Pool",
      tagId: 2601
    }, {
      id: 2,
      label: "Outdoor Pool",
      tagId: 2602
    }, {
      id: 3,
      label: "Hot Tub",
      tagId: 2603
    }, {
      id: 4,
      label: "Outdoor Hot Tub",
      tagId: 2604
    }, {
      id: 5,
      label: "Sauna",
      tagId: 2605
    }, {
      id: 6,
      label: "Steam Room",
      tagId: 2606
    }, {
      id: 7,
      label: "Hydrotherapy Pool",
      tagId: 2607
    }, {
      id: 8,
      label: "Experience Showers",
      tagId: 2608
    }, {
      id: 9,
      label: "Ice Room / Fountain",
      tagId: 2609
    }, {
      id: 10,
      label: "Plunge Pool",
      tagId: 2610
    }, {
      id: 11,
      label: "Gym",
      tagId: 2611
    }, {
      id: 12,
      label: "Solarium",
      tagId: 2612
    }, {
      id: 13,
      label: "Relaxation Room",
      tagId: 2613
    }, {
      id: 14,
      label: "Other Rooms",
      tagId: 2614
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_TREATMENTS */.gT.tagCategory.TAG_CATEGORY_TREATMENTS,
    icon: config/* Images.iconTagParticipation */.rU.iconTagParticipation,
    width: 20,
    height: 20,
    title: "Treatments",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Manicure",
      tagId: 2701
    }, {
      id: 2,
      label: "Massage",
      tagId: 2702
    }, {
      id: 3,
      label: "Facial",
      tagId: 2703
    }, {
      id: 5,
      label: "Pedicure",
      tagId: 2704
    }, {
      id: 6,
      label: "Body",
      tagId: 2705
    }, {
      id: 7,
      label: "Rasul",
      tagId: 2706
    }, {
      id: 8,
      label: "Rituals",
      tagId: 2707
    }, {
      id: 9,
      label: "Other",
      tagId: 2708
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_ROOFTOP_SIZE */.gT.tagCategory.TAG_CATEGORY_ROOFTOP_SIZE,
    icon: config/* Images.iconTagSize */.rU.iconTagSize,
    width: 20,
    height: 20,
    title: "Size",
    isHide: false,
    detailList: [{
      id: 1,
      label: "XS",
      suffix: "0-20",
      tagId: 2401
    }, {
      id: 2,
      label: "S",
      suffix: "21-50",
      tagId: 2402
    }, {
      id: 3,
      label: "M",
      suffix: "51-100",
      tagId: 2403
    }, {
      id: 4,
      label: "L",
      suffix: "101-200",
      tagId: 2404
    }, {
      id: 5,
      label: "XL",
      suffix: "201-500",
      tagId: 2405
    }, {
      id: 6,
      label: "XXL",
      suffix: "500+",
      tagId: 2406
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PRICE_VENUE */.gT.tagCategory.TAG_CATEGORY_PRICE_VENUE,
    icon: config/* Images.iconTagPrice */.rU.iconTagPrice,
    width: 20,
    height: 20,
    title: "Price",
    isHide: false,
    detailList: [{
      id: 1,
      label: "1",
      tagId: 1501,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }, {
      id: 2,
      label: "2",
      tagId: 1502,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }, {
      id: 3,
      label: "3",
      tagId: 1503,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }, {
      id: 4,
      label: "4",
      tagId: 1504,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_AMENITIES */.gT.tagCategory.TAG_CATEGORY_AMENITIES,
    icon: config/* Images.iconTagAmenities */.rU.iconTagAmenities,
    width: 20,
    height: 20,
    title: "Amenities",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Lounge / Bar",
      tagId: 33
    }, {
      id: 2,
      label: "Restaurant",
      tagId: 44
    }, {
      id: 3,
      label: "Nightclub",
      tagId: 45
    }, {
      id: 4,
      label: "Salon",
      tagId: 46
    }, {
      id: 5,
      label: "Golf",
      tagId: 47
    }, {
      id: 6,
      label: "Tennis",
      tagId: 48
    }, {
      id: 7,
      label: "Parking",
      tagId: 49
    }, {
      id: 8,
      label: "Accessibility",
      tagId: 50
    }, {
      id: 9,
      label: "Pet Friendly",
      tagId: 51
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Status",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Open",
      tagId: 1
    }, {
      id: 2,
      label: "Closed",
      tagId: 2
    }, {
      id: 3,
      label: "Temporarily Closed",
      tagId: 4
    }, {
      id: 4,
      label: "Permanently Closed",
      tagId: 3
    }],
    selectedList: [1, 2, 4]
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RATING */.gT.tagCategory.TAG_CATEGORY_RATING,
    icon: config/* Images.iconTagRating */.rU.iconTagRating,
    width: 21.5,
    height: isMobileVersion ? 21 : 20,
    title: "Rating",
    isHide: true,
    isRating: true,
    detailList: [{
      id: 1,
      label: "1",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating1 */.rU.iconTagRating1,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 2,
      label: "2",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating2 */.rU.iconTagRating2,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 3,
      label: "3",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating3 */.rU.iconTagRating3,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 4,
      label: "4",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating4 */.rU.iconTagRating4,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 5,
      label: "5",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating5 */.rU.iconTagRating5,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }],
    selectedList: []
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/venue_beachful.js





var venueBeachfulFilterCriteria = function venueBeachfulFilterCriteria(isMobileVersion, styles) {
  return [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_VENUE */.gT.tagCategory.TAG_CATEGORY_VENUE,
    icon: config/* Images.iconTagGeneral */.rU.iconTagGeneral,
    width: 20,
    height: 20,
    title: "Venue",
    isHide: false,
    detailList: [{
      id: 7,
      label: "Indoor & Outdoor",
      tagId: 801
    }, {
      id: 8,
      label: "Indoor Only",
      tagId: 802
    }, {
      id: 9,
      label: "Outdoor Only",
      tagId: 803
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_ROOFTOP_FEATURES */.gT.tagCategory.TAG_CATEGORY_ROOFTOP_FEATURES,
    icon: config/* Images.iconTagLightning */.rU.iconTagLightning,
    width: 20,
    height: 20,
    title: "Features",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Party",
      tagId: 627
    }, {
      id: 2,
      label: "Vibey",
      tagId: 640
    }, {
      id: 3,
      label: "Relax",
      tagId: 641
    }, {
      id: 4,
      label: "Family",
      tagId: 642
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_SERVICE */.gT.tagCategory.TAG_CATEGORY_SERVICE,
    icon: config/* Images.iconTagService */.rU.iconTagService,
    width: 20,
    height: 20,
    title: "Service",
    isHide: false,
    detailList: [{
      id: 2,
      label: "Bar",
      tagId: 1602
    }, {
      id: 3,
      label: "Restaurant",
      tagId: 1603
    }, {
      id: 1,
      label: "Club",
      tagId: 1601
    }, {
      id: 4,
      label: "Wellness",
      tagId: 1604
    }, {
      id: 5,
      label: "Other",
      tagId: 1605
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_BEACHFUL_FACILITIES */.gT.tagCategory.TAG_CATEGORY_BEACHFUL_FACILITIES,
    icon: config/* Images.iconTagAmenities */.rU.iconTagAmenities,
    width: 20,
    height: 20,
    title: "Facilities",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Beach",
      tagId: 2801
    }, {
      id: 2,
      label: "Pool",
      tagId: 2802
    }, {
      id: 3,
      label: "Hot Tub",
      tagId: 2803
    }, {
      id: 4,
      label: "WiFi",
      tagId: 2804
    }, {
      id: 5,
      label: "Live Music",
      tagId: 2805
    }, {
      id: 6,
      label: "Hotel",
      tagId: 2806
    }, {
      id: 7,
      label: "Parking",
      tagId: 2807
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_ROOFTOP_SIZE */.gT.tagCategory.TAG_CATEGORY_ROOFTOP_SIZE,
    icon: config/* Images.iconTagSize */.rU.iconTagSize,
    width: 20,
    height: 20,
    title: "Size",
    isHide: false,
    detailList: [{
      id: 1,
      label: "XS",
      suffix: "0-20",
      tagId: 2401
    }, {
      id: 2,
      label: "S",
      suffix: "21-50",
      tagId: 2402
    }, {
      id: 3,
      label: "M",
      suffix: "51-100",
      tagId: 2403
    }, {
      id: 4,
      label: "L",
      suffix: "101-200",
      tagId: 2404
    }, {
      id: 5,
      label: "XL",
      suffix: "201-500",
      tagId: 2405
    }, {
      id: 6,
      label: "XXL",
      suffix: "500+",
      tagId: 2406
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PRICE_VENUE */.gT.tagCategory.TAG_CATEGORY_PRICE_VENUE,
    icon: config/* Images.iconTagPrice */.rU.iconTagPrice,
    width: 20,
    height: 20,
    title: "Price",
    isHide: false,
    detailList: [{
      id: 1,
      label: "1",
      tagId: 1501,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }, {
      id: 2,
      label: "2",
      tagId: 1502,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }, {
      id: 3,
      label: "3",
      tagId: 1503,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPriceGray */.rU.iconTagPriceGray,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }, {
      id: 4,
      label: "4",
      tagId: 1504,
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: styles.row,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 6 : 15
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            marginRight: isMobileVersion ? 0 : 3
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTagPrice */.rU.iconTagPrice,
            width: isMobileVersion ? 16 : 24,
            height: isMobileVersion ? 16 : 24,
            layout: "fixed"
          })
        })]
      })
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_AREA */.gT.tagCategory.TAG_CATEGORY_AREA,
    icon: config/* Images.iconTagArea */.rU.iconTagArea,
    width: 20,
    height: 20,
    title: "Area",
    isHide: false,
    detailList: [{
      id: 1,
      label: "City",
      tagId: 901
    }, {
      id: 2,
      label: "Town",
      tagId: 902
    }, {
      id: 3,
      label: "Countryside",
      tagId: 903
    }, {
      id: 4,
      label: "Field",
      tagId: 904
    }, {
      id: 5,
      label: "Forest",
      tagId: 905
    }, {
      id: 6,
      label: "Lake",
      tagId: 906
    }, {
      id: 7,
      label: "Beach",
      tagId: 907
    }, {
      id: 8,
      label: "Mountain",
      tagId: 908
    }, {
      id: 9,
      label: "Park",
      tagId: 909
    }, {
      id: 10,
      label: "Resort",
      tagId: 910
    }, {
      id: 11,
      label: "Unique Location",
      tagId: 911
    }, {
      id: 12,
      label: "Ship",
      tagId: 912
    }, {
      id: 13,
      label: "Other",
      tagId: 913
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_ENTRY */.gT.tagCategory.TAG_CATEGORY_ENTRY,
    icon: config/* Images.iconTagEntry */.rU.iconTagEntry,
    width: 20,
    height: 20,
    title: "Entry",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Guestlist",
      tagId: 1201
    }, {
      id: 2,
      label: "Table",
      tagId: 1202
    }, {
      id: 3,
      label: "Tickets",
      tagId: 1203
    }, {
      id: 4,
      label: "Door",
      tagId: 1204
    }, {
      id: 5,
      label: "Free",
      tagId: 1205
    }, {
      id: 6,
      label: "Min Spend",
      tagId: 1206
    }, {
      id: 7,
      label: "Fee",
      tagId: 1208
    }, {
      id: 8,
      label: "N/A",
      tagId: 1207
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Status",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Open",
      tagId: 1
    }, {
      id: 2,
      label: "Closed",
      tagId: 2
    }, {
      id: 3,
      label: "Temporarily Closed",
      tagId: 4
    }, {
      id: 4,
      label: "Permanently Closed",
      tagId: 3
    }],
    selectedList: [1, 2, 4]
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RATING */.gT.tagCategory.TAG_CATEGORY_RATING,
    icon: config/* Images.iconTagRating */.rU.iconTagRating,
    width: 21.5,
    height: isMobileVersion ? 21 : 20,
    title: "Rating",
    isHide: true,
    isRating: true,
    detailList: [{
      id: 1,
      label: "1",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating1 */.rU.iconTagRating1,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 2,
      label: "2",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating2 */.rU.iconTagRating2,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 3,
      label: "3",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating3 */.rU.iconTagRating3,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 4,
      label: "4",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating4 */.rU.iconTagRating4,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 5,
      label: "5",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating5 */.rU.iconTagRating5,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }],
    selectedList: []
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/prefab_company.js




var prefabCompanyFilterCriteria = function prefabCompanyFilterCriteria(isMobileVersion, styles) {
  return [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY */.gT.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY,
    icon: config/* Images.iconTagFeature */.rU.iconTagFeature,
    width: 20,
    height: 20,
    title: "Category",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Big Home",
      tagId: 2901
    }, {
      id: 2,
      label: "Tiny Home",
      tagId: 2902
    }, {
      id: 3,
      label: "Guesthouse",
      tagId: 2903
    }, {
      id: 4,
      label: "Office / Studio",
      tagId: 2904
    }, {
      id: 5,
      label: "Mobile on Wheels",
      tagId: 2905
    }, {
      id: 6,
      label: "Cabin / Bunkie",
      tagId: 2906
    }, {
      id: 7,
      label: "A-Frame",
      tagId: 2907
    }, {
      id: 8,
      label: "Container",
      tagId: 2908
    }, {
      id: 9,
      label: "Tent",
      tagId: 2909
    }, {
      id: 10,
      label: "Yurt",
      tagId: 2910
    }, {
      id: 11,
      label: "Dome",
      tagId: 2911
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT */.gT.tagCategory.TAG_CATEGORY_SIZE_SQFT,
    icon: config/* Images.iconTagSize */.rU.iconTagSize,
    width: 20,
    height: 20,
    title: "Size",
    isHide: false,
    isRangeValue: true,
    detailList: [{
      id: 1,
      label: "XS - 0-200 sqft",
      value: {
        minValue: 0,
        maxValue: 200
      }
    }, {
      id: 2,
      label: "S - 200-500 sqft",
      value: {
        minValue: 200,
        maxValue: 500
      }
    }, {
      id: 3,
      label: "M - 500-1k sqft",
      value: {
        minValue: 500,
        maxValue: 1000
      }
    }, {
      id: 4,
      label: "L - 1-2k sqft",
      value: {
        minValue: 1000,
        maxValue: 2000
      }
    }, {
      id: 5,
      label: "XL 2-5k sqft",
      value: {
        minValue: 2000,
        maxValue: 5000
      }
    }, {
      id: 6,
      label: "XXL - +5k sqft",
      value: {
        minValue: 5000
      }
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PRICE */.gT.tagCategory.TAG_CATEGORY_PRICE,
    icon: config/* Images.iconTagPrice */.rU.iconTagPrice,
    width: 20,
    height: 20,
    title: "Price",
    isHide: false,
    isRangeValue: true,
    detailList: [{
      id: 1,
      label: "$0 - $10k",
      value: {
        minValue: 0,
        maxValue: 10000
      }
    }, {
      id: 2,
      label: "$10k - $20k",
      value: {
        minValue: 10000,
        maxValue: 20000
      }
    }, {
      id: 3,
      label: "$20k - $50k",
      value: {
        minValue: 20000,
        maxValue: 50000
      }
    }, {
      id: 4,
      label: "$50k - $100k",
      value: {
        minValue: 50000,
        maxValue: 100000
      }
    }, {
      id: 5,
      label: "$100k - $200k",
      value: {
        minValue: 100000,
        maxValue: 200000
      }
    }, {
      id: 6,
      label: "$200k - $500k",
      value: {
        minValue: 200000,
        maxValue: 500000
      }
    }, {
      id: 7,
      label: "$500k - $1m",
      value: {
        minValue: 500000,
        maxValue: 1000000
      }
    }, {
      id: 8,
      label: "+$1m",
      value: {
        minValue: 1000000
      }
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING */.gT.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING,
    icon: config/* Images.iconTagGeneral */.rU.iconTagGeneral,
    width: 20,
    height: 20,
    title: "Assembling",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Pre-Assembled - Mobile Home",
      tagId: 3901
    }, {
      id: 2,
      label: "Pre-Assembled",
      tagId: 3902
    }, {
      id: 3,
      label: "Assembled On-Site",
      tagId: 3903
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_HOME_LISTED */.gT.tagCategory.TAG_CATEGORY_HOME_LISTED,
    icon: config/* Images.iconTagGeneral */.rU.iconTagGeneral,
    width: 20,
    height: 20,
    title: "Homes Listed",
    isHide: false,
    isCompanyHomeSize: true,
    detailList: [{
      id: 1,
      label: "0-5",
      value: {
        minValue: 0,
        maxValue: 5
      }
    }, {
      id: 2,
      label: "6-10",
      value: {
        minValue: 6,
        maxValue: 10
      }
    }, {
      id: 3,
      label: "+10",
      value: {
        minValue: 11
      }
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RATING */.gT.tagCategory.TAG_CATEGORY_RATING,
    icon: config/* Images.iconTagRating */.rU.iconTagRating,
    width: 21.5,
    height: isMobileVersion ? 21 : 20,
    title: "Rating",
    isHide: true,
    isRating: true,
    detailList: [{
      id: 1,
      label: "1",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating1 */.rU.iconTagRating1,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 2,
      label: "2",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating2 */.rU.iconTagRating2,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 3,
      label: "3",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating3 */.rU.iconTagRating3,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 4,
      label: "4",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating4 */.rU.iconTagRating4,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 5,
      label: "5",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating5 */.rU.iconTagRating5,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }],
    selectedList: []
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/prefab_home.js




var prefabHomeFilterCriteria = function prefabHomeFilterCriteria(isMobileVersion, styles) {
  return [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY */.gT.tagCategory.TAG_CATEGORY_PREFAB_CATEGORY,
    icon: config/* Images.iconTagFeature */.rU.iconTagFeature,
    width: 20,
    height: 20,
    title: "Category",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Big Home",
      tagId: 2901
    }, {
      id: 2,
      label: "Tiny Home",
      tagId: 2902
    }, {
      id: 3,
      label: "Guesthouse",
      tagId: 2903
    }, {
      id: 4,
      label: "Office / Studio",
      tagId: 2904
    }, {
      id: 5,
      label: "Mobile on Wheels",
      tagId: 2905
    }, {
      id: 6,
      label: "Cabin / Bunkie",
      tagId: 2906
    }, {
      id: 7,
      label: "A-Frame",
      tagId: 2907
    }, {
      id: 8,
      label: "Container",
      tagId: 2908
    }, {
      id: 9,
      label: "Tent",
      tagId: 2909
    }, {
      id: 10,
      label: "Yurt",
      tagId: 2910
    }, {
      id: 11,
      label: "Dome",
      tagId: 2911
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT */.gT.tagCategory.TAG_CATEGORY_SIZE_SQFT,
    icon: config/* Images.iconTagSize */.rU.iconTagSize,
    width: 20,
    height: 20,
    title: "Size",
    isHide: false,
    isRangeValue: true,
    detailList: [{
      id: 1,
      label: "XS - 0-200 sqft",
      value: {
        minValue: 0,
        maxValue: 200
      }
    }, {
      id: 2,
      label: "S - 200-500 sqft",
      value: {
        minValue: 200,
        maxValue: 500
      }
    }, {
      id: 3,
      label: "M - 500-1k sqft",
      value: {
        minValue: 500,
        maxValue: 1000
      }
    }, {
      id: 4,
      label: "L - 1-2k sqft",
      value: {
        minValue: 1000,
        maxValue: 2000
      }
    }, {
      id: 5,
      label: "XL 2-5k sqft",
      value: {
        minValue: 2000,
        maxValue: 5000
      }
    }, {
      id: 6,
      label: "XXL - +5k sqft",
      value: {
        minValue: 5000
      }
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PRICE */.gT.tagCategory.TAG_CATEGORY_PRICE,
    icon: config/* Images.iconTagPrice */.rU.iconTagPrice,
    width: 20,
    height: 20,
    title: "Price",
    isHide: false,
    isRangeValue: true,
    detailList: [{
      id: 1,
      label: "$0 - $10k",
      value: {
        minValue: 0,
        maxValue: 10000
      }
    }, {
      id: 2,
      label: "$10k - $20k",
      value: {
        minValue: 10000,
        maxValue: 20000
      }
    }, {
      id: 3,
      label: "$20k - $50k",
      value: {
        minValue: 20000,
        maxValue: 50000
      }
    }, {
      id: 4,
      label: "$50k - $100k",
      value: {
        minValue: 50000,
        maxValue: 100000
      }
    }, {
      id: 5,
      label: "$100k - $200k",
      value: {
        minValue: 100000,
        maxValue: 200000
      }
    }, {
      id: 6,
      label: "$200k - $500k",
      value: {
        minValue: 200000,
        maxValue: 500000
      }
    }, {
      id: 7,
      label: "$500k - $1m",
      value: {
        minValue: 500000,
        maxValue: 1000000
      }
    }, {
      id: 8,
      label: "+$1m",
      value: {
        minValue: 1000000
      }
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PREFAB_BEDROOM */.gT.tagCategory.TAG_CATEGORY_PREFAB_BEDROOM,
    icon: config/* Images.iconTagGeneral */.rU.iconTagGeneral,
    width: 20,
    height: 20,
    title: "Bedrooms",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Studio",
      tagId: 3201
    }, {
      id: 2,
      label: "0",
      tagId: 3202
    }, {
      id: 3,
      label: "1",
      tagId: 3203
    }, {
      id: 4,
      label: "2",
      tagId: 3204
    }, {
      id: 5,
      label: "3",
      tagId: 3205
    }, {
      id: 6,
      label: "+4",
      tagId: 3206
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PREFAB_BATHROOM */.gT.tagCategory.TAG_CATEGORY_PREFAB_BATHROOM,
    icon: config/* Images.iconTagGeneral */.rU.iconTagGeneral,
    width: 20,
    height: 20,
    title: "Bathrooms",
    isHide: false,
    isRangeValue: true,
    detailList: [{
      id: 1,
      label: "0",
      value: {
        minValue: 0,
        maxValue: 0
      }
    }, {
      id: 2,
      label: "1",
      value: {
        minValue: 1,
        maxValue: 1
      }
    }, {
      id: 3,
      label: "2",
      value: {
        minValue: 2,
        maxValue: 2
      }
    }, {
      id: 4,
      label: "3",
      value: {
        minValue: 3,
        maxValue: 3
      }
    }, {
      id: 5,
      label: "+4",
      value: {
        minValue: 4
      }
    }],
    selectedList: []
  }, // {
  //   icon: Images.iconTagCountry,
  //   width: 16,
  //   height: 19.5,
  //   title: "Country",
  //   isHide: false,
  //   isSearchable: true,
  //   isCountry: true,
  //   detailList: [
  //     // from api country
  //   ],
  //   selectedList: [],
  // },
  {
    id: config/* Constants.tagCategory.TAG_CATEGORY_CAPACITY */.gT.tagCategory.TAG_CATEGORY_CAPACITY,
    icon: config/* Images.iconTagGeneral */.rU.iconTagGeneral,
    width: 20,
    height: 20,
    title: "Capacity",
    isHide: false,
    isRangeValue: true,
    detailList: [{
      id: 1,
      label: "1 People",
      value: {
        minValue: 1,
        maxValue: 1
      }
    }, {
      id: 2,
      label: "2 People",
      value: {
        minValue: 2,
        maxValue: 2
      }
    }, {
      id: 3,
      label: "3 People",
      value: {
        minValue: 3,
        maxValue: 3
      }
    }, {
      id: 4,
      label: "4 People",
      value: {
        minValue: 4,
        maxValue: 4
      }
    }, {
      id: 5,
      label: "5 People",
      value: {
        minValue: 5,
        maxValue: 5
      }
    }, {
      id: 6,
      label: "6 People",
      value: {
        minValue: 6,
        maxValue: 6
      }
    }, {
      id: 7,
      label: "7 People",
      value: {
        minValue: 7,
        maxValue: 7
      }
    }, {
      id: 8,
      label: "+8 People",
      value: {
        minValue: 8
      }
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PREFAB_OTHER_ROOM */.gT.tagCategory.TAG_CATEGORY_PREFAB_OTHER_ROOM,
    icon: config/* Images.iconTagGeneral */.rU.iconTagGeneral,
    width: 20,
    height: 20,
    title: "Other Rooms",
    isHide: false,
    detailList: [{
      id: 1,
      label: "No Kitchen",
      tagId: 3701
    }, {
      id: 2,
      label: "Kitchenette",
      tagId: 3702
    }, {
      id: 3,
      label: "Full Kitchen",
      tagId: 3703
    }, {
      id: null,
      label: null,
      isSeparator: true
    }, {
      id: 4,
      label: "0 Loft",
      tagId: 3801
    }, {
      id: 5,
      label: "1 Loft",
      tagId: 3802
    }, {
      id: 6,
      label: "2 Loft",
      tagId: 3803
    }, {
      id: 7,
      label: "+3 Loft",
      tagId: 3804
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING */.gT.tagCategory.TAG_CATEGORY_PREFAB_ASSEMBLING,
    icon: config/* Images.iconTagGeneral */.rU.iconTagGeneral,
    width: 20,
    height: 20,
    title: "Assembling",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Pre-Assembled - Mobile Home",
      tagId: 3901
    }, {
      id: 2,
      label: "Pre-Assembled",
      tagId: 3902
    }, {
      id: 3,
      label: "Assembled On-Site",
      tagId: 3903
    }],
    selectedList: []
  }, // {
  //   id: Constants.tagCategory.TAG_CATEGORY_PREFAB_DIMENSION_TYPE,
  //   icon: Images.iconTagStatus,
  //   width: 20,
  //   height: 20,
  //   title: "Dimensions",
  //   isHide: false,
  //   isDimension: true,
  //   detailList: [
  //     {
  //       id: 1,
  //       label: "ft",
  //       tagId: 3401,
  //     },
  //     {
  //       id: 2,
  //       label: "m",
  //       tagId: 3402,
  //     },
  //   ],
  //   selectedList: [],
  // },
  {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RATING */.gT.tagCategory.TAG_CATEGORY_RATING,
    icon: config/* Images.iconTagRating */.rU.iconTagRating,
    width: 21.5,
    height: isMobileVersion ? 21 : 20,
    title: "Rating",
    isHide: true,
    isRating: true,
    detailList: [{
      id: 1,
      label: "1",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating1 */.rU.iconTagRating1,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 2,
      label: "2",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating2 */.rU.iconTagRating2,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 3,
      label: "3",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating3 */.rU.iconTagRating3,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 4,
      label: "4",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating4 */.rU.iconTagRating4,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 5,
      label: "5",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating5 */.rU.iconTagRating5,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }],
    selectedList: []
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/zoo.js




var zooFilterCriteria = function zooFilterCriteria(isMobileVersion, styles) {
  return [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Status",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Open",
      tagId: 1
    }, {
      id: 2,
      label: "Closed",
      tagId: 2
    }, {
      id: 3,
      label: "Temporarily Closed",
      tagId: 4
    }, {
      id: 4,
      label: "Permanently Closed",
      tagId: 3
    }],
    selectedList: [1, 2, 4]
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_ZOO_CATEGORY */.gT.tagCategory.TAG_CATEGORY_ZOO_CATEGORY,
    icon: config/* Images.iconTagFeature */.rU.iconTagFeature,
    width: 20,
    height: 20,
    title: "Category",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Zoo",
      tagId: 4001
    }, {
      id: 2,
      label: "Wildlife Park",
      tagId: 4002
    }, {
      id: 3,
      label: "Animal sanctuary",
      tagId: 4003
    }, {
      id: 4,
      label: "Aquarium",
      tagId: 4004
    }, {
      id: 5,
      label: "Marine mammal park",
      tagId: 4005
    }, {
      id: 6,
      label: "Penguinarium",
      tagId: 4006
    }, {
      id: 7,
      label: "Dolphinarium",
      tagId: 4007
    }, {
      id: 8,
      label: "Nocturnal house",
      tagId: 4008
    }, {
      id: 9,
      label: "Aviary",
      tagId: 4009
    }, {
      id: 10,
      label: "Petting zoo",
      tagId: 4010
    }, {
      id: 11,
      label: "Animal theme park",
      tagId: 4011
    }, {
      id: 12,
      label: "Reptilarium",
      tagId: 4012
    }, {
      id: 13,
      label: "Herpetarium",
      tagId: 4013
    }, {
      id: 14,
      label: "Serpentarium",
      tagId: 4014
    }, {
      id: 15,
      label: "Farm",
      tagId: 4015
    }, {
      id: 16,
      label: "Oceanarium",
      tagId: 4016
    }],
    selectedList: []
  }, // {
  //   id: Constants.tagCategory.TAG_CATEGORY_ANIMAL_LINKED,
  //   icon: Images.iconTagSize,
  //   width: 20,
  //   height: 20,
  //   title: "Animals Linked",
  //   isHide: false,
  //   detailList: [
  //     {
  //       id: 0,
  //       label: "N/A",
  //       value: null,
  //     },
  //     {
  //       id: 1,
  //       label: "0-10",
  //       value: { minValue: 0, maxValue: 10 },
  //     },
  //     {
  //       id: 2,
  //       label: "11-50",
  //       value: { minValue: 11, maxValue: 50 },
  //     },
  //     {
  //       id: 3,
  //       label: "51-100",
  //       value: { minValue: 51, maxValue: 100 },
  //     },
  //     {
  //       id: 4,
  //       label: "101-200",
  //       value: { minValue: 101, maxValue: 200 },
  //     },
  //     {
  //       id: 5,
  //       label: "+200",
  //       value: { minValue: 200 },
  //     },
  //   ],
  //   selectedList: [],
  // },
  {
    id: config/* Constants.tagCategory.TAG_CATEGORY_ZOO_SPECIES */.gT.tagCategory.TAG_CATEGORY_ZOO_SPECIES,
    icon: config/* Images.iconTagSize */.rU.iconTagSize,
    width: 20,
    height: 20,
    title: "Animals",
    isHide: false,
    isRangeValue: true,
    detailList: [{
      id: 0,
      label: "N/A",
      value: null
    }, {
      id: 1,
      label: "0-10",
      value: {
        minValue: 0,
        maxValue: 10
      }
    }, {
      id: 2,
      label: "11-50",
      value: {
        minValue: 11,
        maxValue: 50
      }
    }, {
      id: 3,
      label: "51-100",
      value: {
        minValue: 51,
        maxValue: 100
      }
    }, {
      id: 4,
      label: "101-200",
      value: {
        minValue: 101,
        maxValue: 200
      }
    }, {
      id: 5,
      label: "201-500",
      value: {
        minValue: 201,
        maxValue: 500
      }
    }, {
      id: 6,
      label: "+500",
      value: {
        minValue: 500
      }
    }],
    selectedList: []
  }, // {
  //   id: Constants.tagCategory.TAG_CATEGORY_ZOO_SPECIES,
  //   icon: Images.iconTagSize,
  //   width: 20,
  //   height: 20,
  //   title: "Population",
  //   isHide: false,
  //   isRangeValue: true,
  //   detailList: [
  //     {
  //       id: 0,
  //       label: "N/A",
  //       value: null,
  //     },
  //     {
  //       id: 1,
  //       label: "0-100",
  //       value: { minValue: 0, maxValue: 100 },
  //     },
  //     {
  //       id: 2,
  //       label: "100-500",
  //       value: { minValue: 100, maxValue: 500 },
  //     },
  //     {
  //       id: 3,
  //       label: "500-1,000",
  //       value: { minValue: 500, maxValue: 1000 },
  //     },
  //     {
  //       id: 4,
  //       label: "1,000-2,000",
  //       value: { minValue: 1000, maxValue: 2000 },
  //     },
  //     {
  //       id: 5,
  //       label: "+2,000",
  //       value: { minValue: 2000 },
  //     },
  //   ],
  //   selectedList: [],
  // },
  {
    id: config/* Constants.tagCategory.TAG_CATEGORY_SIZE_SQM */.gT.tagCategory.TAG_CATEGORY_SIZE_SQM,
    icon: config/* Images.iconTagSize */.rU.iconTagSize,
    width: 20,
    height: 20,
    title: "Size",
    isHide: false,
    detailList: [{
      id: 1,
      label: "XS - 0-10k sqm",
      tagId: 4601
    }, {
      id: 2,
      label: "S - 10-100k sqm",
      tagId: 4602
    }, {
      id: 3,
      label: "M - 100k-1m sqm",
      tagId: 4603
    }, {
      id: 4,
      label: "L - 1-10 sqkm",
      tagId: 4604
    }, {
      id: 5,
      label: "XL - 10-100 sqkm",
      tagId: 4605
    }, {
      id: 6,
      label: "XXL - +100 sqkm",
      tagId: 4606
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PRICE */.gT.tagCategory.TAG_CATEGORY_PRICE,
    icon: config/* Images.iconTagPrice */.rU.iconTagPrice,
    width: 20,
    height: 20,
    title: "Price",
    isHide: true,
    isRangeValue: true,
    detailList: [{
      id: 1,
      label: "$0 - $5",
      value: {
        minValue: 0,
        maxValue: 5
      }
    }, {
      id: 2,
      label: "$5 - $10",
      value: {
        minValue: 5,
        maxValue: 10
      }
    }, {
      id: 3,
      label: "$10 - $20",
      value: {
        minValue: 10,
        maxValue: 20
      }
    }, {
      id: 4,
      label: "$20 - $50",
      value: {
        minValue: 20,
        maxValue: 50
      }
    }, {
      id: 5,
      label: "+$50",
      value: {
        minValue: 50
      }
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RATING */.gT.tagCategory.TAG_CATEGORY_RATING,
    icon: config/* Images.iconTagRating */.rU.iconTagRating,
    width: 21.5,
    height: isMobileVersion ? 21 : 20,
    title: "Rating",
    isHide: true,
    isRating: true,
    detailList: [{
      id: 1,
      label: "1",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating1 */.rU.iconTagRating1,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 2,
      label: "2",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating2 */.rU.iconTagRating2,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 3,
      label: "3",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating3 */.rU.iconTagRating3,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 4,
      label: "4",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating4 */.rU.iconTagRating4,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 5,
      label: "5",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating5 */.rU.iconTagRating5,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }],
    selectedList: []
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/animal.js




var animalFilterCriteria = function animalFilterCriteria(isMobileVersion, styles) {
  return [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_ANIMAL_CATEGORY */.gT.tagCategory.TAG_CATEGORY_ANIMAL_CATEGORY,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Category",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Mammal",
      tagId: 4401
    }, {
      id: 2,
      label: "Bird",
      tagId: 4402
    }, {
      id: 3,
      label: "Reptile",
      tagId: 4403
    }, {
      id: 4,
      label: "Amphibian",
      tagId: 4404
    }, {
      id: 5,
      label: "Fish",
      tagId: 4405
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_ANIMAL_HABITAT */.gT.tagCategory.TAG_CATEGORY_ANIMAL_HABITAT,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Habitat",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Earth",
      tagId: 4501
    }, {
      id: 2,
      label: "Water",
      tagId: 4502
    }, {
      id: 3,
      label: "Air",
      tagId: 4503
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_ANIMAL_LOCATION */.gT.tagCategory.TAG_CATEGORY_ANIMAL_LOCATION,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Locations",
    isHide: false,
    detailList: [{
      id: 1,
      label: "0-5",
      value: {
        minValue: 0,
        maxValue: 5
      }
    }, {
      id: 2,
      label: "6-20",
      value: {
        minValue: 6,
        maxValue: 20
      }
    }, {
      id: 3,
      label: "21-50",
      value: {
        minValue: 21,
        maxValue: 50
      }
    }, {
      id: 4,
      label: "51-100",
      value: {
        minValue: 51,
        maxValue: 100
      }
    }, {
      id: 5,
      label: "+100",
      value: {
        minValue: 100
      }
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RATING */.gT.tagCategory.TAG_CATEGORY_RATING,
    icon: config/* Images.iconTagRating */.rU.iconTagRating,
    width: 21.5,
    height: isMobileVersion ? 21 : 20,
    title: "Rating",
    isHide: true,
    isRating: true,
    detailList: [{
      id: 1,
      label: "1",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating1 */.rU.iconTagRating1,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 2,
      label: "2",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating2 */.rU.iconTagRating2,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 3,
      label: "3",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating3 */.rU.iconTagRating3,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 4,
      label: "4",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating4 */.rU.iconTagRating4,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 5,
      label: "5",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating5 */.rU.iconTagRating5,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }],
    selectedList: []
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/parkful.js




var parkfulFilterCriteria = function parkfulFilterCriteria(isMobileVersion, styles) {
  return [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Status",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Open",
      tagId: 1
    }, {
      id: 2,
      label: "Closed",
      tagId: 2
    }, {
      id: 3,
      label: "Temporarily Closed",
      tagId: 4
    }, {
      id: 4,
      label: "Permanently Closed",
      tagId: 3
    }],
    selectedList: [1, 2, 4]
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_AMENITIES */.gT.tagCategory.TAG_CATEGORY_AMENITIES,
    icon: config/* Images.iconTagAmenities */.rU.iconTagAmenities,
    width: 20,
    height: 20,
    title: "Amenities",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Hotel",
      tagId: 52
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PARKFUL_CATEGORY */.gT.tagCategory.TAG_CATEGORY_PARKFUL_CATEGORY,
    icon: config/* Images.iconTagFeature */.rU.iconTagFeature,
    width: 20,
    height: 20,
    title: "Category",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Theme Park",
      tagId: 5501
    }, {
      id: 2,
      label: "Waterpark",
      tagId: 5502
    }, {
      id: 3,
      label: "Waterplay",
      tagId: 5503
    }, {
      id: 4,
      label: "Dark Ride Park",
      tagId: 5504
    }, {
      id: 5,
      label: "Ride Park",
      tagId: 5505
    }, {
      id: 6,
      label: "Children’s Role Play",
      tagId: 5506
    }, {
      id: 7,
      label: "Family Entertainment Center",
      tagId: 5507
    }, {
      id: 8,
      label: "Children’s Playroom",
      tagId: 5508
    }, {
      id: 9,
      label: "Trampoline Park",
      tagId: 5509
    }, {
      id: 10,
      label: "Escape Room",
      tagId: 5510
    }, {
      id: 11,
      label: "VR Attraction",
      tagId: 5511
    }, {
      id: 12,
      label: "Surf Wave",
      tagId: 5512
    }, {
      id: 13,
      label: "Laser Tag",
      tagId: 5513
    }, {
      id: 14,
      label: "Go Karts",
      tagId: 5514
    }, {
      id: 15,
      label: "Indoor Skydive",
      tagId: 5515
    }, {
      id: 16,
      label: "Bowling",
      tagId: 5516
    }, {
      id: 17,
      label: "Minigolf",
      tagId: 5517
    }, {
      id: 18,
      label: "Resort Park",
      tagId: 5518
    }, {
      id: 19,
      label: "Marine Animal",
      tagId: 5519
    }, {
      id: 20,
      label: "Show Based",
      tagId: 5520
    }, {
      id: 21,
      label: "Cultural Attraction",
      tagId: 5521
    }, {
      id: 22,
      label: "Adventure Park",
      tagId: 5522
    }, {
      id: 23,
      label: "Agricultural Attraction",
      tagId: 5523
    }, {
      id: 24,
      label: "Indoor Ice, Ski & Snow",
      tagId: 5524
    }, {
      id: 25,
      label: "Marine Interaction",
      tagId: 5525
    }, {
      id: 26,
      label: "Gardens",
      tagId: 5526
    }, {
      id: 27,
      label: "Wildlife-Based Attraction",
      tagId: 5527
    }, {
      id: 28,
      label: "Animal-based attractions",
      tagId: 5528
    }, {
      id: 29,
      label: "Minilands",
      tagId: 5529
    }, {
      id: 30,
      label: "Factory Tours",
      tagId: 5530
    }, {
      id: 31,
      label: "Art and Culture Museums",
      tagId: 5531
    }, {
      id: 32,
      label: "Interactive Museums",
      tagId: 5532
    }, {
      id: 33,
      label: "Observatory/Wheels",
      tagId: 5533
    }, {
      id: 34,
      label: "Flying Theater",
      tagId: 5534
    }, {
      id: 35,
      label: "Dinner Theater",
      tagId: 5535
    }, {
      id: 36,
      label: "Themed Village",
      tagId: 5536
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_PARKFUL_SIZE */.gT.tagCategory.TAG_CATEGORY_PARKFUL_SIZE,
    icon: config/* Images.iconTagSize */.rU.iconTagSize,
    width: 20,
    height: 20,
    title: "Size",
    isHide: false,
    detailList: [{
      id: 1,
      label: "XS - 0-20k sqm",
      tagId: 5601
    }, {
      id: 2,
      label: "S - 20-100k sqm",
      tagId: 5602
    }, {
      id: 3,
      label: "M - 100-1,000k sqm",
      tagId: 5603
    }, {
      id: 4,
      label: "L - 1,000-5,000k sqm",
      tagId: 5604
    }, {
      id: 5,
      label: "XL - +5,000k sqm",
      tagId: 4605
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RATING */.gT.tagCategory.TAG_CATEGORY_RATING,
    icon: config/* Images.iconTagRating */.rU.iconTagRating,
    width: 21.5,
    height: isMobileVersion ? 21 : 20,
    title: "Rating",
    isHide: true,
    isRating: true,
    detailList: [{
      id: 1,
      label: "1",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating1 */.rU.iconTagRating1,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 2,
      label: "2",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating2 */.rU.iconTagRating2,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 3,
      label: "3",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating3 */.rU.iconTagRating3,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 4,
      label: "4",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating4 */.rU.iconTagRating4,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 5,
      label: "5",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating5 */.rU.iconTagRating5,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }],
    selectedList: []
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/casino.js




var casinoFilterCriteria = function casinoFilterCriteria(isMobileVersion, styles) {
  return [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Status",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Open",
      tagId: 1
    }, {
      id: 2,
      label: "Closed",
      tagId: 2
    }, {
      id: 3,
      label: "Temporarily Closed",
      tagId: 4
    }, {
      id: 4,
      label: "Permanently Closed",
      tagId: 3
    }],
    selectedList: [1, 2, 4]
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_CASINO_CATEGORY */.gT.tagCategory.TAG_CATEGORY_CASINO_CATEGORY,
    icon: config/* Images.iconTagEventType */.rU.iconTagEventType,
    width: 20,
    height: 20,
    title: "Category",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Basic",
      tagId: 5101
    }, {
      id: 2,
      label: "Premium",
      tagId: 5102
    }, {
      id: 3,
      label: "Luxury",
      tagId: 5103
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_CASINO_FEATURE */.gT.tagCategory.TAG_CATEGORY_CASINO_FEATURE,
    icon: config/* Images.iconTagFeature */.rU.iconTagFeature,
    width: 20,
    height: 20,
    title: "Features",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Hotel",
      tagId: 5201
    }, {
      id: 2,
      label: "Restaurant",
      tagId: 5202
    }, {
      id: 3,
      label: "Bar",
      tagId: 5203
    }, {
      id: 4,
      label: "Nightlife",
      tagId: 5204
    }, {
      id: 5,
      label: "Attraction",
      tagId: 5205
    }, {
      id: 6,
      label: "Shop",
      tagId: 5206
    }, {
      id: 7,
      label: "Pool",
      tagId: 5207
    }, {
      id: 8,
      label: "Spa",
      tagId: 5208
    }, {
      id: 9,
      label: "Golf",
      tagId: 5209
    }, {
      id: 10,
      label: "Convention",
      tagId: 5210
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_CASINO_GAMES */.gT.tagCategory.TAG_CATEGORY_CASINO_GAMES,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Games",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Casino",
      tagId: 5301
    }, {
      id: 2,
      label: "Poker",
      tagId: 5302
    }, {
      id: 3,
      label: "Machine Games",
      tagId: 5303
    }, {
      id: 4,
      label: "Bingo",
      tagId: 5304
    }, {
      id: 5,
      label: "Horse Racing",
      tagId: 5305
    }, {
      id: 6,
      label: "Sportsbook",
      tagId: 5306
    }, {
      id: 7,
      label: "Greyhounds",
      tagId: 5307
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_SIZE_SQFT */.gT.tagCategory.TAG_CATEGORY_SIZE_SQFT,
    icon: config/* Images.iconTagSize */.rU.iconTagSize,
    width: 20,
    height: 20,
    title: "Size",
    isHide: false,
    isRangeValue: true,
    detailList: [{
      id: 1,
      label: "XS",
      suffix: "0 - 10K sqft",
      value: {
        minValue: 0,
        maxValue: 10000
      }
    }, {
      id: 2,
      label: "S",
      suffix: "10K - 50K sqft",
      value: {
        minValue: 10000,
        maxValue: 50000
      }
    }, {
      id: 3,
      label: "M",
      suffix: "50K - 200K sqft",
      value: {
        minValue: 50000,
        maxValue: 200000
      }
    }, {
      id: 4,
      label: "L",
      suffix: "200K - 500K sqft",
      value: {
        minValue: 200000,
        maxValue: 500000
      }
    }, {
      id: 5,
      label: "XL",
      suffix: "500K - 1M sqft",
      value: {
        minValue: 500000,
        maxValue: 1000000
      }
    }, {
      id: 6,
      label: "XXL",
      suffix: "+1M sqft",
      value: {
        minValue: 1000000
      }
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RATING */.gT.tagCategory.TAG_CATEGORY_RATING,
    icon: config/* Images.iconTagRating */.rU.iconTagRating,
    width: 21.5,
    height: isMobileVersion ? 21 : 20,
    title: "Rating",
    isHide: true,
    isRating: true,
    detailList: [{
      id: 1,
      label: "1",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating1 */.rU.iconTagRating1,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 2,
      label: "2",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating2 */.rU.iconTagRating2,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 3,
      label: "3",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating3 */.rU.iconTagRating3,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 4,
      label: "4",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating4 */.rU.iconTagRating4,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 5,
      label: "5",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating5 */.rU.iconTagRating5,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }],
    selectedList: []
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/castle.js




var castleFilterCriteria = function castleFilterCriteria(isMobileVersion, styles) {
  return [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Status",
    isHide: true,
    detailList: [{
      id: 1,
      label: "Open",
      tagId: 1
    }, {
      id: 2,
      label: "Closed",
      tagId: 2
    }, {
      id: 3,
      label: "Temporarily Closed",
      tagId: 4
    }, {
      id: 4,
      label: "Permanently Closed",
      tagId: 3
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_AREA */.gT.tagCategory.TAG_CATEGORY_AREA,
    icon: config/* Images.iconTagArea */.rU.iconTagArea,
    width: 20,
    height: 20,
    title: "Area",
    isHide: false,
    detailList: [{
      id: 1,
      label: "City",
      tagId: 901
    }, {
      id: 2,
      label: "Town",
      tagId: 902
    }, {
      id: 3,
      label: "Countryside",
      tagId: 903
    }, {
      id: 4,
      label: "Field",
      tagId: 904
    }, {
      id: 5,
      label: "Forest",
      tagId: 905
    }, {
      id: 6,
      label: "Lake",
      tagId: 906
    }, {
      id: 7,
      label: "Beach",
      tagId: 907
    }, {
      id: 8,
      label: "Mountain",
      tagId: 908
    }, {
      id: 9,
      label: "Unique Location",
      tagId: 911
    }, {
      id: 10,
      label: "Other",
      tagId: 913
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_AMENITIES */.gT.tagCategory.TAG_CATEGORY_AMENITIES,
    icon: config/* Images.iconTagFeature */.rU.iconTagFeature,
    width: 20,
    height: 20,
    title: "Features",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Guided Visit",
      tagId: 53
    }, {
      id: 2,
      label: "Museum",
      tagId: 54
    }, {
      id: 3,
      label: "Restaurant",
      tagId: 55
    }, {
      id: 4,
      label: "Bar",
      tagId: 56
    }, {
      id: 5,
      label: "Hotel",
      tagId: 57
    }, {
      id: 6,
      label: "Wellness",
      tagId: 58
    }, {
      id: 7,
      label: "Park",
      tagId: 59
    }, {
      id: 8,
      label: "Event Venue",
      tagId: 60
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_CASTLE_SIZE */.gT.tagCategory.TAG_CATEGORY_CASTLE_SIZE,
    icon: config/* Images.iconTagSize */.rU.iconTagSize,
    width: 20,
    height: 20,
    title: "Size",
    isHide: false,
    detailList: [{
      id: 1,
      label: "XS",
      tagId: 6301
    }, {
      id: 2,
      label: "S",
      tagId: 6302
    }, {
      id: 3,
      label: "M",
      tagId: 6303
    }, {
      id: 4,
      label: "L",
      tagId: 6304
    }, {
      id: 5,
      label: "XL",
      tagId: 6305
    }, {
      id: 6,
      label: "XXL",
      tagId: 6306
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_CASTLE_CONDITION */.gT.tagCategory.TAG_CATEGORY_CASTLE_CONDITION,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Condition",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Poor",
      tagId: 6401
    }, {
      id: 2,
      label: "Decent",
      tagId: 6402
    }, {
      id: 3,
      label: "Good",
      tagId: 6403
    }, {
      id: 4,
      label: "Very Good",
      tagId: 6404
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RATING */.gT.tagCategory.TAG_CATEGORY_RATING,
    icon: config/* Images.iconTagRating */.rU.iconTagRating,
    width: 21.5,
    height: isMobileVersion ? 21 : 20,
    title: "Rating",
    isHide: true,
    isRating: true,
    detailList: [{
      id: 1,
      label: "1",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating1 */.rU.iconTagRating1,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 2,
      label: "2",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating2 */.rU.iconTagRating2,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 3,
      label: "3",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating3 */.rU.iconTagRating3,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 4,
      label: "4",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating4 */.rU.iconTagRating4,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 5,
      label: "5",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating5 */.rU.iconTagRating5,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }],
    selectedList: []
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/resort.js




var resortFilterCriteria = function resortFilterCriteria(isMobileVersion, styles) {
  return [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Status",
    isHide: true,
    detailList: [{
      id: 1,
      label: "Open",
      tagId: 1
    }, {
      id: 2,
      label: "Closed",
      tagId: 2
    }, {
      id: 3,
      label: "Temporarily Closed",
      tagId: 4
    }, {
      id: 4,
      label: "Permanently Closed",
      tagId: 3
    }],
    selectedList: [1, 2, 4]
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RESORT_CATEGORY */.gT.tagCategory.TAG_CATEGORY_RESORT_CATEGORY,
    icon: config/* Images.iconTagEventType */.rU.iconTagEventType,
    width: 20,
    height: 20,
    title: "Category",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Basic",
      tagId: 6501
    }, {
      id: 2,
      label: "Premium",
      tagId: 6502
    }, {
      id: 3,
      label: "Luxury",
      tagId: 6503
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RESORT_PRICE */.gT.tagCategory.TAG_CATEGORY_RESORT_PRICE,
    icon: config/* Images.iconTagPrice */.rU.iconTagPrice,
    width: 20,
    height: 20,
    title: "Price",
    isHide: false,
    detailList: [{
      id: 1,
      label: "$",
      tagId: 6701
    }, {
      id: 2,
      label: "$$",
      tagId: 6702
    }, {
      id: 3,
      label: "$$$",
      tagId: 6703
    }, {
      id: 4,
      label: "$$$$",
      tagId: 6704
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RESORT_FEATURE */.gT.tagCategory.TAG_CATEGORY_RESORT_FEATURE,
    icon: config/* Images.iconTagFeature */.rU.iconTagFeature,
    width: 20,
    height: 20,
    title: "Features",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Spa",
      tagId: 6601
    }, {
      id: 2,
      label: "Ski",
      tagId: 6602
    }, {
      id: 3,
      label: "Beach",
      tagId: 6603
    }, {
      id: 4,
      label: "Golf",
      tagId: 6604
    }, {
      id: 6,
      label: "Amusement Park",
      tagId: 6606
    }, {
      id: 7,
      label: "Casino",
      tagId: 6607
    }, {
      id: 8,
      label: "Island",
      tagId: 6608
    }, {
      id: 9,
      label: "Lake",
      tagId: 6609
    }, {
      id: 10,
      label: "Unique location",
      tagId: 6610
    }, {
      id: 11,
      label: "Sport",
      tagId: 6611
    }, {
      id: 12,
      label: "Historic",
      tagId: 6612
    }, {
      id: 13,
      label: "Ranch",
      tagId: 6613
    }, {
      id: 14,
      label: "Adult-Only",
      tagId: 6614
    }, {
      id: 15,
      label: "Nudist",
      tagId: 6615
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_STAR */.gT.tagCategory.TAG_CATEGORY_STAR,
    icon: config/* Images.iconTagStar */.rU.iconTagStar,
    width: 20,
    height: 20,
    title: "Stars",
    isHide: false,
    detailList: [{
      id: 1,
      label: "1",
      tagId: 7101
    }, {
      id: 2,
      label: "2",
      tagId: 7102
    }, {
      id: 3,
      label: "3",
      tagId: 7103
    }, {
      id: 4,
      label: "4",
      tagId: 7104
    }, {
      id: 5,
      label: "5",
      tagId: 7105
    }, {
      id: 6,
      label: "N/A",
      tagId: 7106
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RATING */.gT.tagCategory.TAG_CATEGORY_RATING,
    icon: config/* Images.iconTagRating */.rU.iconTagRating,
    width: 21.5,
    height: isMobileVersion ? 21 : 20,
    title: "Rating",
    isHide: true,
    isRating: true,
    detailList: [{
      id: 1,
      label: "1",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating1 */.rU.iconTagRating1,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 2,
      label: "2",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating2 */.rU.iconTagRating2,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 3,
      label: "3",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating3 */.rU.iconTagRating3,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 4,
      label: "4",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating4 */.rU.iconTagRating4,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 5,
      label: "5",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating5 */.rU.iconTagRating5,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }],
    selectedList: []
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/data/aparthotel.js




var aparthotelFilterCriteria = function aparthotelFilterCriteria(isMobileVersion, styles) {
  return [{
    title: "Location",
    isHide: isMobileVersion,
    isLocation: true
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS,
    icon: config/* Images.iconTagStatus */.rU.iconTagStatus,
    width: 20,
    height: 20,
    title: "Status",
    isHide: true,
    detailList: [{
      id: 1,
      label: "Open",
      tagId: 1
    }, {
      id: 2,
      label: "Closed",
      tagId: 2
    }, {
      id: 3,
      label: "Temporarily Closed",
      tagId: 4
    }, {
      id: 4,
      label: "Permanently Closed",
      tagId: 3
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_APARTHOTEL_CATEGORY */.gT.tagCategory.TAG_CATEGORY_APARTHOTEL_CATEGORY,
    icon: config/* Images.iconTagEventType */.rU.iconTagEventType,
    width: 20,
    height: 20,
    title: "Category",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Basic",
      tagId: 6801
    }, {
      id: 2,
      label: "Premium",
      tagId: 6802
    }, {
      id: 3,
      label: "Luxury",
      tagId: 6803
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_APARTHOTEL_PRICE */.gT.tagCategory.TAG_CATEGORY_APARTHOTEL_PRICE,
    icon: config/* Images.iconTagPrice */.rU.iconTagPrice,
    width: 20,
    height: 20,
    title: "Price",
    isHide: false,
    detailList: [{
      id: 1,
      label: "$",
      tagId: 6901
    }, {
      id: 2,
      label: "$$",
      tagId: 6902
    }, {
      id: 3,
      label: "$$$",
      tagId: 6903
    }, {
      id: 4,
      label: "$$$$",
      tagId: 6904
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_APARTHOTEL_FEATURE */.gT.tagCategory.TAG_CATEGORY_APARTHOTEL_FEATURE,
    icon: config/* Images.iconTagFeature */.rU.iconTagFeature,
    width: 20,
    height: 20,
    title: "Features",
    isHide: false,
    detailList: [{
      id: 1,
      label: "Kitchen",
      tagId: 7001
    }, {
      id: 2,
      label: "Washer",
      tagId: 7002
    }, {
      id: 3,
      label: "Dryer",
      tagId: 7003
    }, {
      id: 4,
      label: "Gym",
      tagId: 7004
    }, {
      id: 5,
      label: "Pool",
      tagId: 7005
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_STAR */.gT.tagCategory.TAG_CATEGORY_STAR,
    icon: config/* Images.iconTagStar */.rU.iconTagStar,
    width: 20,
    height: 20,
    title: "Stars",
    isHide: false,
    detailList: [{
      id: 1,
      label: "1",
      tagId: 7101
    }, {
      id: 2,
      label: "2",
      tagId: 7102
    }, {
      id: 3,
      label: "3",
      tagId: 7103
    }, {
      id: 4,
      label: "4",
      tagId: 7104
    }, {
      id: 5,
      label: "5",
      tagId: 7105
    }, {
      id: 6,
      label: "N/A",
      tagId: 7106
    }],
    selectedList: []
  }, {
    id: config/* Constants.tagCategory.TAG_CATEGORY_RATING */.gT.tagCategory.TAG_CATEGORY_RATING,
    icon: config/* Images.iconTagRating */.rU.iconTagRating,
    width: 21.5,
    height: isMobileVersion ? 21 : 20,
    title: "Rating",
    isHide: true,
    isRating: true,
    detailList: [{
      id: 1,
      label: "1",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating1 */.rU.iconTagRating1,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 2,
      label: "2",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating2 */.rU.iconTagRating2,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 3,
      label: "3",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating3 */.rU.iconTagRating3,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 4,
      label: "4",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating4 */.rU.iconTagRating4,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }, {
      id: 5,
      label: "5",
      prefixIcon: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: styles.row,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconTagRating5 */.rU.iconTagRating5,
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed"
        })
      })
    }],
    selectedList: []
  }];
};
;// CONCATENATED MODULE: ./src/modules/filter/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









































var FilterScreen = function FilterScreen(props) {
  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var router = (0,next_router.useRouter)(); // const {
  //   category,
  //   isSearch,
  //   keyword,
  //   locationDistance,
  //   locationSelected,
  //   sortBy,
  //   onApply,
  //   filterCriteriaListOriginal,
  //   filterTabSelected,
  // } = props.route?.params;

  var setShowFilter = props.setShowFilter,
      category = props.category,
      isSearch = props.isSearch,
      keyword = props.keyword,
      locationSelected = props.locationSelected,
      setLocationSelected = props.setLocationSelected,
      locationSelectedTemp = props.locationSelectedTemp,
      setLocationSelectedTemp = props.setLocationSelectedTemp,
      sortBy = props.sortBy,
      onApply = props.onApply,
      filterCriteriaListOriginal = props.filterCriteriaListOriginal,
      setFilterCriteriaListOriginal = props.setFilterCriteriaListOriginal,
      filterTabSelected = props.filterTabSelected,
      tabList = props.tabList,
      setTabList = props.setTabList,
      isMobileVersion = props.isMobileVersion,
      isChartsMode = props.isChartsMode;

  var _useState = (0,react.useState)(null),
      dataCategory = _useState[0],
      setDataCategory = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      selectedTabIndex = _useState3[0],
      setSelectedTabIndex = _useState3[1];

  var _useState4 = (0,react.useState)(null),
      filterCriteriaSelected = _useState4[0],
      setFilterCriteriaSelected = _useState4[1];

  var locationModal = (0,react.useRef)(null);

  var _useState5 = (0,react.useState)(filterCriteriaListOriginal || (category === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE ? venueFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP ? rooftopFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA ? spaFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL ? venueBeachfulFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? prefabCompanyFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES ? prefabHomeFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO ? zooFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? animalFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? parkfulFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO ? casinoFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE ? castleFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT ? resortFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL ? aparthotelFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? venueCocktailFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? eventFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? festivalFilterCriteria(isMobileVersion, filter_styles, isChartsMode) : category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? artistFilterCriteria(isMobileVersion, filter_styles, isChartsMode) : category === config/* Constants.categoryType.CATEGORY_PROMOTERS */.gT.categoryType.CATEGORY_PROMOTERS ? promoterFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_OTHER */.gT.categoryType.CATEGORY_OTHER ? otherFilterCriteria(isMobileVersion, filter_styles) : [])),
      filterCriteriaList = _useState5[0],
      setFilterCriteriaList = _useState5[1];

  var subFilterModal = (0,react.useRef)(null);

  var onLoad = function onLoad() {
    setIsLoading(true);
    DAO/* CategoryDao.find */.Rr.find().then(function (categories) {
      setDataCategory(find_default()(categories, {
        id: category
      }));
      setSelectedTabIndex(findIndex_default()(tabList, {
        id: filterTabSelected
      }) || 0);
    });

    if (category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL) {
      var status = [];
      var tagFilters = [];
      var startDateFrom = null;
      var startDateTo = null;
      var rating = null;
      var lineupSize = null;
      var price = null;

      if (filterCriteriaListOriginal) {
        filterCriteriaListOriginal.forEach(function (item) {
          if (item.selectedList) {
            var _item$selectedList, _item$selectedList2, _item$selectedList3, _item$selectedList7;

            if (item.isDate && ((_item$selectedList = item.selectedList) !== null && _item$selectedList !== void 0 && _item$selectedList.start || (_item$selectedList2 = item.selectedList) !== null && _item$selectedList2 !== void 0 && _item$selectedList2.isUpcoming || (_item$selectedList3 = item.selectedList) !== null && _item$selectedList3 !== void 0 && _item$selectedList3.isAnytime)) {
              var _item$selectedList4, _item$selectedList5;

              if ((_item$selectedList4 = item.selectedList) !== null && _item$selectedList4 !== void 0 && _item$selectedList4.start) {
                startDateFrom = item.selectedList.start;
                startDateTo = item.selectedList.end;
              } else if ((_item$selectedList5 = item.selectedList) !== null && _item$selectedList5 !== void 0 && _item$selectedList5.isUpcoming) {
                startDateFrom = moment_default()().format("YYYY-MM-DD");
                startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              }
            } else if (item.isLineup) {
              var _item$selectedList6;

              lineupSize = ((_item$selectedList6 = item.selectedList) === null || _item$selectedList6 === void 0 ? void 0 : _item$selectedList6.length) > 0 ? item.selectedList : null;
            } else if (item.isPrice && item.selectedList.length > 0) {
              price = item.selectedList[1] === 1000 ? {
                minValue: item.selectedList[0]
              } : {
                minValue: item.selectedList[0],
                maxValue: item.selectedList[1]
              };
            } else if (item.isRating && ((_item$selectedList7 = item.selectedList) === null || _item$selectedList7 === void 0 ? void 0 : _item$selectedList7.length) > 0) {
              rating = item.selectedList;
            } else if (item.id === config/* Constants.tagCategory.TAG_CATEGORY_STATUS */.gT.tagCategory.TAG_CATEGORY_STATUS) {
              status = item.selectedList;
            } else if (item.isAge) {
              if (item.selectedList.length > 0) {
                tagFilters.push({
                  tagId: 1101,
                  category: config/* Constants.tagCategory.TAG_CATEGORY_AGE */.gT.tagCategory.TAG_CATEGORY_AGE,
                  maxValue: item.selectedList[1],
                  unit: config/* Constants.tagUnit.TAG_UNIT_AGE */.gT.tagUnit.TAG_UNIT_AGE
                });
              }
            } else {
              if (item.selectedList.length > 0) {
                tagFilters.push({
                  category: item.id,
                  tags: item.selectedList
                });
              }
            }
          }
        });
        tagFilters = JSON.stringify(tagFilters);
      }

      DAO/* FestivalDao.find */.vB.find({
        startDateFrom: startDateFrom,
        startDateTo: startDateTo,
        keyword: keyword,
        pageIndex: 0,
        pageSize: 1,
        status: status.length > 0 ? status : null,
        tagFilters: tagFilters,
        filterFollowLogic: filterTabSelected,
        range: locationSelectedTemp !== null && locationSelectedTemp !== void 0 && locationSelectedTemp.city_id && (locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.distance) > 0 ? locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.distance : null,
        distanceUnit: locationSelectedTemp !== null && locationSelectedTemp !== void 0 && locationSelectedTemp.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
        countryId: locationSelectedTemp !== null && locationSelectedTemp !== void 0 && locationSelectedTemp.country_id ? [locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.country_id] : null,
        cityId: locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.city_id,
        sortType: sortBy,
        rating: rating,
        lineupSize: lineupSize,
        price: price,
        isFollowCount: 1
      }).then(function (result) {
        var _tabList = tabList;

        _tabList.forEach(function (item, index) {
          if (item.title === "All") {
            _tabList[index].count = result.totalCount;
          } else if (item.title === "Followed") {
            _tabList[index].count = result.followingCount;
          } else if (item.title === "Other") {
            _tabList[index].count = result.otherCount;
          }
        });

        setTabList(_tabList);
        setIsLoading(false);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST) {
      var _tagFilters = [];
      var countryId = locationSelectedTemp !== null && locationSelectedTemp !== void 0 && locationSelectedTemp.country_id ? [locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.country_id] : null;
      var activity = null;
      var _startDateFrom = null;
      var _startDateTo = null;
      var eventSize = null;

      if (filterCriteriaListOriginal) {
        filterCriteriaListOriginal.forEach(function (item) {
          if (item.selectedList) {
            var _item$selectedList8, _item$selectedList9, _item$selectedList10;

            if (item.isDate && ((_item$selectedList8 = item.selectedList) !== null && _item$selectedList8 !== void 0 && _item$selectedList8.start || (_item$selectedList9 = item.selectedList) !== null && _item$selectedList9 !== void 0 && _item$selectedList9.isUpcoming || (_item$selectedList10 = item.selectedList) !== null && _item$selectedList10 !== void 0 && _item$selectedList10.isAnytime)) {
              var _item$selectedList11, _item$selectedList12;

              if ((_item$selectedList11 = item.selectedList) !== null && _item$selectedList11 !== void 0 && _item$selectedList11.start) {
                _startDateFrom = item.selectedList.start;
                _startDateTo = item.selectedList.end;
              } else if ((_item$selectedList12 = item.selectedList) !== null && _item$selectedList12 !== void 0 && _item$selectedList12.isUpcoming) {
                _startDateFrom = moment_default()().format("YYYY-MM-DD");
                _startDateTo = moment_default()().add(3, "years").format("YYYY-MM-DD");
              }
            } else if (item.isEventSize) {
              var _item$selectedList13;

              eventSize = ((_item$selectedList13 = item.selectedList) === null || _item$selectedList13 === void 0 ? void 0 : _item$selectedList13.length) > 0 ? item.selectedList : null;
            } else if (item.isLocation && item.selectedList.length > 0) {
              countryId = item.selectedList;
            } else if (item.isActivity && item.selectedList.length > 0) {
              activity = item.selectedList;
            } else {
              if (item.selectedList.length > 0) {
                _tagFilters.push({
                  category: item.id,
                  tags: item.selectedList
                });
              }
            }
          }
        });
        _tagFilters = JSON.stringify(_tagFilters);
      }

      DAO/* ArtistDao.find */.uf.find({
        startDateFrom: _startDateFrom,
        startDateTo: _startDateTo,
        countryId: countryId,
        activity: activity,
        keyword: keyword,
        pageIndex: 0,
        tagFilters: _tagFilters,
        filterFollowLogic: filterTabSelected,
        pageSize: 1,
        cityId: locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.city_id,
        sortType: sortBy,
        eventSize: eventSize,
        isFollowCount: 1
      }).then(function (result) {
        var _tabList = tabList;

        _tabList.forEach(function (item, index) {
          if (item.title === "All") {
            _tabList[index].count = result.totalCount;
          } else if (item.title === "Followed") {
            _tabList[index].count = result.followingCount;
          } else if (item.title === "Other") {
            _tabList[index].count = result.otherCount;
          }
        });

        setTabList(_tabList);
        setIsLoading(false);
      });
    } else if (category === config/* Constants.categoryType.CATEGORY_OTHER */.gT.categoryType.CATEGORY_OTHER) {
      var _tagFilters2 = [];

      if (filterCriteriaListOriginal) {
        filterCriteriaListOriginal.forEach(function (item) {
          if (item.selectedList) {
            if (item.selectedList.length > 0) {
              _tagFilters2.push({
                category: item.id,
                tags: item.selectedList
              });
            }
          }
        });
        _tagFilters2 = JSON.stringify(_tagFilters2);
      }

      DAO/* ProfileDao.find */.TR.find({
        keyword: keyword,
        pageIndex: 0,
        pageSize: 1,
        tagFilters: _tagFilters2,
        filterFollowLogic: filterTabSelected,
        range: locationSelectedTemp !== null && locationSelectedTemp !== void 0 && locationSelectedTemp.city_id && (locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.distance) > 0 ? locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.distance : null,
        distanceUnit: locationSelectedTemp !== null && locationSelectedTemp !== void 0 && locationSelectedTemp.city_id ? config/* Constants.distanceUnit.DISTANCE_UNIT_KM */.gT.distanceUnit.DISTANCE_UNIT_KM : null,
        countryId: locationSelectedTemp !== null && locationSelectedTemp !== void 0 && locationSelectedTemp.country_id ? [locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.country_id] : null,
        cityId: locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.city_id,
        categoryType: 6,
        sortType: sortBy,
        isFollowCount: 1
      }).then(function (result) {
        var _tabList = tabList;

        _tabList.forEach(function (item, index) {
          if (item.title === "All") {
            _tabList[index].count = result.totalCount;
          } else if (item.title === "Followed") {
            _tabList[index].count = result.followingCount;
          } else if (item.title === "Other") {
            _tabList[index].count = result.otherCount;
          }
        });

        setTabList(_tabList);
        setIsLoading(false);
      });
    }
  };

  (0,react.useEffect)(function () {// onLoad();
  }, [filterTabSelected]);
  (0,react.useEffect)(function () {
    if (filterCriteriaSelected) {
      if (subFilterModal) {
        subFilterModal.current.showModal();
      }
    }
  }, [filterCriteriaSelected]);
  (0,react.useEffect)(function () {
    if (category) {
      var result = filterCriteriaListOriginal || (category === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE ? venueFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP ? rooftopFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA ? spaFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL ? venueBeachfulFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? prefabCompanyFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES ? prefabHomeFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO ? zooFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? animalFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? parkfulFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO ? casinoFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE ? castleFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT ? resortFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL ? aparthotelFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? venueCocktailFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? eventFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? festivalFilterCriteria(isMobileVersion, filter_styles, isChartsMode) : category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? artistFilterCriteria(isMobileVersion, filter_styles, isChartsMode) : category === config/* Constants.categoryType.CATEGORY_PROMOTERS */.gT.categoryType.CATEGORY_PROMOTERS ? promoterFilterCriteria(isMobileVersion, filter_styles) : category === config/* Constants.categoryType.CATEGORY_OTHER */.gT.categoryType.CATEGORY_OTHER ? otherFilterCriteria(isMobileVersion, filter_styles) : []);
      setFilterCriteriaList(result);
      setFilterCriteriaListOriginal(result);
    }
  }, [category, filterCriteriaListOriginal]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    style: filter_styles.background,
    className: "lg:w-335px sm:w-230px w-full sm:h-auto h-full",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: filter_styles.background,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* StatusBar */.A_, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(components_NavigationView, {
        isMobileVersion: isMobileVersion,
        navigation: props.navigation,
        categoryTitle: category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? "FESTIVALS" : category === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? "EVENTS" : category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? "ARTISTS" : category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP ? "ROOFTOPS" : category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA ? "SPAS" : category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL ? "BEACH CLUBS" : category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? "COMPANIES" : category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES ? "HOMES" : category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO ? "ZOOS" : category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? "ANIMALS" : category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? "PARKS" : category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO ? "CASINOS" : category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE ? "CASTLES" : category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT ? "RESORTS" : category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL ? "APARTHOTELS" : category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? "BARS" : "VENUES",
        onClear: isChartsMode ? null : function () {
          var newData = filterCriteriaList.map(function (row) {
            return _objectSpread(_objectSpread({}, row), {}, {
              selectedList: []
            });
          });
          setFilterCriteriaList(newData);
          setFilterCriteriaSelected(null);
          setShowFilter(false);
          onApply([], newData, []);

          if (setLocationSelectedTemp) {
            setLocationSelectedTemp(null);
          } else {
            setLocationSelected(null);
          }
        },
        onBack: function onBack() {
          return setShowFilter(false);
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: filter_styles.content,
        children: !isLoading && /*#__PURE__*/(0,jsx_runtime.jsx)((ScrollView_default()), {
          children: filterCriteriaList.filter(function (item) {
            return item.isHide === false;
          }).map(function (item, index) {
            var _item$title, _item$selectedList14, _item$selectedList15, _item$selectedList16, _item$selectedList17, _item$selectedList18, _item$selectedList19, _item$selectedList20, _item$selectedList21, _item$selectedList22, _item$selectedList23, _item$selectedList24, _item$selectedList25, _item$selectedList26;

            return item.isLocation ? /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
              style: filter_styles.item,
              onPress: function onPress() {
                return locationModal.current.showModal();
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
                style: filter_styles.itemContent,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
                  style: {
                    flexDirection: "row",
                    alignItems: "center",
                    flex: 1
                  },
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                    source: config/* Images.iconLocationPin */.rU.iconLocationPin,
                    width: isMobileVersion ? 12 : 20,
                    height: isMobileVersion ? 12 : 20,
                    layout: "fixed",
                    alt: "location",
                    className: category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP || category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? "img-drop-shadow" : ""
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                    style: [filter_styles.cityLabel, isMobileVersion ? {
                      fontSize: 12,
                      lineHeight: 12,
                      fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular
                    } : {}],
                    children: item === null || item === void 0 ? void 0 : item.title
                  }), (locationSelectedTemp && ((locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.country_id) || (locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.state_id) || (locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.isWorldWide) || (locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.isVirtual)) || locationSelected && ((locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id) || (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id) || (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.isWorldWide) || (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.isVirtual))) && !isChartsMode && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
                    style: filter_styles.itemCount,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                      style: filter_styles.itemCountText,
                      children: "1"
                    })
                  })]
                }), (locationSelectedTemp && ((locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.country_id) || (locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.state_id) || (locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.isWorldWide) || (locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.isVirtual)) || locationSelected && ((locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.country_id) || (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.state_id) || (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.isWorldWide) || (locationSelected === null || locationSelected === void 0 ? void 0 : locationSelected.isVirtual))) && !isChartsMode && !isMobileVersion && /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
                  style: {
                    paddingVertical: 16,
                    paddingHorizontal: isChartsMode && isMobileVersion ? 0 : 4
                  },
                  onPress: function onPress() {
                    if (!isChartsMode) {
                      if (setLocationSelectedTemp) {
                        setLocationSelectedTemp(null);
                      } else {
                        setLocationSelected(null);
                      }
                    }
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                    source: config/* Images.iconClose */.rU.iconClose,
                    width: 14,
                    height: 14,
                    layout: "fixed",
                    alt: "close"
                  })
                }), isChartsMode && isMobileVersion && /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
                  style: {
                    paddingVertical: 16,
                    paddingHorizontal: isMobileVersion ? 0 : 4
                  },
                  onPress: function onPress() {
                    if (!isChartsMode) {
                      if (setLocationSelectedTemp) {
                        setLocationSelectedTemp(null);
                      } else {
                        setLocationSelected(null);
                      }
                    }
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                    source: config/* Images.iconAngleRight */.rU.iconAngleRight,
                    width: 14,
                    height: 14,
                    layout: "fixed",
                    alt: "close"
                  })
                }), !isChartsMode && isMobileVersion && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
                  style: {
                    width: 12,
                    height: 12
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                    source: config/* Images.iconAngleRight */.rU.iconAngleRight,
                    width: 12,
                    height: 12,
                    layout: "fixed"
                  })
                })]
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)((TouchableOpacity_default()), {
              style: filter_styles.item,
              onPress: function onPress() {
                return setFilterCriteriaSelected(item);
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
                style: filter_styles.itemContent,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                  source: item === null || item === void 0 ? void 0 : item.icon,
                  width: isMobileVersion && (item === null || item === void 0 ? void 0 : item.width) > 0 ? (item === null || item === void 0 ? void 0 : item.width) - 6 : item === null || item === void 0 ? void 0 : item.width,
                  height: isMobileVersion && (item === null || item === void 0 ? void 0 : item.height) > 0 ? (item === null || item === void 0 ? void 0 : item.height) - 6 : item === null || item === void 0 ? void 0 : item.height,
                  layout: "fixed",
                  alt: item === null || item === void 0 ? void 0 : (_item$title = item.title) === null || _item$title === void 0 ? void 0 : _item$title.toLowerCase(),
                  className: category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP || category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? "img-drop-shadow" : ""
                }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                  style: [filter_styles.itemTitle, isMobileVersion ? {
                    fontSize: 12,
                    lineHeight: 12,
                    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular
                  } : []],
                  children: item === null || item === void 0 ? void 0 : item.title
                }), !isChartsMode && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: item.isDate && item !== null && item !== void 0 && (_item$selectedList14 = item.selectedList) !== null && _item$selectedList14 !== void 0 && _item$selectedList14.start || (_item$selectedList15 = item.selectedList) !== null && _item$selectedList15 !== void 0 && _item$selectedList15.isUpcoming || (_item$selectedList16 = item.selectedList) !== null && _item$selectedList16 !== void 0 && _item$selectedList16.isAnytime ? /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
                    style: filter_styles.itemCount,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                      style: filter_styles.itemCountText,
                      children: item !== null && item !== void 0 && (_item$selectedList17 = item.selectedList) !== null && _item$selectedList17 !== void 0 && _item$selectedList17.start ? "".concat(item === null || item === void 0 ? void 0 : (_item$selectedList18 = item.selectedList) === null || _item$selectedList18 === void 0 ? void 0 : _item$selectedList18.start, " - ").concat(item === null || item === void 0 ? void 0 : (_item$selectedList19 = item.selectedList) === null || _item$selectedList19 === void 0 ? void 0 : _item$selectedList19.end) : item !== null && item !== void 0 && (_item$selectedList20 = item.selectedList) !== null && _item$selectedList20 !== void 0 && _item$selectedList20.isUpcoming ? "Upcoming" : "Anytime"
                    })
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (item === null || item === void 0 ? void 0 : (_item$selectedList21 = item.selectedList) === null || _item$selectedList21 === void 0 ? void 0 : _item$selectedList21.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
                      style: filter_styles.itemCount,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                        style: filter_styles.itemCountText,
                        children: item.isPrice ? "".concat((item === null || item === void 0 ? void 0 : item.selectedList[0]) === 0 ? "Free" : "$".concat(item === null || item === void 0 ? void 0 : item.selectedList[0]), " - ", "".concat((item === null || item === void 0 ? void 0 : item.selectedList[1]) === 1000 ? "Max" : "$".concat(item === null || item === void 0 ? void 0 : item.selectedList[1]))) : item.isAge ? "".concat(item === null || item === void 0 ? void 0 : item.selectedList[0], " ").concat(item === null || item === void 0 ? void 0 : item.selectedList[1], " ").concat(item === null || item === void 0 ? void 0 : item.selectedList[2]) : item === null || item === void 0 ? void 0 : (_item$selectedList22 = item.selectedList) === null || _item$selectedList22 === void 0 ? void 0 : _item$selectedList22.length
                      })
                    })
                  })
                })]
              }), !isChartsMode && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: (item.isDate && (item === null || item === void 0 ? void 0 : (_item$selectedList23 = item.selectedList) === null || _item$selectedList23 === void 0 ? void 0 : _item$selectedList23.start) || ((_item$selectedList24 = item.selectedList) === null || _item$selectedList24 === void 0 ? void 0 : _item$selectedList24.isUpcoming) || ((_item$selectedList25 = item.selectedList) === null || _item$selectedList25 === void 0 ? void 0 : _item$selectedList25.isAnytime) || (item === null || item === void 0 ? void 0 : (_item$selectedList26 = item.selectedList) === null || _item$selectedList26 === void 0 ? void 0 : _item$selectedList26.length) > 0) && !isMobileVersion && /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
                  style: {
                    paddingVertical: 16,
                    paddingHorizontal: 4
                  },
                  onPress: function onPress() {
                    var newData = filterCriteriaList.map(function (row) {
                      if (row.title === item.title) {
                        return _objectSpread(_objectSpread({}, row), {}, {
                          selectedList: []
                        });
                      }

                      return row;
                    });
                    setFilterCriteriaList(newData);
                    setFilterCriteriaSelected(null);
                    setShowFilter(false);
                    onApply(newData.filter(function (item) {
                      var _item$selectedList27;

                      return item.isHide === false && ((_item$selectedList27 = item.selectedList) === null || _item$selectedList27 === void 0 ? void 0 : _item$selectedList27.length) > 0;
                    }).flatMap(function (item) {
                      return item.selectedList;
                    }), newData.filter(function (item) {
                      return item.isHide === false;
                    }), tabList[selectedTabIndex]);
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                    source: config/* Images.iconClose */.rU.iconClose,
                    width: 14,
                    height: 14,
                    layout: "fixed"
                  })
                })
              }), isMobileVersion && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
                style: {
                  width: 12,
                  height: 12
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                  source: config/* Images.iconAngleRight */.rU.iconAngleRight,
                  width: 12,
                  height: 12,
                  layout: "fixed"
                })
              })]
            }, index);
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "sm:hidden block",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: filter_styles.footerButton,
          children: [!isChartsMode && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
            style: filter_styles.footerItemLeft,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
              buttonTitle: t("key_button_clear_all"),
              bordered: true,
              style: {
                borderColor: (0,formatHelpers/* getClass */.ll)("border-black")
              },
              borderedTextColor: (0,formatHelpers/* getClass */.ll)("text-white"),
              onPress: function onPress() {
                var newData = filterCriteriaList.map(function (row) {
                  return _objectSpread(_objectSpread({}, row), {}, {
                    selectedList: []
                  });
                });
                setFilterCriteriaList(newData);
                setFilterCriteriaSelected(null);
                setShowFilter(false);
                onApply([], newData, []);
              },
              isMobileVersion: isMobileVersion
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
            style: filter_styles.footerItemRight,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
              buttonTitle: t("key_button_show") // style={{
              //   backgroundColor:
              //     filterCriteriaList.filter(
              //       (item) =>
              //         item.isHide === false && item.selectedList?.length > 0
              //     ).length !== 3
              //       ? Colors.grayText
              //       : Colors.white,
              // }}
              // filledTextColor={
              //   filterCriteriaList.filter(
              //     (item) =>
              //       item.isHide === false && item.selectedList?.length > 0
              //   ).length !== 3
              //     ? Colors.lightGray
              //     : null
              // }
              ,
              filled: true // disabled={
              //   filterCriteriaList.filter(
              //     (item) =>
              //       item.isHide === false && item.selectedList?.length > 0
              //   ).length !== 3
              // }
              ,
              filledColor:  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  true ? config/* Colors.rooftopPink */.wL.rooftopPink : 0,
              filledTextColor:  true ? config/* Colors.white */.wL.white : 0,
              onPress: function onPress() {
                setShowFilter(false);

                if (locationSelectedTemp) {
                  setLocationSelected(locationSelectedTemp);
                }

                onApply(filterCriteriaList.filter(function (item) {
                  var _item$selectedList28;

                  return item.isHide === false && ((_item$selectedList28 = item.selectedList) === null || _item$selectedList28 === void 0 ? void 0 : _item$selectedList28.length) > 0;
                }).flatMap(function (item) {
                  return item.selectedList;
                }), filterCriteriaList.filter(function (item) {
                  return item.isHide === false;
                }), tabList[selectedTabIndex]);
              },
              isMobileVersion: isMobileVersion
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* MultipleCheckModal */.G7, {
        ref: subFilterModal,
        icon: filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.icon,
        iconWidth: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.title) === "Country" ? isMobileVersion ? 19.5 - 6 : 19.5 : (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.title) === "Activity" ? isMobileVersion ? 21 - 6 : 19.5 : (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.title) === "Rating" ? isMobileVersion ? 25 - 6 : 25.5 : null,
        category: category,
        title: filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.title,
        checkedItemIds: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.selectedList) || [],
        isPrice: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.isPrice) || false,
        isAge: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.isAge) || false,
        isDimension: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.isDimension) || false,
        isSearchable: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.isSearchable) || false,
        isDate: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.isDate) || false,
        isLineup: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.isLineup) || false,
        isRangeValue: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.isRangeValue) || false,
        isEventSize: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.isEventSize) || false,
        isCompanyHomeSize: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.isCompanyHomeSize) || false,
        isCountry: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.isCountry) || false,
        isRating: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.isRating) || false,
        isMinimumOneSelect: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.isMinimumOneSelect) || false,
        isSingle: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.isSingle) || false,
        dateType: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.dateType) || false,
        items: (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.detailList) || [],
        onClose: function onClose() {
          setFilterCriteriaSelected(null);

          if (subFilterModal) {
            subFilterModal.current.hideModal();
          }
        },
        buttonTitleClear: isChartsMode ? t("key_close") : null,
        onPressClear: function onPressClear() {
          if (isChartsMode) {
            setFilterCriteriaSelected(null);

            if (subFilterModal) {
              subFilterModal.current.hideModal();
            }
          } else {
            var newData = filterCriteriaList.map(function (item) {
              if (item.title === (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.title)) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  selectedList: []
                });
              }

              return item;
            });
            setFilterCriteriaList(newData);
            setFilterCriteriaSelected(null);

            if (!isMobileVersion) {
              onApply(newData.filter(function (item) {
                var _item$selectedList29;

                return item.isHide === false && ((_item$selectedList29 = item.selectedList) === null || _item$selectedList29 === void 0 ? void 0 : _item$selectedList29.length) > 0;
              }).flatMap(function (item) {
                return item.selectedList;
              }), newData.filter(function (item) {
                return item.isHide === false;
              }), tabList[selectedTabIndex]);
            }

            if (subFilterModal) {
              subFilterModal.current.hideModal();
            }
          }
        },
        onPressItem: function onPressItem(items) {
          var newData = filterCriteriaList.map(function (item) {
            if (item.title === (filterCriteriaSelected === null || filterCriteriaSelected === void 0 ? void 0 : filterCriteriaSelected.title)) {
              return _objectSpread(_objectSpread({}, item), {}, {
                selectedList: items
              });
            }

            return item;
          });
          setFilterCriteriaList(newData);
          setFilterCriteriaSelected(null);

          if (subFilterModal) {
            subFilterModal.current.hideModal();
          }

          onApply(newData.filter(function (item) {
            var _item$selectedList30;

            return item.isHide === false && ((_item$selectedList30 = item.selectedList) === null || _item$selectedList30 === void 0 ? void 0 : _item$selectedList30.length) > 0;
          }).flatMap(function (item) {
            return item.selectedList;
          }), newData.filter(function (item) {
            return item.isHide === false;
          }), tabList[selectedTabIndex]);
        },
        isMobileVersion: isMobileVersion
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* LocationModal */.F8, {
      ref: locationModal,
      category: category,
      locationSelected: locationSelectedTemp,
      distanceValue: locationSelectedTemp === null || locationSelectedTemp === void 0 ? void 0 : locationSelectedTemp.distance,
      isDistance: true,
      isCountryOnly: isChartsMode,
      isShowState: !isChartsMode,
      onPressApply: function onPressApply(location, distance) {
        router.replace({
          query: _objectSpread(_objectSpread({}, router.query), {}, {
            page: 1
          })
        });

        if (setLocationSelectedTemp) {
          setLocationSelectedTemp(_objectSpread(_objectSpread({}, location), {}, {
            distance: distance
          }));
        } else {
          setLocationSelected(_objectSpread(_objectSpread({}, location), {}, {
            distance: distance
          }));
        }

        if (locationModal) {
          locationModal.current.hideModal();
        }
      },
      onPressCancel: function onPressCancel() {
        if (locationModal) {
          locationModal.current.hideModal();
        }
      },
      isMobileVersion: isMobileVersion
    })]
  });
};

var filter_styles = StyleSheet_default().create({
  background: {
    flex: 1,
    backgroundColor: (0,formatHelpers/* getClass */.ll)("background"),
    overflow: "auto",
    height: "100%"
  },
  container: {
    flex: 1,
    alignItems: "center"
  },
  content: {
    flex: 1,
    padding: 16
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    marginRight: 4
  },
  icon: {
    width: 16,
    height: 16,
    resizeMode: "contain",
    marginRight: 6
  },
  item: {
    backgroundColor: (0,formatHelpers/* getClass */.ll)("bg-gray1"),
    borderRadius: 50,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingVertical: 12,
    paddingHorizontal: 18,
    marginBottom: 8,
    height: 40
  },
  itemContent: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center"
  },
  itemTitle: {
    fontFamily: config/* Fonts.primarySemiBold */.F3.primarySemiBold,
    color: config/* Colors.white */.wL.white,
    fontSize: 14,
    lineHeight: 14,
    marginLeft: 8
  },
  cityLabel: {
    color: config/* Colors.white */.wL.white,
    fontSize: 14,
    lineHeight: 14,
    marginLeft: 6,
    fontFamily: config/* Fonts.primarySemiBold */.F3.primarySemiBold
  },
  countryLabel: {
    color: config/* Colors.placeholder */.wL.placeholder,
    fontSize: 14,
    lineHeight: 14,
    marginLeft: 4,
    fontFamily: config/* Fonts.primarySemiBold */.F3.primarySemiBold
  },
  itemCount: {
    backgroundColor: config/* Colors.tabBottomColor */.wL.tabBottomColor,
    borderRadius: 50,
    paddingHorizontal: 8,
    paddingVertical: 3,
    marginLeft: 12
  },
  itemCountText: {
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.white */.wL.white,
    fontSize: 12,
    lineHeight: 12
  },
  gap: {
    height: 40
  },
  footerButton: {
    backgroundColor: (0,formatHelpers/* getClass */.ll)("background"),
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    flexDirection: "row",
    alignItems: "center",
    padding: 16
  },
  footerItemLeft: {
    flex: 0.6,
    paddingRight: 16
  },
  footerItemRight: {
    flex: 1
  }
});
/* harmony default export */ var filter = (FilterScreen);

/***/ })

}]);